import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.string.trim-start.js";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/library/components/context-providers/cart/CartContext.ts
import { createContext } from "react";
var CartQueryMutationKey = /* @__PURE__ */(CartQueryMutationKey2 => {
  CartQueryMutationKey2["addLineItem"] = "addLineItem";
  CartQueryMutationKey2["removeLineItem"] = "removeLineItem";
  CartQueryMutationKey2["updateLineItem"] = "updateLineItem";
  CartQueryMutationKey2["createCart"] = "createCart";
  CartQueryMutationKey2["deleteCart"] = "deleteCart";
  CartQueryMutationKey2["recalculateCart"] = "recalculateCart";
  CartQueryMutationKey2["addCoupon"] = "addCoupon";
  CartQueryMutationKey2["removeCoupon"] = "removeCoupon";
  CartQueryMutationKey2["duplicateLineItem"] = "duplicateLineItem";
  CartQueryMutationKey2["getCart"] = "getCart";
  CartQueryMutationKey2["addQuoteToCart"] = "addQuoteToCart";
  CartQueryMutationKey2["setReferenceLabel"] = "setReferenceLabel";
  CartQueryMutationKey2["setPurchaseorderNumber"] = "setPurchaseorderNumber";
  CartQueryMutationKey2["reOrderLineItems"] = "reOrderLineItems";
  CartQueryMutationKey2["setPaymentMethod"] = "setPaymentMethod";
  CartQueryMutationKey2["getShippingOptions"] = "getShippingOptions";
  CartQueryMutationKey2["placeOrder"] = "placeOrder";
  CartQueryMutationKey2["editLineItem"] = "editLineItem";
  CartQueryMutationKey2["changeDeliveryOption"] = "changeDeliveryOption";
  CartQueryMutationKey2["setPickupPoint"] = "setPickupPoint";
  CartQueryMutationKey2["setShippingAddress"] = "setShippingAddress";
  CartQueryMutationKey2["setSplitShipment"] = "setSplitShipment";
  CartQueryMutationKey2["setBillingAddress"] = "setBillingAddress";
  return CartQueryMutationKey2;
})(CartQueryMutationKey || {});
var defaultValue = {
  cartId: void 0,
  cart: void 0,
  setCartId() {},
  invalidateCart() {},
  setCartData() {},
  locallyRemoveCart() {},
  errors: /* @__PURE__ */new Map(),
  addError() {},
  removeError() {},
  removeAllErrors() {},
  notifications: /* @__PURE__ */new Map(),
  addNotification() {},
  removeNotification() {},
  resetNotifications() {},
  expiredQuotesError: void 0
};
var CartContext = createContext(defaultValue);
var CartContext_default = CartContext;

// src/library/components/order/context-provider/OrderContext.ts
var OrderQueryMutationKey = /* @__PURE__ */(OrderQueryMutationKey2 => {
  OrderQueryMutationKey2["patchOrder"] = "patchOrder";
  OrderQueryMutationKey2["orderSetPoNumber"] = "orderSetPoNumber";
  OrderQueryMutationKey2["orderSetReference"] = "orderSetReference";
  OrderQueryMutationKey2["getOrder"] = "getOrder";
  OrderQueryMutationKey2["patchLineItem"] = "patchLineItem";
  return OrderQueryMutationKey2;
})(OrderQueryMutationKey || {});

// src/library/hooks/cart/useCart.ts
import { useContext } from "react";
function useCart() {
  const cartContext = useContext(CartContext_default);
  if (!cartContext.queries) {
    throw new Error("Cannot use cart hook when cart queries have not been provided. Make sure the application is wrapped in a CartProvider.");
  }
  return cartContext;
}

// src/library/queries/line-item/useRemoveLineItemMutation.ts
import { useMutation } from "@tanstack/react-query";

// src/library/http-clients/ShoppingCartHttpClient.ts
import { preventCartVersionMismatch } from "@printdeal/checkout-shared/dist/frontend";
import axios from "axios";
import { getFeatureManagementUserId } from "@printdeal/feature-management/react";
import { configurationProvider } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor } from "@printdeal/authentication";
var ShoppingCartHttpClient = class {
  get client() {
    var _a;
    if (!this.httpClient) {
      const baseURL = configurationProvider.getValue("ECOMMERCE_CART_API_BASE_URL");
      this.httpClient = axios.create({
        baseURL,
        headers: {
          "Feature-Management-User-Id": (_a = getFeatureManagementUserId()) != null ? _a : ""
        }
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor);
    }
    return this.httpClient;
  }
  getCart(cartId) {
    return __async(this, null, function* () {
      return this.client.get("/cart/".concat(cartId));
    });
  }
  removeLineItem(cartId, data) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.delete("/cart/".concat(cartId, "/lineitems/").concat(data.lineItemId)));
    });
  }
  updateLineItem(_0, _1) {
    return __async(this, arguments, function (cartId, _ref) {
      var _this = this;
      let {
        payload,
        lineItemId
      } = _ref;
      return function* () {
        return preventCartVersionMismatch(() => _this.client.patch("cart/".concat(cartId, "/lineitems/").concat(lineItemId), payload));
      }();
    });
  }
  patchCart(cartId, payload) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.patch("/cart/".concat(cartId), payload));
    });
  }
  deleteCart(cartId) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.delete("/cart/".concat(cartId)));
    });
  }
  addLineItem(cartId, payload) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.post("/cart/".concat(cartId, "/lineitems"), payload));
    });
  }
  createCart() {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.post("/cart"));
    });
  }
  getTimedDeliveries(cartId, lineItemId) {
    return __async(this, null, function* () {
      return this.client.get("/cart/".concat(cartId, "/lineitems/").concat(lineItemId, "/timed-deliveries"));
    });
  }
  addQuoteLineItem(cartId, payload) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.post("/cart/".concat(cartId, "/lineitems/quotes"), payload));
    });
  }
  placeOrder(cartId) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.post("/cart/".concat(cartId, "/order")));
    });
  }
  getLineItemOptions(cartId, lineItemId) {
    return __async(this, null, function* () {
      return this.client.get("/cart/".concat(cartId, "/lineitems/").concat(lineItemId, "/options"));
    });
  }
  searchPickupPoints(cartId, lineItemId, payload) {
    return __async(this, null, function* () {
      return this.client.post("/cart/".concat(cartId, "/lineitems/").concat(lineItemId, "/search-pickup-points"), payload);
    });
  }
};
var shoppingCartHttpClient = new ShoppingCartHttpClient();
var ShoppingCartHttpClient_default = shoppingCartHttpClient;

// src/library/queries/line-item/useRemoveLineItemMutation.ts
function useRemoveLineItemMutation(_ref2) {
  let {
    onSuccess,
    onError
  } = _ref2;
  const {
    cartId,
    invalidateCart
  } = useCart();
  const mutationKey = "removeLineItem" /* removeLineItem */;
  return useMutation({
    mutationKey: [mutationKey],
    mutationFn: _0 => __async(this, [_0], function (_ref3) {
      let {
        lineItemId
      } = _ref3;
      return function* () {
        if (!cartId) {
          throw new Error("Cannot remove line item without cart id");
        }
        if (!lineItemId) {
          throw new Error("Cannot remove line item without line item id");
        }
        const {
          data
        } = yield ShoppingCartHttpClient_default.removeLineItem(cartId, {
          lineItemId
        });
        return data;
      }();
    }),
    retry: false,
    onSuccess: data => {
      invalidateCart();
      if (typeof onSuccess === "function") {
        onSuccess(data, mutationKey);
      }
    },
    onError: error => {
      if (typeof onError === "function") {
        onError(error, mutationKey);
      }
    }
  });
}

// src/library/queries/line-item/useAddLineItemMutation.ts
import { useMutation as useMutation3 } from "@tanstack/react-query";
import { addDataLayerEntry } from "@printdeal/data-layer-manager";
import { ErrorManagement } from "@printdeal/error-management/react";

// src/library/queries/cart/useCreateCartMutation.ts
import { useMutation as useMutation2 } from "@tanstack/react-query";
function useCreateCartMutation() {
  let {
    onSuccess,
    onError
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    setCartData
  } = useCart();
  const mutationKey = "createCart" /* createCart */;
  return useMutation2({
    mutationKey: [mutationKey],
    mutationFn: () => __async(this, null, function* () {
      const {
        data
      } = yield ShoppingCartHttpClient_default.createCart();
      return data;
    }),
    retry: false,
    onSuccess: data => {
      setCartData(data);
      if (typeof onSuccess === "function") {
        onSuccess(data, mutationKey);
      }
    },
    onError: error => {
      if (typeof onError === "function") {
        onError(error, mutationKey);
      }
    }
  });
}

// src/library/queries/line-item/useAddLineItemMutation.ts
function useAddLineItemMutation() {
  let {
    onSuccess,
    onError
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    cartId,
    setCartData,
    cart
  } = useCart();
  const createCartMutation = useCreateCartMutation({
    onError
  });
  const mutationKey = "addLineItem" /* addLineItem */;
  return useMutation3({
    mutationKey: [mutationKey],
    mutationFn: payload => __async(this, null, function* () {
      payload.lineItems.forEach(lineItem => {
        if (!lineItem.product.userSelection["Delivery Type"]) {
          ErrorManagement.exception({
            exception: "Attempting to add line item to cart without Delivery Type attribute",
            tags: {
              fileLocation: "AddLineItemHelper",
              featureFunction: "buildLineItemShape"
            },
            fingerprint: ["missing-delivery-type"]
          });
        }
      });
      cart == null ? void 0 : cart.lineItems.forEach(lineItem => {
        var _a2, _b, _c, _d, _e;
        if (((_b = (_a2 = lineItem.custom) == null ? void 0 : _a2.fields.mcpDocumentsSource) == null ? void 0 : _b.length) && ((_e = (_d = (_c = payload.lineItems[0].files) == null ? void 0 : _c.mcp) == null ? void 0 : _d.mcpDocumentsSource) == null ? void 0 : _e.length) && lineItem.custom.fields.mcpDocumentsSource[0] === payload.lineItems[0].files.mcp.mcpDocumentsSource[0]) {
          ErrorManagement.exception({
            exception: "Attempting to add line item to cart that matches the doc ref of an existing cart line item",
            tags: {
              fileLocation: "AddLineItemHelper",
              featureFunction: "buildLineItemShape"
            },
            fingerprint: ["add-to-cart-duplicate-line-item"]
          });
        }
      });
      let newCartId = cartId;
      if (!newCartId) {
        const newCart = yield createCartMutation.mutateAsync();
        newCartId = newCart.id;
      }
      const _a = payload,
        {
          dataLayer
        } = _a,
        requestBody = __objRest(_a, ["dataLayer"]);
      const {
        data
      } = yield ShoppingCartHttpClient_default.addLineItem(newCartId, requestBody);
      return data;
    }),
    retry: 1,
    onSuccess: (newCart, payload) => {
      setCartData(newCart);
      if (typeof onSuccess === "function") {
        onSuccess(newCart, mutationKey);
      }
      if (!payload.dataLayer) {
        return;
      }
      addDataLayerEntry("add_to_cart", {
        items: [{
          item_id: payload.dataLayer.productPage.parentProduct.key,
          item_name: payload.dataLayer.productPage.parentProduct.productName,
          variant_id: payload.dataLayer.productPage.variant.sku,
          variant_name: payload.dataLayer.productPage.productNameOriginal || payload.dataLayer.productPage.productName,
          contentfulId: payload.dataLayer.productPage.contentful_id,
          price: Number((payload.dataLayer.price.centAmount / 100).toFixed(2)),
          currency: payload.dataLayer.price.currencyCode
        }],
        cartId,
        lineItemIds: newCart.lineItems.map(lineItem => lineItem.id)
      });
    },
    onError: error => {
      if (typeof onError === "function") {
        onError(error, mutationKey);
      }
    }
  });
}

// src/library/views/CartView.tsx
import { Alert as Alert5, Button as Button6, Container, Panel as Panel7 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage23, useIntl as useIntl10 } from "react-intl";
import { getMainLineItems as getMainLineItems3 } from "@printdeal/checkout-shared";
import { useAuthentication as useAuthentication8 } from "@printdeal/authentication";
import React36, { useContext as useContext9, useEffect as useEffect14 } from "react";
import { addDataLayerEntry as addDataLayerEntry8 } from "@printdeal/data-layer-manager";
import { StoreToggle as StoreToggle2 } from "@printdeal/feature-management/react";
import { usePrefetchAddresses } from "@printdeal/address-frontend";

// src/library/components/cart/CartQuery.tsx
import React4 from "react";
import { FormattedMessage as FormattedMessage2, useIntl as useIntl2 } from "react-intl";
import { Heading, Panel, Spinner } from "@printdeal/ui-library";
import { getMainLineItems } from "@printdeal/checkout-shared";
import { useAuthentication } from "@printdeal/authentication";

// src/library/queries/cart/useGetCartQuery.ts
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
function useGetCartQuery() {
  let {
    enabled
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    cartId,
    setCartData
  } = useCart();
  const queryKey = "getCart" /* getCart */;
  const getCartQuery = useQuery({
    queryKey: [queryKey, cartId],
    queryFn: () => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cannot get cart without a cart id");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.getCart(cartId);
      return data;
    }),
    retry: false,
    enabled
  });
  useEffect(() => {
    if (getCartQuery.status === "success") {
      setCartData(getCartQuery.data);
    }
  }, [getCartQuery.data, getCartQuery.status, setCartData]);
  return getCartQuery;
}

// src/library/components/cart/error-handling/CartErrorNotifications.tsx
import { defineMessages, useIntl } from "react-intl";
import React3, { useEffect as useEffect3 } from "react";

// src/library/hooks/error/useError.ts
import { useContext as useContext2 } from "react";
function useError() {
  const cartContext = useContext2(CartContext_default);
  return cartContext;
}

// src/library/components/design-system/error-handling/ErrorAlert.tsx
import React2 from "react";
import { FormattedMessage } from "react-intl";
import useDeepCompareEffect from "use-deep-compare-effect";
import { implementationProvider } from "@printdeal/configuration";
import { ErrorManagement as ErrorManagement2 } from "@printdeal/error-management/react";
import { Alert } from "@printdeal/ui-library";

// src/library/components/design-system/scrolling/ScrollIntoView.tsx
import React, { useEffect as useEffect2, useRef } from "react";
var ScrollIntoView = _ref4 => {
  let {
    children,
    scrollIntoView = true,
    scrollIntoViewTrigger,
    scrollIntoViewOptions = {
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    },
    onUnmount
  } = _ref4;
  const ref = useRef(null);
  useEffect2(() => {
    var _a;
    if (scrollIntoView && typeof ((_a = ref.current) == null ? void 0 : _a.scrollIntoView) === "function") {
      ref.current.scrollIntoView(scrollIntoViewOptions);
    }
  }, [scrollIntoView, scrollIntoViewOptions, scrollIntoViewTrigger]);
  useEffect2(() => () => {
    if (onUnmount) {
      onUnmount();
    }
  }, [onUnmount]);
  return /* @__PURE__ */React.createElement("div", {
    ref
  }, children);
};
var ScrollIntoView_default = ScrollIntoView;

// src/library/components/design-system/error-handling/ErrorAlert.tsx
var ErrorAlert = _ref5 => {
  let {
    children,
    scrollIntoView = true,
    scrollIntoViewTrigger,
    className,
    sentryException
  } = _ref5;
  useDeepCompareEffect(() => {
    if (sentryException) {
      if (Array.isArray(sentryException)) {
        sentryException.forEach(exception => {
          ErrorManagement2.exception({
            exception: exception.e,
            tags: exception.tags,
            fingerprint: exception.fingerPrint
          });
        });
      } else {
        ErrorManagement2.exception({
          exception: sentryException.e,
          tags: sentryException.tags,
          fingerprint: sentryException.fingerPrint
        });
      }
    }
  }, [
  // Use {} as fallback value so that useDeepCompareEffect will not crash on a null value.
  sentryException || {}]);
  return /* @__PURE__ */React2.createElement(ScrollIntoView_default, {
    scrollIntoView,
    scrollIntoViewTrigger
  }, /* @__PURE__ */React2.createElement(Alert, {
    variant: "error",
    className: "".concat(className, " pd-mb-3")
  }, children || /* @__PURE__ */React2.createElement(FormattedMessage, {
    id: "checkout.generic.error",
    defaultMessage: "An error occurred."
  })), /* @__PURE__ */React2.createElement(implementationProvider.customerCareComponent, {
    showDebugId: Boolean(sentryException)
  }));
};
var ErrorAlert_default = ErrorAlert;

// src/library/components/cart/error-handling/CartErrorNotifications.tsx
var errorMessages = defineMessages({
  ["removeLineItem" /* removeLineItem */]: {
    id: "checkout.errorMessage.errorWhileRemovingLineItem",
    defaultMessage: "Something went wrong when trying to remove the product."
  },
  ["deleteCart" /* deleteCart */]: {
    id: "checkout.errorMessage.errorWhileDeletingCart",
    defaultMessage: "Something went wrong when trying to delete the cart."
  },
  ["addCoupon" /* addCoupon */]: {
    id: "checkout.errorMessage.errorWhileAddingCoupon",
    defaultMessage: "Something went wrong when trying to add the coupon to the cart."
  },
  ["removeCoupon" /* removeCoupon */]: {
    id: "checkout.errorMessage.errorWhileRemovingCoupon",
    defaultMessage: "Something went wrong when trying to remove the coupon to the cart."
  },
  ["addLineItem" /* addLineItem */]: {
    id: "checkout.errorMessage.errorWhileAddingLineItem",
    defaultMessage: "Something went wrong when trying to add the product to the cart."
  },
  ["updateLineItem" /* updateLineItem */]: {
    id: "checkout.errorMessage.errorWhileUpdatingLineItem",
    defaultMessage: "Something went wrong when trying to update the line item."
  },
  ["createCart" /* createCart */]: {
    id: "checkout.errorMessage.errorWhileCreatingCart",
    defaultMessage: "Something went wrong when trying to create the cart."
  },
  ["recalculateCart" /* recalculateCart */]: {
    id: "checkout.errorMessage.errorWhileRecalculatingCart",
    defaultMessage: "Something went wrong when trying to recalculate the cart."
  },
  ["duplicateLineItem" /* duplicateLineItem */]: {
    id: "checkout.errorMessage.errorWhileDuplicatingLineItem",
    defaultMessage: "Something went wrong when trying to duplicate the product."
  },
  ["getCart" /* getCart */]: {
    id: "checkout.errorMessage.errorWhileGettingCart",
    defaultMessage: "Something went wrong when trying to get the cart."
  },
  ["addQuoteToCart" /* addQuoteToCart */]: {
    id: "checkout.errorMessage.errorWhileAddingQuoteToCart",
    defaultMessage: "Something went wrong when trying to add the quote to the cart."
  },
  ["setPurchaseorderNumber" /* setPurchaseorderNumber */]: {
    id: "checkout.errorMessage.errorSetPurchaseOrderNumber",
    defaultMessage: "Something went wrong when trying to set or to update the purchase order number to the cart."
  },
  ["setReferenceLabel" /* setReferenceLabel */]: {
    id: "checkout.errorMessage.errorSetReferenceLabel",
    defaultMessage: "Something went wrong when trying to set or to update the reference label to the cart."
  },
  ["reOrderLineItems" /* reOrderLineItems */]: {
    id: "checkout.errorMessage.errorWhileReOrderingLineItems",
    defaultMessage: "Something went wrong when trying to re-order the line items."
  },
  ["setPaymentMethod" /* setPaymentMethod */]: {
    id: "checkout.errorMessage.errorWhileSettingPaymentMethod",
    defaultMessage: "Something went wrong when trying to set the payment method."
  },
  ["getShippingOptions" /* getShippingOptions */]: {
    id: "checkout.errorMessage.errorWhileGettingShippingOptions",
    defaultMessage: "Something went wrong when trying to get the shipping options."
  },
  ["placeOrder" /* placeOrder */]: {
    id: "checkout.errorMessage.errorWhilePlacingOrder",
    defaultMessage: "Something went wrong when trying to place the order."
  },
  ["editLineItem" /* editLineItem */]: {
    id: "checkout.errorMessage.errorWhileEditingLineItem",
    defaultMessage: "Something went wrong when trying to edit the line item."
  },
  ["changeDeliveryOption" /* changeDeliveryOption */]: {
    id: "checkout.errorMessage.errorWhileChangingDeliveryOption",
    defaultMessage: "Something went wrong when trying to change the delivery option."
  },
  ["setPickupPoint" /* setPickupPoint */]: {
    id: "checkout.errorMessage.errorWhileSettingPickupPoint",
    defaultMessage: "Something went wrong when trying to set the pickup point."
  },
  ["setShippingAddress" /* setShippingAddress */]: {
    id: "checkout.errorMessage.errorWhileSettingShippingAddress",
    defaultMessage: "Something went wrong when trying to set the shipping address."
  },
  ["setSplitShipment" /* setSplitShipment */]: {
    id: "checkout.errorMessage.errorWhileSettingSplitShipment",
    defaultMessage: "Something went wrong when trying to set the split shipment."
  },
  ["setBillingAddress" /* setBillingAddress */]: {
    id: "checkout.errorMessage.errorWhileSettingBillingAddress",
    defaultMessage: "Something went wrong when trying to set the billing address."
  }
});
var CartErrorNotifications = _ref6 => {
  let {
    fileLocation
  } = _ref6;
  const intl = useIntl();
  const {
    errors: errorsMap,
    removeAllErrors
  } = useError();
  const errors = Array.from(errorsMap, _ref7 => {
    let [key, value] = _ref7;
    return {
      key,
      value
    };
  });
  useEffect3(() => () => {
    if (errors.length > 0) {
      removeAllErrors();
    }
  }, [errors.length, removeAllErrors]);
  const sentryExceptions = errors.map(errorObject => ({
    e: errorObject.value.error,
    tags: {
      fileLocation,
      featureFunction: errorObject.key
    },
    fingerPrint: ["".concat(fileLocation, "-").concat(errorObject.key.toLowerCase(), "-error}")]
  }));
  return errors.length > 0 && /* @__PURE__ */React3.createElement(ErrorAlert_default, {
    className: "pd-mb-4",
    sentryException: sentryExceptions
  }, errors.map(errorObject => /* @__PURE__ */React3.createElement("div", null, intl.formatMessage(errorMessages[errorObject.key]))));
};
var CartErrorNotifications_default = CartErrorNotifications;

// src/library/components/cart/CartQuery.tsx
var CartQuery = _ref8 => {
  let {
    children
  } = _ref8;
  const intl = useIntl2();
  const cartQuery = useGetCartQuery();
  const {
    isUserLoggedIn
  } = useAuthentication();
  const loadingMessage = intl.formatMessage({
    id: "checkout.spinnerLabel.loadingCart",
    defaultMessage: "Loading your cart"
  });
  if (cartQuery.isLoading) {
    return /* @__PURE__ */React4.createElement("div", {
      className: "pd-flex pd-justify-center"
    }, /* @__PURE__ */React4.createElement("div", {
      className: "pd-flex pd-flex-col pd-items-center pd-py-32"
    }, /* @__PURE__ */React4.createElement(Spinner, {
      size: "lg",
      screenReaderLabel: loadingMessage
    }), /* @__PURE__ */React4.createElement(Heading, {
      as: "h3",
      className: "pd-mt-4"
    }, loadingMessage)));
  }
  if (!cartQuery.data || getMainLineItems(cartQuery.data).length === 0) {
    return /* @__PURE__ */React4.createElement(Panel, null, isUserLoggedIn ? /* @__PURE__ */React4.createElement(FormattedMessage2, {
      id: "checkout.emptyCart",
      defaultMessage: "Your shopping cart is empty."
    }) : /* @__PURE__ */React4.createElement(FormattedMessage2, {
      id: "checkout.emptyCart.notLoggedIn",
      defaultMessage: "Your shopping cart is empty. Did you recently add products to your cart? Log in to view them."
    }));
  }
  if (cartQuery.isError) {
    return /* @__PURE__ */React4.createElement(ErrorAlert_default, {
      sentryException: {
        e: cartQuery.error,
        tags: {
          fileLocation: "CartQuery.tsx",
          featureFunction: "cartQuery"
        },
        fingerPrint: ["checkout-frontend", "cart-query"]
      }
    }, /* @__PURE__ */React4.createElement(FormattedMessage2, __spreadValues({}, errorMessages.getCart)));
  }
  return /* @__PURE__ */React4.createElement("div", null, children(cartQuery.data));
};
var CartQuery_default = CartQuery;

// src/library/components/design-system/checkout/CheckoutSummary.tsx
import { Brand as Brand2, Link as Link2, Panel as Panel2, Heading as Heading2 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage5, useIntl as useIntl4 } from "react-intl";
import React8, { useContext as useContext3 } from "react";
import { StoreToggle, Experiment } from "@printdeal/feature-management/react";

// src/library/components/design-system/money/Money.tsx
import React5 from "react";
import { FormattedNumber } from "react-intl";
var Money = _a => {
  var _b = _a,
    {
      value,
      currency = "EUR",
      style = "currency"
    } = _b,
    rest = __objRest(_b, ["value", "currency", "style"]);
  return /* @__PURE__ */React5.createElement(FormattedNumber, __spreadValues({
    value: value / 100,
    currency,
    style,
    currencyDisplay: "symbol"
  }, rest));
};
var Money_default = Money;

// src/library/components/context-providers/checkout-view/CheckoutViewContext.ts
import { useLocation } from "@gatsbyjs/reach-router";
import { createContext as createContext2 } from "react";
var defaultSystemPage = {
  page: "",
  path: "",
  title: ""
};
var defaultValue2 = {
  navigate: (path, options) => __async(void 0, null, function* () {
    console.warn("CheckoutViewContext.navigate() not implemented. More details:\n".concat(JSON.stringify({
      path,
      options
    }, null, 2)), {
      path,
      options
    });
    yield Promise.resolve();
  }),
  useLocation: () => useLocation(),
  paths: {
    cartPage: defaultSystemPage,
    deliveryPage: defaultSystemPage,
    paymentMethodPage: defaultSystemPage,
    thanksForOrderPage: defaultSystemPage,
    accountDashboardPage: defaultSystemPage,
    loginPage: defaultSystemPage
  },
  location: void 0,
  kiyohScore: void 0
};
var CheckoutViewContext = createContext2(defaultValue2);
var CheckoutViewContext_default = CheckoutViewContext;

// src/library/components/design-system/checkout/DiscountSummary.tsx
import { FormattedMessage as FormattedMessage3 } from "react-intl";
import React6 from "react";
var DiscountSummary = _ref9 => {
  let {
    entityTotal
  } = _ref9;
  var _a, _b, _c, _d, _e, _f;
  return /* @__PURE__ */React6.createElement("div", {
    className: "pd-flex pd-flex-col pd-gap-2"
  }, ((_a = entityTotal == null ? void 0 : entityTotal.discounts) == null ? void 0 : _a.reseller) && /* @__PURE__ */React6.createElement("div", {
    key: "reseller-discount",
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React6.createElement("span", null, /* @__PURE__ */React6.createElement(FormattedMessage3, {
    id: "discountPlatformDiscount.reseller",
    defaultMessage: "Reseller Discount"
  })), /* @__PURE__ */React6.createElement(Money_default, {
    value: -entityTotal.discounts.reseller.totalNet.centAmount,
    currency: entityTotal.discounts.reseller.totalNet.currencyCode
  })), ((_c = (_b = entityTotal == null ? void 0 : entityTotal.discounts) == null ? void 0 : _b.product) == null ? void 0 : _c.totalNet.centAmount) && entityTotal.discounts.product.totalNet.centAmount > 0 && /* @__PURE__ */React6.createElement("div", {
    key: "product-discount",
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React6.createElement("span", null, /* @__PURE__ */React6.createElement(FormattedMessage3, {
    id: "discountPlatformDiscount.product",
    defaultMessage: "Product Discount"
  })), /* @__PURE__ */React6.createElement(Money_default, {
    value: -entityTotal.discounts.product.totalNet.centAmount,
    currency: entityTotal.discounts.product.totalNet.currencyCode
  })), ((_e = (_d = entityTotal == null ? void 0 : entityTotal.discounts) == null ? void 0 : _d.unCategorized) == null ? void 0 : _e.totalNet.centAmount) && entityTotal.discounts.unCategorized.totalNet.centAmount > 0 && /* @__PURE__ */React6.createElement("div", {
    key: "remaining-discount",
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React6.createElement("span", null, /* @__PURE__ */React6.createElement(FormattedMessage3, {
    id: "discountPlatformDiscount.remainingDiscount",
    defaultMessage: "Discount"
  })), /* @__PURE__ */React6.createElement(Money_default, {
    value: -entityTotal.discounts.unCategorized.totalNet.centAmount,
    currency: entityTotal.discounts.unCategorized.totalNet.currencyCode
  })), ((_f = entityTotal == null ? void 0 : entityTotal.customerDiscount) == null ? void 0 : _f.totalNet.centAmount) && entityTotal.customerDiscount.totalNet.centAmount < 0 && /* @__PURE__ */React6.createElement("div", {
    key: "customer-discount",
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React6.createElement("span", null, /* @__PURE__ */React6.createElement(FormattedMessage3, {
    id: "checkout.customerDiscountPrice",
    defaultMessage: "Customer Discount"
  }), ":"), /* @__PURE__ */React6.createElement(Money_default, {
    value: entityTotal.customerDiscount.totalNet.centAmount,
    currency: entityTotal.customerDiscount.totalNet.currencyCode
  })), (entityTotal == null ? void 0 : entityTotal.couponCodes) && entityTotal.couponCodes.length > 0 && entityTotal.couponCodes.map(couponCode => /* @__PURE__ */React6.createElement("div", {
    key: "coupon-".concat(couponCode.code),
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React6.createElement("span", null, /* @__PURE__ */React6.createElement(FormattedMessage3, {
    id: "checkout.couponCodeLabel",
    defaultMessage: "Coupon code"
  }), " ", "(", couponCode.code, "):"), /* @__PURE__ */React6.createElement(Money_default, {
    value: -couponCode.centAmount,
    currency: couponCode.currencyCode
  }))));
};
var DiscountSummary_default = DiscountSummary;

// src/library/components/design-system/checkout/CheckoutTrustpilot.tsx
import React7 from "react";
import clsx from "clsx";
import { addDataLayerEntry as addDataLayerEntry2 } from "@printdeal/data-layer-manager";
import { Brand, Link } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage4, useIntl as useIntl3 } from "react-intl";
var CheckoutTrustpilot = _ref10 => {
  let {
    className
  } = _ref10;
  const intl = useIntl3();
  return /* @__PURE__ */React7.createElement(Link, {
    href: "https://nl.trustpilot.com/review/www.drukwerkdeal.nl",
    variant: "secondary",
    className: clsx("pd-flex pd-justify-center pd-whitespace-nowrap pd-text-sm pd-font-normal", className),
    onClick: () => addDataLayerEntry2("trustpilot_click", {
      contentType: "checkout_summary_cart_page",
      locale: intl.locale
    }),
    target: "_blank"
  }, /* @__PURE__ */React7.createElement(FormattedMessage4, {
    id: "checkout.trustpilot.score.reviewAmount",
    defaultMessage: "<strong>4.5</strong> out of 5 | 6487 reviews",
    values: {
      // eslint-disable-next-line react/no-unstable-nested-components
      strong: chunks => /* @__PURE__ */React7.createElement("strong", null, chunks)
    }
  }), /* @__PURE__ */React7.createElement(Brand, {
    brand: "trustpilot",
    className: "pd-h-5"
  }));
};
var CheckoutTrustpilot_default = CheckoutTrustpilot;

// src/library/hooks/calculations/useEntityTotals.ts
import { cartOrOrderTotals, lineItemPrices } from "@printdeal/checkout-shared";
import { useEffect as useEffect4, useState } from "react";
function useEntityTotals(_ref11) {
  let {
    entity
  } = _ref11;
  const [entityTotal, setEntityTotal] = useState(void 0);
  const [lineItemsTotal, setLineItemsTotal] = useState(void 0);
  useEffect4(() => {
    if (entity) {
      setEntityTotal(cartOrOrderTotals({
        cartOrOrder: entity,
        discountTags: ["product", "reseller", "endUser"]
      }));
      const lineTotals = /* @__PURE__ */new Map();
      entity.lineItems.forEach(lineItem => {
        lineTotals.set(lineItem.id, lineItemPrices({
          lineItemId: lineItem.id,
          cartOrOrder: entity,
          discountTags: ["product", "reseller", "endUser"]
        }));
      });
      setLineItemsTotal(lineTotals);
    }
  }, [entity]);
  return {
    entityTotal,
    lineItemsTotal
  };
}

// src/library/components/design-system/checkout/CheckoutSummary.tsx
var CheckoutSummary = _ref12 => {
  let {
    nextStepButton,
    isKiyohEnabled = false
  } = _ref12;
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const {
    locale
  } = useIntl4();
  const {
    kiyohScore
  } = useContext3(CheckoutViewContext_default);
  const {
    cart
  } = useCart();
  const {
    entityTotal
  } = useEntityTotals({
    entity: cart
  });
  const last12MonthAverageRating = kiyohScore == null ? void 0 : kiyohScore.last12MonthAverageRating;
  const last12MonthNumberReviews = kiyohScore == null ? void 0 : kiyohScore.last12MonthNumberReviews;
  const reviewUrl = (_b = (_a = kiyohScore == null ? void 0 : kiyohScore.reviewURLs) == null ? void 0 : _a.find(element => element.locale === locale)) == null ? void 0 : _b.reviewUrl;
  return /* @__PURE__ */React8.createElement(Panel2, {
    className: "pd-flex pd-flex-col pd-gap-2 pd-p-4 pd-text-sm"
  }, /* @__PURE__ */React8.createElement("div", {
    key: "total-price",
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React8.createElement("span", null, /* @__PURE__ */React8.createElement(FormattedMessage5, {
    id: "checkout.lineItemProductPrice",
    defaultMessage: "Product price"
  }), ":"), /* @__PURE__ */React8.createElement(Money_default, {
    value: (_d = (_c = entityTotal == null ? void 0 : entityTotal.product.basePrice) == null ? void 0 : _c.totalNet.centAmount) != null ? _d : 0,
    currency: (_e = entityTotal == null ? void 0 : entityTotal.product.basePrice) == null ? void 0 : _e.totalNet.currencyCode
  })), ((_f = entityTotal == null ? void 0 : entityTotal.services.basePrice) == null ? void 0 : _f.totalNet.centAmount) && /* @__PURE__ */React8.createElement("div", {
    key: "services-costs",
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React8.createElement("span", null, /* @__PURE__ */React8.createElement(FormattedMessage5, {
    id: "checkout.servicesCosts",
    defaultMessage: "Services costs"
  }), entityTotal.services.quantity > 1 && " (".concat(entityTotal.services.quantity, "x)"), ":"), /* @__PURE__ */React8.createElement(Money_default, {
    value: entityTotal.services.basePrice.totalNet.centAmount
  })), /* @__PURE__ */React8.createElement("div", {
    key: "shipping-price",
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React8.createElement("span", null, /* @__PURE__ */React8.createElement(FormattedMessage5, {
    id: "checkout.shippingCosts",
    defaultMessage: "Shipping costs"
  }), ":"), ((_g = entityTotal == null ? void 0 : entityTotal.shipping.basePrice) == null ? void 0 : _g.totalNet.centAmount) === void 0 || entityTotal.shipping.basePrice.totalNet.centAmount === 0 ? /* @__PURE__ */React8.createElement("span", {
    className: "pd-text-success-500"
  }, /* @__PURE__ */React8.createElement(FormattedMessage5, {
    id: "checkout.freeShipping",
    defaultMessage: "Free"
  })) : /* @__PURE__ */React8.createElement(Money_default, {
    value: entityTotal.shipping.basePrice.totalNet.centAmount,
    currency: entityTotal.shipping.basePrice.totalNet.currencyCode
  })), ((_h = entityTotal == null ? void 0 : entityTotal.deliveryService.basePrice) == null ? void 0 : _h.totalNet.centAmount) && /* @__PURE__ */React8.createElement("div", {
    key: "timed-delivery-costs",
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React8.createElement("span", null, /* @__PURE__ */React8.createElement(FormattedMessage5, {
    id: "checkout.timedDeliveryPrice",
    defaultMessage: "Timed delivery costs"
  }), ":"), /* @__PURE__ */React8.createElement(Money_default, {
    value: entityTotal.deliveryService.basePrice.totalNet.centAmount,
    currency: entityTotal.deliveryService.basePrice.totalNet.currencyCode
  })), ((_i = entityTotal == null ? void 0 : entityTotal.additionalAddressCosts.basePrice) == null ? void 0 : _i.totalNet.centAmount) && /* @__PURE__ */React8.createElement("div", {
    key: "additional-address-costs",
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React8.createElement("span", null, /* @__PURE__ */React8.createElement(FormattedMessage5, {
    id: "checkout.additionalAddressPrice",
    defaultMessage: "Additional address costs"
  }), ":"), /* @__PURE__ */React8.createElement(Money_default, {
    value: entityTotal.additionalAddressCosts.basePrice.totalNet.centAmount,
    currency: entityTotal.additionalAddressCosts.basePrice.totalNet.currencyCode
  })), /* @__PURE__ */React8.createElement(DiscountSummary_default, {
    entityTotal
  }), /* @__PURE__ */React8.createElement("hr", null), /* @__PURE__ */React8.createElement("div", {
    key: "subtotal-price",
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React8.createElement("span", null, /* @__PURE__ */React8.createElement(FormattedMessage5, {
    id: "checkout.subTotalPrice",
    defaultMessage: "Subtotal"
  }), ":"), /* @__PURE__ */React8.createElement(Money_default, {
    value: (_j = entityTotal == null ? void 0 : entityTotal.totalPrice.totalNet.centAmount) != null ? _j : 0,
    currency: entityTotal == null ? void 0 : entityTotal.totalPrice.totalNet.currencyCode
  })), (entityTotal == null ? void 0 : entityTotal.totalPrice.taxPortions) && entityTotal.totalPrice.taxPortions.map(taxPortion => {
    const taxRate = Math.round((taxPortion.rate + Number.EPSILON) * 1e3) / 10;
    return /* @__PURE__ */React8.createElement("div", {
      key: "tax-portion-".concat(taxRate),
      className: "pd-flex pd-justify-between"
    }, /* @__PURE__ */React8.createElement("span", null, /* @__PURE__ */React8.createElement(FormattedMessage5, {
      id: "checkout.totalVat",
      defaultMessage: "VAT"
    }), " ", "(", /* @__PURE__ */React8.createElement(FormattedMessage5, {
      id: "checkout.taxRate",
      defaultMessage: "{taxRate}%",
      values: {
        taxRate
      }
    }), "):"), /* @__PURE__ */React8.createElement(Money_default, {
      value: taxPortion.amount.centAmount,
      currency: taxPortion.amount.currencyCode
    }));
  }), /* @__PURE__ */React8.createElement("hr", null), /* @__PURE__ */React8.createElement("div", {
    key: "total-final-price",
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React8.createElement(Heading2, {
    as: "span",
    variant: "display",
    size: "2"
  }, /* @__PURE__ */React8.createElement(FormattedMessage5, {
    id: "checkout.lineItemTotalPrice",
    defaultMessage: "Total"
  }), ":"), /* @__PURE__ */React8.createElement(Heading2, {
    as: "span",
    variant: "display",
    size: "2"
  }, /* @__PURE__ */React8.createElement(Money_default, {
    value: (_k = entityTotal == null ? void 0 : entityTotal.totalPrice.totalGross.centAmount) != null ? _k : 0,
    currency: entityTotal == null ? void 0 : entityTotal.totalPrice.totalGross.currencyCode
  }))), /* @__PURE__ */React8.createElement("div", {
    className: "pd-flex pd-flex-col pd-gap-4"
  }, nextStepButton, /* @__PURE__ */React8.createElement(Experiment, {
    id: "search4it_exp1728_-_kiyoh_reviews_vs_trustpilot_reviews",
    fallback: true
  }, /* @__PURE__ */React8.createElement(Experiment.Control, null, isKiyohEnabled && Boolean(reviewUrl) && Boolean(last12MonthAverageRating) && Boolean(last12MonthNumberReviews) && /* @__PURE__ */React8.createElement(StoreToggle, {
    id: "drukwerkdeal-nl_printdeal-be"
  }, /* @__PURE__ */React8.createElement(StoreToggle.Enabled, null, /* @__PURE__ */React8.createElement(Link2, {
    href: reviewUrl,
    target: "_blank",
    className: "pd-flex pd-justify-center",
    variant: "secondary"
  }, /* @__PURE__ */React8.createElement(Brand2, {
    brand: "kiyoh",
    className: "pd-inline-block pd-h-5"
  }), /* @__PURE__ */React8.createElement("span", {
    className: "pd-inline-block"
  }, last12MonthAverageRating, " ", "Kiyoh\xA0", /* @__PURE__ */React8.createElement(FormattedMessage5, {
    id: "checkout.numberOfKiyohReviewsSmall",
    defaultMessage: "{number} reviews",
    values: {
      number: last12MonthNumberReviews
    }
  })))))), /* @__PURE__ */React8.createElement(Experiment.Variant, null, isKiyohEnabled && /* @__PURE__ */React8.createElement(CheckoutTrustpilot_default, null)))));
};
var CheckoutSummary_default = CheckoutSummary;

// src/library/components/cart/DeleteCartButton.tsx
import { LinkAsButton } from "@printdeal/ui-library";
import React9, { useMemo } from "react";
import { FormattedMessage as FormattedMessage6 } from "react-intl";
import { useCartVersionMismatchPrevention } from "@printdeal/checkout-shared/dist/frontend";

// src/library/queries/cart/useDeleteCartMutation.ts
import { useMutation as useMutation4 } from "@tanstack/react-query";
function useDeleteCartMutation(_ref13) {
  let {
    onError,
    onSuccess
  } = _ref13;
  const {
    locallyRemoveCart
  } = useCart();
  return useMutation4({
    mutationKey: ["deleteCart" /* deleteCart */],
    mutationFn: cartId => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cannot delete a cart without cartId");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.deleteCart(cartId);
      return data;
    }),
    onError: error => {
      if (typeof onError === "function") {
        onError(error);
      }
    },
    onSuccess: () => {
      locallyRemoveCart();
      if (typeof onSuccess === "function") {
        onSuccess();
      }
    },
    retry: false
  });
}

// src/library/components/cart/DeleteCartButton.tsx
var DeleteCartButton = _ref14 => {
  let {
    onSuccess,
    onError
  } = _ref14;
  const deleteCartMutation = useDeleteCartMutation({
    onSuccess,
    onError
  });
  const {
    cart,
    cartId
  } = useCart();
  const {
    isCartMutationPending
  } = useCartVersionMismatchPrevention();
  const shouldDisableMutation = useMemo(() => !cart || !cartId || isCartMutationPending || deleteCartMutation.isPending, [cart, cartId, isCartMutationPending, deleteCartMutation.isPending]);
  const handleOnClick = event => {
    event.preventDefault();
    if (shouldDisableMutation) {
      return;
    }
    deleteCartMutation.mutate(cartId);
  };
  return /* @__PURE__ */React9.createElement(LinkAsButton, {
    iconBefore: deleteCartMutation.isPending ? void 0 : "trashcan",
    onClick: handleOnClick,
    variant: "secondary",
    disabled: shouldDisableMutation,
    className: "pd-text-xs",
    isLoading: deleteCartMutation.isPending
  }, /* @__PURE__ */React9.createElement(FormattedMessage6, {
    id: "checkout.emptyCart.button",
    defaultMessage: "Empty cart"
  }));
};
var DeleteCartButton_default = DeleteCartButton;

// src/library/components/design-system/checkout/CheckoutDevOnly.tsx
import { Panel as Panel3 } from "@printdeal/ui-library";
import React11 from "react";
import cx from "clsx";

// src/library/helpers/WindowHelpers.ts
var windowPresent = typeof window !== "undefined";
var getFromLocalStorage = key => {
  if (!windowPresent) {
    return void 0;
  }
  return window.localStorage.getItem(key);
};
var saveToLocalStorage = (key, value) => {
  if (!windowPresent) {
    return;
  }
  window.localStorage.setItem(key, value);
};

// src/library/components/design-system/checkout/CheckoutJSONViewer.tsx
import { LinkAsButton as LinkAsButton2, useCopyToClipboard } from "@printdeal/ui-library";
import React10 from "react";
var CheckoutJSONViewer = _ref15 => {
  let {
    jsonObject
  } = _ref15;
  const [, copyToClipboard] = useCopyToClipboard();
  const handleCopy = text => __async(void 0, null, function* () {
    yield copyToClipboard(text.toString());
  });
  return /* @__PURE__ */React10.createElement("div", {
    className: "pd-flex pd-flex-col"
  }, Object.keys(jsonObject).map(key => /* @__PURE__ */React10.createElement(LinkAsButton2, {
    onClick: () => {
      handleCopy(jsonObject[key]).catch(() => {});
    },
    iconAfter: "copy",
    key,
    variant: "secondary"
  }, key, ":", jsonObject[key])));
};
var CheckoutJSONViewer_default = CheckoutJSONViewer;

// src/library/components/design-system/checkout/CheckoutDevOnly.tsx
var CheckoutDevOnly = _ref16 => {
  let {
    className,
    jsonObject,
    children
  } = _ref16;
  return getFromLocalStorage("checkout_info") === "true" && /* @__PURE__ */React11.createElement(Panel3, {
    className: cx("pd-p-4 pd-bg-error-100", className)
  }, /* @__PURE__ */React11.createElement("p", {
    className: "pd-mb-2 pd-text-xs"
  }, "This panel is only visible for developers."), /* @__PURE__ */React11.createElement("div", {
    className: "pd-flex"
  }, /* @__PURE__ */React11.createElement("div", {
    className: "pd-w-full pd-rounded-md pd-border pd-border-dim-200 pd-bg-white pd-p-2 pd-text-sm"
  }, jsonObject && /* @__PURE__ */React11.createElement(CheckoutJSONViewer_default, {
    jsonObject
  }), children)));
};
var CheckoutDevOnly_default = CheckoutDevOnly;

// src/library/components/design-system/checkout/cart-page/CartLineItems.tsx
import { Experiment as Experiment3 } from "@printdeal/feature-management/react";
import React28 from "react";

// src/library/components/design-system/line-item/LineItemPanel.tsx
import { Panel as Panel6 } from "@printdeal/ui-library";
import React21 from "react";

// src/library/components/design-system/line-item/LineItemActions.tsx
import React20, { useState as useState6 } from "react";
import { hasLinkedServices, isQuoteLineItem, hasOrchestration } from "@printdeal/business-logic";
import { isLineItemReviewGroupLead } from "@printdeal/checkout-shared";

// src/library/components/line-item/DuplicateLineItemButton.tsx
import React12, { useMemo as useMemo2 } from "react";
import { useCartVersionMismatchPrevention as useCartVersionMismatchPrevention2 } from "@printdeal/checkout-shared/dist/frontend";
import { FormattedMessage as FormattedMessage7 } from "react-intl";
import { Button } from "@printdeal/ui-library";

// src/library/queries/line-item/useDuplicateLineItemMutation.ts
import { useMutation as useMutation6 } from "@tanstack/react-query";
import { AddLineItemHelper } from "@printdeal/checkout-shared";
import { isGroupLineItem, getAssociatedGroupedLineItems } from "@printdeal/business-logic";
import { nanoid } from "nanoid";

// src/library/queries/quote/useAddQuoteToCartMutation.ts
import { useMutation as useMutation5 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication2 } from "@printdeal/authentication";
import { ErrorManagement as ErrorManagement3 } from "@printdeal/error-management/react";
function useAddQuoteToCartMutation() {
  const {
    isUserLoggedIn
  } = useAuthentication2();
  const {
    setCartData,
    cartId,
    addError,
    removeError
  } = useCart();
  const createCartMutation = useCreateCartMutation();
  const mutationKey = "addQuoteToCart" /* addQuoteToCart */;
  return useMutation5({
    mutationKey: [mutationKey],
    mutationFn: payload => __async(this, null, function* () {
      if (!isUserLoggedIn) {
        throw new Error("Cannot add a quote to the cart when not logged in");
      }
      if (payload.length === 0) {
        throw new Error("Payload for add quote line item is invalid: ".concat(JSON.stringify(payload)));
      }
      let newCartId = cartId;
      if (!newCartId) {
        ({
          id: newCartId
        } = yield createCartMutation.mutateAsync());
      }
      removeError(mutationKey);
      return ShoppingCartHttpClient_default.addQuoteLineItem(newCartId, payload);
    }),
    onSuccess: responseData => {
      setCartData(responseData.data);
    },
    onError: error => {
      addError(mutationKey, error);
      ErrorManagement3.exception({
        exception: error,
        tags: {
          fileLocation: "useAddQuoteToCartMutation",
          featureFunction: "add quote line item to cart"
        },
        fingerprint: ["checkout", "useAddQuoteToCartMutation"]
      });
    }
  });
}

// src/library/queries/line-item/useDuplicateLineItemMutation.ts
function useDuplicateLineItemMutation(_ref17) {
  let {
    onSuccess,
    onError
  } = _ref17;
  const {
    cartId,
    cart,
    setCartData
  } = useCart();
  const mutationKey = "duplicateLineItem" /* duplicateLineItem */;
  const addQuoteToCartMutation = useAddQuoteToCartMutation();
  const reAssignGroupIds = lineItems => {
    const groupIds = [];
    lineItems.forEach(lineItem => {
      var _a, _b;
      if ((_a = lineItem.custom) == null ? void 0 : _a.fields.serviceGroup) {
        groupIds.push({
          oldGroupId: lineItem.custom.fields.serviceGroup,
          newGroupId: nanoid()
        });
      }
      if ((_b = lineItem.custom) == null ? void 0 : _b.fields.isReviewGroupLead) {
        groupIds.push({
          oldGroupId: lineItem.custom.fields.reviewGroup,
          newGroupId: nanoid()
        });
      }
    });
    groupIds.forEach(_ref18 => {
      let {
        oldGroupId,
        newGroupId
      } = _ref18;
      lineItems.forEach(lineItem => {
        var _a, _b;
        if (((_a = lineItem.custom) == null ? void 0 : _a.fields.serviceGroup) && lineItem.custom.fields.serviceGroup === oldGroupId) {
          lineItem.custom.fields.serviceGroup = newGroupId;
        }
        if (((_b = lineItem.custom) == null ? void 0 : _b.fields.reviewGroup) && lineItem.custom.fields.reviewGroup === oldGroupId) {
          lineItem.custom.fields.reviewGroup = newGroupId;
          lineItem.custom.fields.fulfillmentGroup = newGroupId;
        }
      });
    });
    return lineItems;
  };
  return useMutation6({
    mutationKey: [mutationKey],
    mutationFn: _0 => __async(this, [_0], function (_ref19) {
      let {
        lineItem
      } = _ref19;
      return function* () {
        var _a;
        if (!cartId || !cart) {
          throw new Error("Cannot duplicate line item without a cart");
        }
        if ((_a = lineItem.custom) == null ? void 0 : _a.fields.quoteId) {
          const {
            data: data2
          } = yield addQuoteToCartMutation.mutateAsync([{
            quoteId: lineItem.custom.fields.quoteId,
            quoteLineItemId: lineItem.custom.fields.quoteLineItemId
          }]);
          return data2;
        }
        const lineItems = [lineItem];
        if (isGroupLineItem(lineItem)) {
          lineItems.push(...getAssociatedGroupedLineItems(cart, lineItem, {
            reviewGroup: true,
            fulfillmentGroup: true,
            multipleDesignsGroup: true
          }));
        }
        const newLineItem = AddLineItemHelper.buildLineItemsFromExistingLineItems({
          lineItems: reAssignGroupIds(lineItems),
          orderOrCart: cart
        });
        const {
          data
        } = yield ShoppingCartHttpClient_default.addLineItem(cartId, newLineItem);
        return data;
      }();
    }),
    retry: false,
    onSuccess: data => {
      setCartData(data);
      if (typeof onSuccess === "function") {
        onSuccess(data, mutationKey);
      }
    },
    onError: error => {
      if (typeof onError === "function") {
        onError(error, mutationKey);
      }
    }
  });
}

// src/library/components/line-item/DuplicateLineItemButton.tsx
var DuplicateLineItemButton = _ref20 => {
  let {
    lineItem,
    open = false,
    onSuccess,
    onError,
    onMouseEnter,
    onMouseLeave
  } = _ref20;
  const duplicateLineItemMutation = useDuplicateLineItemMutation({
    onSuccess,
    onError
  });
  const {
    isCartMutationPending
  } = useCartVersionMismatchPrevention2();
  const {
    queries: {
      cartQuery
    }
  } = useCart();
  const shouldDisableMutation = useMemo2(() => {
    if (cartQuery.isLoading || isCartMutationPending || duplicateLineItemMutation.status === "pending") {
      return true;
    }
    return false;
  }, [cartQuery.isLoading, isCartMutationPending, duplicateLineItemMutation.status]);
  const handleOnClick = event => {
    event.preventDefault();
    if (shouldDisableMutation) {
      return;
    }
    duplicateLineItemMutation.mutate({
      lineItem
    });
  };
  const showSpinner = duplicateLineItemMutation.status === "pending" && duplicateLineItemMutation.variables.lineItem.id === lineItem.id;
  return /* @__PURE__ */React12.createElement(Button, {
    variant: "tertiary",
    iconBefore: "copy",
    className: "pd-gap-0",
    isLoading: showSpinner,
    disabled: shouldDisableMutation,
    onClick: handleOnClick,
    onMouseEnter,
    onMouseLeave
  }, /* @__PURE__ */React12.createElement("div", {
    className: "pd-overflow-hidden pd-transition-[max-width] pd-duration-[1000ms] ".concat(open ? "pd-max-w-[200px]" : "pd-max-w-0")
  }, /* @__PURE__ */React12.createElement("span", {
    className: "pd-ml-2 pd-whitespace-nowrap"
  }, /* @__PURE__ */React12.createElement(FormattedMessage7, {
    id: "checkout.lineItem.copy",
    defaultMessage: "Copy"
  }))));
};
var DuplicateLineItemButton_default = DuplicateLineItemButton;

// src/library/components/line-item/RemoveLineItemButton.tsx
import React13, { useEffect as useEffect5, useMemo as useMemo3 } from "react";
import { useCartVersionMismatchPrevention as useCartVersionMismatchPrevention3 } from "@printdeal/checkout-shared/dist/frontend";
import { FormattedMessage as FormattedMessage8 } from "react-intl";
import { useQueryClient } from "@tanstack/react-query";
import { addDataLayerEntry as addDataLayerEntry3 } from "@printdeal/data-layer-manager";
import { Button as Button2 } from "@printdeal/ui-library";

// src/library/helpers/CartHelpers.ts
var hasQuoteLineItem = cart => cart.lineItems.some(lineItem => {
  var _a;
  return (_a = lineItem.custom) == null ? void 0 : _a.fields.quoteId;
});
var getLineItemIds = cart => cart.lineItems.map(_ref21 => {
  let {
    id
  } = _ref21;
  return id;
});

// src/library/helpers/EcommerceObjectHelper.ts
var EcommerceObjectHelper = class {
  static convertCentAmountToAmountWithCents(_ref22) {
    let {
      centAmount,
      fractionDigits
    } = _ref22;
    const digits = fractionDigits || 2;
    const fractionDivision = {
      2: 100
    };
    return Number((centAmount / fractionDivision[digits]).toFixed(digits));
  }
  static getPropertyValueFromVariableAttributesByKey(lineItem, propertyKey) {
    var _a;
    const variableAttributes = (_a = lineItem.custom) == null ? void 0 : _a.fields.variableAttributes;
    if (!variableAttributes || variableAttributes.length === 0) {
      return void 0;
    }
    const keyToLower = propertyKey.toLowerCase();
    const quantity = variableAttributes.map(attribute => {
      const [key, value] = attribute.split(":");
      return {
        key,
        value: parseInt(value, 10)
      };
    }).find(attribute => attribute.key.toLowerCase() === keyToLower);
    return quantity ? quantity.value : void 0;
  }
  static getProductVariant(lineItem) {
    var _a;
    const userSelection = (_a = lineItem.custom) == null ? void 0 : _a.fields.userSelection;
    if (!userSelection || userSelection.length === 0) {
      return "Unknown, userSelection field missing or empty";
    }
    const productVariant = {};
    userSelection.forEach(selection => {
      const [key, value] = selection.split(":");
      productVariant[key] = value;
    });
    const quantity = this.getPropertyValueFromVariableAttributesByKey(lineItem, "Quantity");
    if (quantity) {
      productVariant.Quantity = quantity;
    }
    return JSON.stringify(productVariant);
  }
  static clearEcommerceObject() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ecommerce: null
    });
  }
  /**
   * Intended for most events that don't need anything else besides basic cart data.
   * See other functions below for events that need their own separate implementation.
   */
  static createEcommerceObject(cart) {
    return {
      currency: "EUR",
      value: cart && cart.taxedPrice ? this.convertCentAmountToAmountWithCents(cart.taxedPrice.totalGross) : void 0,
      coupon: cart && cart.couponCodes.length > 0 ? cart.couponCodes.map(_ref23 => {
        let {
          code
        } = _ref23;
        return code;
      }).join() : void 0,
      items: cart && cart.lineItems.length > 0 ? cart.lineItems.map(lineItem => {
        var _a;
        return {
          item_name: lineItem.name.en,
          item_id: (_a = lineItem.custom) == null ? void 0 : _a.fields.productKey,
          price: this.convertCentAmountToAmountWithCents(lineItem.totalPrice),
          item_variant: this.getProductVariant(lineItem),
          quantity: 1,
          sku_quantity: lineItem.quantity
        };
      }) : void 0
    };
  }
  /**
   * Intended for 'add_payment_info' events.
   * @see https://sites.google.com/artefact.com/drukwerkdeal-ga4-solutiondesig/tracking-overview/add_payment_info?authuser=0
   */
  static createEcommercePaymentInfoObject(cart, paymentMethodId) {
    return __spreadProps(__spreadValues({}, this.createEcommerceObject(cart)), {
      payment_type: paymentMethodId
    });
  }
  /**
   * Intended for 'remove_from_cart' events.
   * @see https://sites.google.com/artefact.com/drukwerkdeal-ga4-solutiondesig/tracking-overview/remove_from_cart?authuser=0
   */
  static createEcommerceRemoveObject(cart, removedLineItems) {
    return {
      currency: "EUR",
      coupon: cart && cart.couponCodes.length > 0 ? cart.couponCodes.map(_ref24 => {
        let {
          code
        } = _ref24;
        return code;
      }).join() : void 0,
      items: removedLineItems.map(lineItem => {
        var _a;
        return {
          item_name: lineItem.name.en,
          item_id: (_a = lineItem.custom) == null ? void 0 : _a.fields.productKey,
          price: this.convertCentAmountToAmountWithCents(lineItem.totalPrice),
          item_variant: this.getProductVariant(lineItem),
          quantity: 1,
          sku_quantity: lineItem.quantity,
          index: cart ? cart.lineItems.indexOf(lineItem) + 1 : void 0
        };
      })
    };
  }
  static createEcommercePurchaseObject(cart, order) {
    var _a;
    return __spreadProps(__spreadValues({}, this.createEcommerceObject(cart)), {
      transaction_id: order.orderNumber,
      tax: ((_a = order.taxedPrice) == null ? void 0 : _a.totalTax) ? this.convertCentAmountToAmountWithCents(order.taxedPrice.totalTax) : void 0,
      shipping: this.convertCentAmountToAmountWithCents(order.shippingCosts.totalNet)
    });
  }
};

// src/library/components/line-item/RemoveLineItemButton.tsx
var RemoveLineItemButton = _ref25 => {
  let {
    lineItem,
    open = false,
    onSuccess,
    onError,
    onMouseEnter,
    onMouseLeave
  } = _ref25;
  var _a;
  const removeLineItemMutation = useRemoveLineItemMutation({
    onSuccess,
    onError
  });
  const {
    isCartMutationPending
  } = useCartVersionMismatchPrevention3();
  const queryClient = useQueryClient();
  const {
    queries: {
      cartQuery
    },
    expiredQuotesError,
    cart,
    cartId
  } = useCart();
  const shouldDisableRemoveLineItem = useMemo3(() => {
    if (cartQuery.isLoading || isCartMutationPending || removeLineItemMutation.status === "pending") {
      return true;
    }
    return false;
  }, [cartQuery.isLoading, isCartMutationPending, removeLineItemMutation.status]);
  useEffect5(() => {
    var _a2;
    if (removeLineItemMutation.isSuccess && ((_a2 = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a2.length) && cart && getLineItemIds(cart).includes(lineItem.id)) {
      const invalidateQuery = () => __async(void 0, null, function* () {
        yield queryClient.invalidateQueries({
          queryKey: ["getExpiredQuotes", cartId]
        });
      });
      invalidateQuery().catch(() => {});
    }
  }, [cart, cartId, (_a = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a.length, lineItem.id, queryClient, removeLineItemMutation.isSuccess]);
  const showSpinner = removeLineItemMutation.status === "pending" && removeLineItemMutation.variables.lineItemId === lineItem.id;
  return /* @__PURE__ */React13.createElement(Button2, {
    variant: "tertiary",
    iconBefore: "trashcan",
    className: "pd-gap-0",
    isLoading: showSpinner,
    disabled: shouldDisableRemoveLineItem,
    onClick: () => {
      if (shouldDisableRemoveLineItem) {
        return;
      }
      removeLineItemMutation.mutate({
        lineItemId: lineItem.id
      });
      EcommerceObjectHelper.clearEcommerceObject();
      addDataLayerEntry3("remove_from_cart", EcommerceObjectHelper.createEcommerceRemoveObject(cart, [lineItem]));
    },
    onMouseEnter,
    onMouseLeave
  }, /* @__PURE__ */React13.createElement("div", {
    className: "pd-overflow-hidden pd-transition-[max-width] pd-duration-[1000ms] ".concat(open ? "pd-max-w-[200px]" : "pd-max-w-0")
  }, /* @__PURE__ */React13.createElement("span", {
    className: "pd-ml-2 pd-whitespace-nowrap"
  }, /* @__PURE__ */React13.createElement(FormattedMessage8, {
    id: "checkout.lineItem.remove",
    defaultMessage: "Remove"
  }))));
};
var RemoveLineItemButton_default = RemoveLineItemButton;

// src/library/components/line-item/EditLineItemButton.tsx
import React19, { useState as useState5 } from "react";
import { FormattedMessage as FormattedMessage13 } from "react-intl";
import { useCartVersionMismatchPrevention as useCartVersionMismatchPrevention4 } from "@printdeal/checkout-shared/dist/frontend";
import { Button as Button4 } from "@printdeal/ui-library";

// src/library/components/line-item/edit-line-item/EditLineItemModal.tsx
import { Modal, Spinner as Spinner2 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage12, useIntl as useIntl6 } from "react-intl";
import { SelectorContextProvider, PricesContextProvider, VatModeProvider, useSelectorContentByPageId } from "@printdeal/product-selector";
import React18 from "react";

// src/library/components/line-item/edit-line-item/EditLineItemContent.tsx
import { useSelectorMachineSend } from "@printdeal/product-selector";
import { LinkAsButton as LinkAsButton3 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage11 } from "react-intl";
import React17 from "react";
import { getDeliveryOptionId } from "@printdeal/checkout-shared";

// src/library/components/line-item/edit-line-item/EditLineItemSummary.tsx
import React14, { useContext as useContext4, useEffect as useEffect6, useState as useState2 } from "react";
import { VatModeContext, useSelectorMachineContext, getProductAttribute, useSelectorState } from "@printdeal/product-selector";
import { Alert as Alert2, Button as Button3, Heading as Heading3, Panel as Panel4, Tooltip } from "@printdeal/ui-library";
import { defineMessages as defineMessages2, FormattedMessage as FormattedMessage9, useIntl as useIntl5 } from "react-intl";
import { arrayOfStringArraysToArrayOfObjects, keyValueObjectToStringArray } from "@printdeal/transformers";
import { getProductVariantVersion, isArtworkDelivered } from "@printdeal/business-logic";
import { shouldRemoveArtwork } from "@printdeal/checkout-shared";

// src/library/queries/surface-helper/useGetSurfaceDependenciesQuery.ts
import { useQuery as useQuery2 } from "@tanstack/react-query";

// src/library/http-clients/SurfaceHelperServiceHttpClient.ts
import axios2 from "axios";
import { configurationProvider as configurationProvider2 } from "@printdeal/configuration";
import { jwtDecode } from "jwt-decode";
import { authenticationHttpClient } from "@printdeal/authentication";
var anonymousCoamIdentity;
var isDecodedTokenExpired = decodedToken => {
  if (!decodedToken.exp) {
    return true;
  }
  return Boolean(decodedToken.exp <= Math.floor(( /* @__PURE__ */new Date()).getTime() / 1e3));
};
var createAnonymousCOAMIdentity = identity => __async(void 0, null, function* () {
  const {
    data: {
      token: printdealAuthToken
    }
  } = yield authenticationHttpClient.createToken();
  const {
    data
  } = yield axios2.post("".concat(configurationProvider2.getValue("AUTH_LAYER_API_BASE_URL"), "/anon-coam-identity"), identity, {
    headers: {
      Authorization: printdealAuthToken
    }
  });
  return data;
});
var getAnonymousCOAMIdentity = () => __async(void 0, null, function* () {
  const identityFromStorage = getFromLocalStorage("anonCoamIdentity");
  if (!identityFromStorage) {
    const newIdentity = yield createAnonymousCOAMIdentity();
    saveToLocalStorage("anonCoamIdentity", JSON.stringify(newIdentity));
    return newIdentity;
  }
  const parsedIdentityFromStorage = JSON.parse(identityFromStorage);
  const decodedToken = jwtDecode(parsedIdentityFromStorage.anonymousToken);
  if (isDecodedTokenExpired(decodedToken)) {
    const newIdentity = yield createAnonymousCOAMIdentity(parsedIdentityFromStorage);
    saveToLocalStorage("anonCoamIdentity", JSON.stringify(newIdentity));
    return newIdentity;
  }
  return parsedIdentityFromStorage;
});
function authenticateHttpRequestInterceptor2(config) {
  return __async(this, null, function* () {
    if (!anonymousCoamIdentity) {
      anonymousCoamIdentity = yield getAnonymousCOAMIdentity();
    }
    if (!(anonymousCoamIdentity == null ? void 0 : anonymousCoamIdentity.anonymousToken)) {
      throw new Error("Could not retrieve an anonymous COAM Identity to authenticate the HTTP request.");
    }
    const updatedConfig = config;
    updatedConfig.headers.Authorization = "Bearer ".concat(anonymousCoamIdentity.anonymousToken);
    return updatedConfig;
  });
}
var SurfaceHelperServiceHttpClient = class {
  get client() {
    if (!this.httpClient) {
      const baseURL = "https://surface-helper.products.cimpress.io";
      this.httpClient = axios2.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor2);
    }
    return this.httpClient;
  }
  getDependencies(productId, version) {
    return __async(this, null, function* () {
      return this.client.post("/v1/dependencies:calculated", {
        productId,
        version
      });
    });
  }
};
var surfaceHelperServiceHttpClient = new SurfaceHelperServiceHttpClient();
var SurfaceHelperServiceHttpClient_default = surfaceHelperServiceHttpClient;

// src/library/queries/surface-helper/useGetSurfaceDependenciesQuery.ts
function useGetSurfaceDependenciesQuery(_ref26) {
  let {
    productId,
    version,
    enabled
  } = _ref26;
  return useQuery2({
    queryKey: ["get-surface-dependencies", productId, version],
    queryFn: () => __async(this, null, function* () {
      if (!productId || !version) {
        throw new Error("productId and or version are required");
      }
      const {
        data
      } = yield SurfaceHelperServiceHttpClient_default.getDependencies(productId, version);
      return data;
    }),
    retry: false,
    enabled
  });
}

// src/library/components/line-item/edit-line-item/EditLineItemSummary.tsx
var translations = defineMessages2({
  "Normal": {
    id: "checkout.editLineItem.deliveryMethod.normal",
    defaultMessage: "Normal"
  },
  "Next Day": {
    id: "checkout.editLineItem.deliveryMethod.nextDay",
    defaultMessage: "Next Day"
  },
  "Express": {
    id: "checkout.editLineItem.deliveryMethod.express",
    defaultMessage: "Express"
  },
  "Quantity": {
    id: "checkout.editLineItem.quantity",
    defaultMessage: "Quantity"
  },
  "Delivery Type": {
    id: "checkout.editLineItem.deliveryType",
    defaultMessage: "Delivery Type"
  }
});
var EditLineItemSummary = _ref27 => {
  let {
    lineItem,
    onSubmitChanges,
    error,
    product,
    deliveryOptionId
  } = _ref27;
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const intl = useIntl5();
  const vatContext = useContext4(VatModeContext);
  const selectedPrice = useSelectorMachineContext(state => state.context.totalPrice);
  const selectorState = useSelectorState();
  const selection = useSelectorMachineContext(state => state.context.selection);
  const quantity = useSelectorMachineContext(state => state.context.totalQuantity);
  const deliveryOption = useSelectorMachineContext(state => state.context.selectedDeliveryOption);
  const deliveryOptions = useSelectorMachineContext(state => state.context.deliveryDates);
  const getSurfaceDependenciesQuery = useGetSurfaceDependenciesQuery({
    productId: (_a = lineItem.custom) == null ? void 0 : _a.fields.mcpSku,
    version: getProductVariantVersion({
      attributes: (_b = lineItem.variant.attributes) != null ? _b : []
    }).toString(),
    enabled: isArtworkDelivered(lineItem)
  });
  const hasNewQuantity = lineItem.quantity !== quantity;
  const [isPending, setIsPending] = useState2(false);
  const [changedAttributes, setChangedAttributes] = useState2([]);
  const [willRemoveArtwork, setWillRemoveArtwork] = useState2(false);
  const [willRemoveSplitShipment, setWillRemoveSplitShipment] = useState2(false);
  const [newUserSelection, setNewUserSelection] = useState2({});
  useEffect6(() => {
    if (getSurfaceDependenciesQuery.data) {
      const {
        remainingOptions
      } = getSurfaceDependenciesQuery.data;
      if (isArtworkDelivered(lineItem) && remainingOptions.length > 0 && Object.keys(selection).length > 0) {
        const removeArtwork = shouldRemoveArtwork(lineItem, selection, remainingOptions);
        setWillRemoveArtwork(removeArtwork);
      }
    }
  }, [getSurfaceDependenciesQuery.data, lineItem, selection]);
  useEffect6(() => {
    var _a2, _b2;
    const currentSelection = keyValueObjectToStringArray((_a2 = lineItem.custom) == null ? void 0 : _a2.fields.userSelection);
    const userSelection = {};
    const changedAttributesArray = [];
    Object.keys(selection).forEach(key => {
      const isQuantity = key === "Quantity";
      if (selection[key] !== currentSelection[key] && !isQuantity) {
        changedAttributesArray.push({
          attributeName: key,
          previousValue: currentSelection[key],
          newValue: selection[key]
        });
      }
      if (!isQuantity) {
        userSelection[key] = selection[key];
      }
    });
    if (deliveryOption.id && deliveryOption.id !== deliveryOptionId) {
      const previousDeliveryOption = deliveryOptions.find(_ref28 => {
        let {
          id
        } = _ref28;
        return id === deliveryOptionId;
      });
      if (previousDeliveryOption) {
        changedAttributesArray.push({
          attributeName: "Delivery Type",
          previousValue: previousDeliveryOption.name,
          newValue: deliveryOption.name
        });
      }
    }
    if (hasNewQuantity) {
      changedAttributesArray.push({
        attributeName: "Quantity",
        previousValue: String(lineItem.quantity),
        newValue: String(quantity)
      });
      const shippingAddresses = arrayOfStringArraysToArrayOfObjects((_b2 = lineItem.custom) == null ? void 0 : _b2.fields.shippingAddressPerLineItem);
      if (shippingAddresses.length > 1) {
        setWillRemoveSplitShipment(true);
      } else {
        setWillRemoveSplitShipment(false);
      }
    } else {
      setWillRemoveSplitShipment(false);
    }
    setNewUserSelection(userSelection);
    setChangedAttributes(changedAttributesArray);
  }, [(_c = lineItem.custom) == null ? void 0 : _c.fields.shippingAddressPerLineItem, (_d = lineItem.custom) == null ? void 0 : _d.fields.userSelection, lineItem.quantity, selection, quantity, deliveryOption.id]);
  return /* @__PURE__ */React14.createElement(Panel4, {
    className: "pd-flex pd-flex-col pd-gap-3"
  }, /* @__PURE__ */React14.createElement(Heading3, {
    as: "h3"
  }, /* @__PURE__ */React14.createElement(FormattedMessage9, {
    id: "checkout.editLineItem.yourChanges",
    defaultMessage: "Your changes"
  })), error && /* @__PURE__ */React14.createElement(ErrorAlert_default, {
    sentryException: {
      e: error,
      tags: {
        fileLocation: "EditLineItemSummary.tsx",
        featureFunction: "editLineItemMutation"
      },
      fingerPrint: ["edit-line-item-summary", "edit-line-item-mutation"]
    }
  }, /* @__PURE__ */React14.createElement(FormattedMessage9, {
    id: "checkout.editLineItem.error",
    defaultMessage: "Something went wrong while updating"
  })), willRemoveArtwork && /* @__PURE__ */React14.createElement(Alert2, {
    variant: "warning"
  }, /* @__PURE__ */React14.createElement(FormattedMessage9, {
    id: "checkout.editLineItem.willRemoveArtwork",
    defaultMessage: "Do you confirm these changes? Then we remove the design. This no longer meets the graphic requirements of the new product composition."
  })), willRemoveSplitShipment && /* @__PURE__ */React14.createElement(Alert2, {
    variant: "warning"
  }, /* @__PURE__ */React14.createElement(FormattedMessage9, {
    id: "checkout.editLineItem.willRemoveSplitShipment",
    defaultMessage: "Do you confirm to change the quantity? Then we remove the split shipment. This is no longer possible with the new quantity."
  })), changedAttributes.length ? /* @__PURE__ */React14.createElement("div", {
    className: "pd-flex pd-flex-col pd-rounded pd-border"
  }, /* @__PURE__ */React14.createElement("div", {
    className: "pd-grid pd-grid-cols-3 pd-bg-dim-100 pd-px-4 pd-py-2"
  }, /* @__PURE__ */React14.createElement(Heading3, {
    as: "h4",
    className: "pd-col-start-2"
  }, /* @__PURE__ */React14.createElement(FormattedMessage9, {
    id: "checkout.editLineItem.oldValue",
    defaultMessage: "Old value"
  })), /* @__PURE__ */React14.createElement(Heading3, {
    as: "h4"
  }, /* @__PURE__ */React14.createElement(FormattedMessage9, {
    id: "checkout.editLineItem.newValue",
    defaultMessage: "New value"
  }))), changedAttributes.map(_ref29 => {
    let {
      attributeName,
      previousValue,
      newValue
    } = _ref29;
    var _a2, _b2, _c2, _d2;
    const productAttribute = getProductAttribute(product.attributes, attributeName);
    const translatedAttributeName = attributeName === "Quantity" ? intl.formatMessage(translations.Quantity) : (productAttribute == null ? void 0 : productAttribute.attributeAlias) || attributeName;
    const translatedPreviousValue = ((_b2 = (_a2 = productAttribute == null ? void 0 : productAttribute.values) == null ? void 0 : _a2.find(value => value.pimAttributeValue === previousValue)) == null ? void 0 : _b2.attributeValueAlias) || previousValue;
    const translatedNewValue = ((_d2 = (_c2 = productAttribute == null ? void 0 : productAttribute.values) == null ? void 0 : _c2.find(value => value.pimAttributeValue === newValue)) == null ? void 0 : _d2.attributeValueAlias) || newValue;
    if (attributeName === "Delivery Type") {
      return /* @__PURE__ */React14.createElement("div", {
        className: "pd-grid pd-grid-cols-3 pd-p-2",
        key: attributeName
      }, /* @__PURE__ */React14.createElement("p", null, intl.formatMessage(translations[attributeName])), /* @__PURE__ */React14.createElement("p", {
        className: "pd-line-through"
      }, intl.formatMessage(translations[previousValue])), /* @__PURE__ */React14.createElement("p", null, intl.formatMessage(translations[newValue])));
    }
    return /* @__PURE__ */React14.createElement("div", {
      className: "pd-grid pd-grid-cols-3 pd-p-2",
      key: attributeName
    }, /* @__PURE__ */React14.createElement("p", null, translatedAttributeName), /* @__PURE__ */React14.createElement("p", {
      className: "pd-line-through"
    }, translatedPreviousValue), /* @__PURE__ */React14.createElement("p", null, translatedNewValue));
  }), selectedPrice && selectedPrice.totalNet.centAmount !== ((_e = lineItem.taxedPrice) == null ? void 0 : _e.totalNet.centAmount) && /* @__PURE__ */React14.createElement("div", {
    className: "pd-grid pd-grid-cols-3 pd-bg-dim-100 pd-p-2 pd-font-bold"
  }, vatContext.vatMode === "totalNet" ? /* @__PURE__ */React14.createElement(FormattedMessage9, {
    id: "checkout.editLineItem.priceExclusiveVAT",
    defaultMessage: "Price (excl. VAT)"
  }) : /* @__PURE__ */React14.createElement(FormattedMessage9, {
    id: "checkout.editLineItem.priceInclusiveVAT",
    defaultMessage: "Price (incl. VAT)"
  }), /* @__PURE__ */React14.createElement("p", {
    className: "pd-line-through"
  }, vatContext.vatMode === "totalNet" ? /* @__PURE__ */React14.createElement(Money_default, {
    value: (_f = lineItem.taxedPrice) == null ? void 0 : _f.totalNet.centAmount,
    currency: (_g = lineItem.taxedPrice) == null ? void 0 : _g.totalNet.currencyCode
  }) : /* @__PURE__ */React14.createElement(Money_default, {
    value: (_h = lineItem.taxedPrice) == null ? void 0 : _h.totalGross.centAmount,
    currency: (_i = lineItem.taxedPrice) == null ? void 0 : _i.totalGross.currencyCode
  })), vatContext.vatMode === "totalNet" ? /* @__PURE__ */React14.createElement(Money_default, {
    value: selectedPrice.totalNet.centAmount,
    currency: selectedPrice.totalNet.currencyCode
  }) : /* @__PURE__ */React14.createElement(Money_default, {
    value: selectedPrice.totalGross.centAmount,
    currency: selectedPrice.totalGross.currencyCode
  }))) : /* @__PURE__ */React14.createElement(Alert2, {
    variant: "dim"
  }, /* @__PURE__ */React14.createElement(FormattedMessage9, {
    id: "checkout.editLineItem.noChanges",
    defaultMessage: "You have not yet made any product changes"
  })), /* @__PURE__ */React14.createElement(Tooltip, {
    placement: "top",
    trigger: /* @__PURE__ */React14.createElement(Button3, {
      as: changedAttributes.length === 0 ? Tooltip.Trigger : "button",
      isLoading: isPending,
      disabled: !selectedPrice || isPending || selectorState !== "idle" || changedAttributes.length === 0,
      onClick: () => __async(void 0, null, function* () {
        setIsPending(true);
        yield onSubmitChanges({
          changedAttributes,
          willRemoveArtwork,
          willRemoveSplitShipment,
          newUserSelection,
          quantity,
          deliveryOptionId: deliveryOption.id
        }, () => {
          setIsPending(false);
        });
      }),
      className: "pd-mt-2 pd-w-full"
    }, /* @__PURE__ */React14.createElement(FormattedMessage9, {
      id: "checkout.editLineItem.submit",
      defaultMessage: "Confirm changes"
    }))
  }, /* @__PURE__ */React14.createElement(FormattedMessage9, {
    id: "checkout.editLineItem.noChangedAttributes",
    defaultMessage: "You have not changed any product attributes yet"
  })));
};
var EditLineItemSummary_default = EditLineItemSummary;

// src/library/components/line-item/edit-line-item/EditLineItemSelector.tsx
import { Panel as Panel5 } from "@printdeal/ui-library";
import { PricesComponent, Selector, getPricePivot, useSelectorMachineContext as useSelectorMachineContext2, SelectVatMode, getAttributes, pricePivotAttributes, getPriceGroups, Pricing, DeliveryOptions } from "@printdeal/product-selector";
import { keyValueObjectToStringArray as keyValueObjectToStringArray2 } from "@printdeal/transformers";
import React15, { useContext as useContext5, useEffect as useEffect7, useState as useState3 } from "react";
import { configurationProvider as configurationProvider3 } from "@printdeal/configuration";

// src/library/queries/line-item/pickup-point/useGetPickupPointQuery.ts
import { useQuery as useQuery3 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication3 } from "@printdeal/authentication";
import axios3 from "axios";
function useGetPickupPointQuery(_ref30) {
  let {
    pickupPointId,
    enabled = true
  } = _ref30;
  const {
    isUserLoggedIn
  } = useAuthentication3();
  return useQuery3({
    queryKey: ["get-pickup-point", pickupPointId],
    queryFn: () => __async(this, null, function* () {
      if (!pickupPointId) {
        throw new Error("No pickup point id provided");
      }
      const response = yield axios3.get("https://proxy.pup.cimpress.io/v1/pickupPoints/".concat(pickupPointId));
      return response.data;
    }),
    enabled: enabled && isUserLoggedIn && Boolean(pickupPointId)
  });
}

// src/library/helpers/PickupPointHelpers.ts
var getPickupPointId = href => {
  const splittedHref = href.split("/v1/pickupPoints/");
  const pickupPointId = splittedHref.pop();
  if (!pickupPointId) {
    throw new Error("Pickup point id not found in href");
  }
  return decodeURIComponent(pickupPointId);
};
var getPickupPointIdFromLineItem = lineItem => {
  var _a;
  let pickupPointInfo;
  if ((_a = lineItem.custom) == null ? void 0 : _a.fields.pickupPoint) {
    [pickupPointInfo] = JSON.parse(lineItem.custom.fields.pickupPoint);
  }
  if (!pickupPointInfo) {
    return void 0;
  }
  return getPickupPointId(pickupPointInfo.href);
};

// src/library/components/line-item/edit-line-item/EditLineItemSelector.tsx
var EditLineItemSelector = _ref31 => {
  let {
    lineItem,
    selector,
    deliveryOptionId
  } = _ref31;
  var _a, _b, _c, _d;
  const {
    customer
  } = useContext5(CheckoutViewContext_default);
  const isSelectionComplete = useSelectorMachineContext2(state => state.matches({
    STARTED: "SELECTION COMPLETE"
  }));
  const selectionMode = useSelectorMachineContext2(state => state.context.selectionMode);
  const price = useSelectorMachineContext2(state => state.context.price);
  const productAttributes = useSelectorMachineContext2(state => state.context.productAttributes);
  const selection = useSelectorMachineContext2(state => state.context.selection);
  const configurationAttributes = useSelectorMachineContext2(state => state.context.attributes);
  const groupSelection = useSelectorMachineContext2(state => state.context.group);
  const shippingAddresses = (_a = lineItem.custom) == null ? void 0 : _a.fields.shippingAddressPerLineItem;
  const pickupPointId = getPickupPointIdFromLineItem(lineItem);
  const pickupPointQuery = useGetPickupPointQuery({
    pickupPointId,
    enabled: Boolean(pickupPointId)
  });
  const isStepByStepSelector = selectionMode === "step-by-step";
  const {
    isPimProduct
  } = selector.product;
  const [shippingAddress, setShippingAddress] = useState3({
    CountryCode: configurationProvider3.getValue("OFFICE_ADDRESS_COUNTRY"),
    PostalCode: configurationProvider3.getValue("OFFICE_ADDRESS_POSTAL_CODE")
  });
  useEffect7(() => {
    let firstShippingAddress;
    if (shippingAddresses) {
      [firstShippingAddress] = shippingAddresses;
    }
    if (firstShippingAddress) {
      const {
        country,
        postalCode
      } = keyValueObjectToStringArray2(firstShippingAddress);
      if (country && postalCode) {
        setShippingAddress({
          CountryCode: country,
          PostalCode: postalCode
        });
      }
    }
  }, [shippingAddresses]);
  useEffect7(() => {
    if (pickupPointQuery.data) {
      const {
        countryCode,
        postalCode
      } = pickupPointQuery.data.address;
      if (countryCode && postalCode) {
        setShippingAddress({
          CountryCode: countryCode,
          PostalCode: postalCode
        });
      }
    }
  }, [pickupPointQuery.data]);
  return /* @__PURE__ */React15.createElement(Panel5, null, /* @__PURE__ */React15.createElement(Selector, {
    productPageId: (_b = lineItem.custom) == null ? void 0 : _b.fields.contentfulPageId,
    selector,
    prefilledSelection: keyValueObjectToStringArray2((_c = lineItem.custom) == null ? void 0 : _c.fields.userSelection),
    shippingAddress,
    customerGroupId: customer == null ? void 0 : customer.customerGroupId,
    deliveryOptionId,
    quantity: lineItem.quantity
  }), isPimProduct && isStepByStepSelector && /* @__PURE__ */React15.createElement("div", {
    className: "pd-flex pd-flex-col pd-gap-4"
  }, /* @__PURE__ */React15.createElement("div", {
    className: "pd-flex pd-justify-end"
  }, /* @__PURE__ */React15.createElement(SelectVatMode, null)), /* @__PURE__ */React15.createElement(Pricing, {
    hasPrefilledSelection: true
  })), isPimProduct && !isStepByStepSelector && /* @__PURE__ */React15.createElement(React15.Fragment, null, /* @__PURE__ */React15.createElement(Pricing, {
    hasPrefilledSelection: true
  }), /* @__PURE__ */React15.createElement(DeliveryOptions, {
    hasPrefilledSelection: true
  })), !isPimProduct && isStepByStepSelector && (isSelectionComplete || price) && /* @__PURE__ */React15.createElement("div", {
    className: "pd-flex pd-flex-col pd-gap-4"
  }, /* @__PURE__ */React15.createElement("div", {
    className: "pd-flex pd-justify-end"
  }, /* @__PURE__ */React15.createElement(SelectVatMode, null)), /* @__PURE__ */React15.createElement(PricesComponent, {
    shippingAddress,
    inventoryCheckEnabled: ((_d = productAttributes.find(_ref32 => {
      let {
        key
      } = _ref32;
      return key === "InventoryCheck";
    })) == null ? void 0 : _d.resolvedValue) === "Yes",
    product: selector.product,
    selectionAttributes: getAttributes(selection, [...pricePivotAttributes, "Quantity"]),
    sort: getPricePivot(configurationAttributes).sort,
    group: getPriceGroups(groupSelection),
    customerGroupId: customer == null ? void 0 : customer.customerGroupId,
    preselectedPriceAttributes: {
      "Printing Process": selection["Printing Process"],
      "Delivery Type": selection["Delivery Type"],
      "Quantity": lineItem.quantity
    }
  })));
};
var EditLineItemSelector_default = EditLineItemSelector;

// src/library/components/line-item/edit-line-item/EditLineItemLockedAttributesAlert.tsx
import { Alert as Alert3, List } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage10 } from "react-intl";
import { getProductVariantVersion as getProductVariantVersion2, isArtworkDelivered as isArtworkDelivered2 } from "@printdeal/business-logic";
import React16, { useEffect as useEffect8, useState as useState4 } from "react";
import { getProductAttribute as getProductAttribute2, useSelectorMachineContext as useSelectorMachineContext3 } from "@printdeal/product-selector";
import { filterRemainingOption } from "@printdeal/checkout-shared";
var EditLineItemLockedAttributesAlert = _ref33 => {
  let {
    lineItem,
    product
  } = _ref33;
  var _a, _b;
  const getSurfaceDependenciesQuery = useGetSurfaceDependenciesQuery({
    productId: (_a = lineItem.custom) == null ? void 0 : _a.fields.mcpSku,
    version: getProductVariantVersion2({
      attributes: (_b = lineItem.variant.attributes) != null ? _b : []
    }).toString(),
    enabled: isArtworkDelivered2(lineItem)
  });
  const selection = useSelectorMachineContext3(state => state.context.selection);
  const [lockedAttributes, setLockedAttributes] = useState4([]);
  const [forceRemoveArtwork, setForceRemoveArtwork] = useState4(false);
  useEffect8(() => {
    if (getSurfaceDependenciesQuery.data) {
      setLockedAttributes(filterRemainingOption(getSurfaceDependenciesQuery.data.remainingOptions, selection));
    }
    if (getSurfaceDependenciesQuery.isError) {
      setLockedAttributes([]);
      setForceRemoveArtwork(true);
    }
  }, [getSurfaceDependenciesQuery, selection]);
  return /* @__PURE__ */React16.createElement(React16.Fragment, null, forceRemoveArtwork && /* @__PURE__ */React16.createElement(Alert3, {
    variant: "warning"
  }, /* @__PURE__ */React16.createElement(FormattedMessage10, {
    id: "checkout.editLineItem.forcedArtworkRemoval",
    defaultMessage: "The artwork you have provided will be removed when you edit this product, to ensure this product will not be produced with invalid artwork."
  })), isArtworkDelivered2(lineItem) && lockedAttributes.length > 0 && /* @__PURE__ */React16.createElement(Alert3, {
    variant: "info"
  }, /* @__PURE__ */React16.createElement("div", {
    className: "pd-grid pd-gap-2"
  }, /* @__PURE__ */React16.createElement(FormattedMessage10, {
    id: "checkout.editLineItem.lockedAttributes",
    defaultMessage: "Due to the design provided, the following options are locked. If you change these options, your design will be lost because the design no longer meets all graphic requirements."
  }), /* @__PURE__ */React16.createElement(List, {
    className: "pd-gap-0"
  }, lockedAttributes.map(attribute => {
    const productAttribute = getProductAttribute2(product.attributes, attribute);
    const attributeName = (productAttribute == null ? void 0 : productAttribute.attributeAlias) || attribute;
    return /* @__PURE__ */React16.createElement(List.Item, {
      key: attribute
    }, attributeName);
  })))));
};
var EditLineItemLockedAttributesAlert_default = EditLineItemLockedAttributesAlert;

// src/library/components/line-item/edit-line-item/EditLineItemContent.tsx
var EditLineItemContent = _ref34 => {
  let {
    lineItem,
    customLineItems,
    onSubmitChanges,
    selector,
    error
  } = _ref34;
  const selectorMachineSend = useSelectorMachineSend();
  const deliveryOptionId = getDeliveryOptionId(customLineItems, lineItem.id);
  return /* @__PURE__ */React17.createElement("div", {
    className: "pd-flex pd-flex-col pd-gap-2"
  }, /* @__PURE__ */React17.createElement(EditLineItemLockedAttributesAlert_default, {
    lineItem,
    product: selector.product
  }), /* @__PURE__ */React17.createElement("div", {
    className: "pd-flex pd-justify-end"
  }, /* @__PURE__ */React17.createElement(LinkAsButton3, {
    variant: "secondary",
    onClick: () => selectorMachineSend({
      type: "Reset machine"
    }),
    iconBefore: "refresh",
    className: "pd-text-sm"
  }, /* @__PURE__ */React17.createElement(FormattedMessage11, {
    id: "checkout.editLineItem.restoreAll",
    defaultMessage: "Restore all"
  }))), /* @__PURE__ */React17.createElement(EditLineItemSelector_default, {
    lineItem,
    selector,
    deliveryOptionId
  }), /* @__PURE__ */React17.createElement(EditLineItemSummary_default, {
    lineItem,
    onSubmitChanges,
    error,
    product: selector.product,
    deliveryOptionId
  }));
};
var EditLineItemContent_default = EditLineItemContent;

// src/library/components/line-item/edit-line-item/EditLineItemModal.tsx
var EditLineItemModal = _ref35 => {
  let {
    lineItem,
    customLineItems,
    isOpen,
    onClose,
    onSubmitChanges,
    error
  } = _ref35;
  var _a, _b, _c;
  const intl = useIntl6();
  const selector = useSelectorContentByPageId({
    productPageId: (_a = lineItem.custom) == null ? void 0 : _a.fields.contentfulPageId,
    locale: intl.locale
  });
  return /* @__PURE__ */React18.createElement(Modal, {
    size: "lg",
    isOpen,
    title: intl.formatMessage({
      id: "checkout.editLineItem",
      defaultMessage: "Edit line item"
    }),
    dismissLabel: intl.formatMessage({
      id: "checkout.editLineItem.closeModal",
      defaultMessage: "Close modal"
    }),
    onClose: () => onClose()
  }, /* @__PURE__ */React18.createElement(Modal.Content, {
    className: "pd-h-[80vh] pd-bg-dim-100"
  }, /* @__PURE__ */React18.createElement(SelectorContextProvider, {
    isPimProduct: (_c = (_b = selector.data) == null ? void 0 : _b.product.isPimProduct) != null ? _c : false
  }, /* @__PURE__ */React18.createElement(PricesContextProvider, null, /* @__PURE__ */React18.createElement(VatModeProvider, null, selector.isError && /* @__PURE__ */React18.createElement(ErrorAlert_default, {
    sentryException: {
      e: "Error loading product selector for edit line item modal",
      tags: {
        fileLocation: "EditLineItemModal.tsx",
        featureFunction: "useSelectorContentByPageId"
      },
      fingerPrint: ["edit-line-item-modal", "product-selector"]
    }
  }, /* @__PURE__ */React18.createElement(FormattedMessage12, {
    id: "checkout.editLineItem.errorLoadingSelector",
    defaultMessage: "Something went wrong while loading the product selector"
  })), selector.data && selector.status === "success" && /* @__PURE__ */React18.createElement(EditLineItemContent_default, {
    customLineItems,
    lineItem,
    onSubmitChanges,
    selector: selector.data,
    error
  }), selector.isPending && /* @__PURE__ */React18.createElement("div", {
    className: "pd-flex pd-h-full pd-items-center pd-justify-center"
  }, /* @__PURE__ */React18.createElement(Spinner2, {
    size: "lg"
  })))))));
};
var EditLineItemModal_default = EditLineItemModal;

// src/library/queries/line-item/useUpdateLineItemMutation.ts
import { useMutation as useMutation7 } from "@tanstack/react-query";
function useUpdateLineItemMutation(_ref36) {
  let {
    context,
    onSuccess
  } = _ref36;
  const {
    cartId,
    setCartData
  } = useCart();
  return useMutation7({
    mutationKey: ["updateLineItem" /* updateLineItem */, context],
    mutationFn: requestData => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cannot update a line item without a cart id");
      }
      if (!requestData.lineItemId) {
        throw new Error("Cannot update a line item without a line item id");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.updateLineItem(cartId, requestData);
      return data;
    }),
    onSuccess: data => {
      setCartData(data);
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    }
  });
}

// src/library/components/line-item/EditLineItemButton.tsx
var EditLineItemButton = _ref37 => {
  let {
    lineItem,
    open,
    onMouseEnter,
    onMouseLeave
  } = _ref37;
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "editLineItem" /* editLineItem */
  });
  const mismatchPrevention = useCartVersionMismatchPrevention4();
  const {
    cart
  } = useCart();
  const [showModal, setShowModal] = useState5(false);
  return /* @__PURE__ */React19.createElement(React19.Fragment, null, /* @__PURE__ */React19.createElement(Button4, {
    variant: "tertiary",
    iconBefore: "edit",
    className: "pd-gap-0",
    onClick: () => setShowModal(true),
    onMouseEnter,
    onMouseLeave,
    disabled: mismatchPrevention.isCartMutationPending
  }, /* @__PURE__ */React19.createElement("div", {
    className: "pd-overflow-hidden pd-transition-[max-width] pd-duration-[1000ms] ".concat(open ? "pd-max-w-[200px]" : "pd-max-w-0")
  }, /* @__PURE__ */React19.createElement("span", {
    className: "pd-ml-2 pd-whitespace-nowrap"
  }, /* @__PURE__ */React19.createElement(FormattedMessage13, {
    id: "checkout.lineItem.edit",
    defaultMessage: "Edit"
  })))), /* @__PURE__ */React19.createElement(EditLineItemModal_default, {
    lineItem,
    customLineItems: cart.customLineItems,
    isOpen: showModal,
    onClose: () => {
      setShowModal(false);
      updateLineItemMutation.reset();
    },
    onSubmitChanges: (_0, _1) => __async(void 0, [_0, _1], function (_ref38, callback) {
      let {
        changedAttributes,
        newUserSelection,
        quantity,
        deliveryOptionId
      } = _ref38;
      return function* () {
        const hasNewQuantity = changedAttributes.find(item => item.attributeName === "Quantity");
        yield updateLineItemMutation.mutateAsync({
          lineItemId: lineItem.id,
          payload: {
            editLineItem: [__spreadValues(__spreadValues(__spreadValues({
              lineItemId: lineItem.id
            }, Object.keys(newUserSelection).length && {
              userSelection: newUserSelection
            }), hasNewQuantity && {
              quantity
            }), deliveryOptionId && {
              shipping: {
                deliveryOptionId
              }
            })]
          }
        }).then(() => setShowModal(false)).finally(callback);
      }();
    }),
    error: updateLineItemMutation.error
  }));
};
var EditLineItemButton_default = EditLineItemButton;

// src/library/components/design-system/line-item/LineItemActions.tsx
var LineItemActions = _ref39 => {
  let {
    lineItem
  } = _ref39;
  var _a, _b;
  const {
    cart,
    expiredQuotesError
  } = useCart();
  const {
    addError,
    removeError
  } = useError();
  const [currentButtonHovered, setCurrentButtonHovered] = useState6(void 0);
  const showEditLineItemButton = Boolean(cart && !isQuoteLineItem(lineItem) && !isLineItemReviewGroupLead(lineItem) && !hasOrchestration(lineItem) && !hasLinkedServices(lineItem.id, cart));
  const isQuoteLineItemExpired = (_a = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a.some(detail => detail.lineItemId === lineItem.id);
  const showDuplicateItemButton = Boolean(!isQuoteLineItemExpired);
  return /* @__PURE__ */React20.createElement("div", {
    className: "pd-absolute pd--top-5 pd-right-4 pd-flex pd-gap-2"
  }, cart && !((_b = lineItem.custom) == null ? void 0 : _b.fields.multipleDesignsSiblings) && /* @__PURE__ */React20.createElement(React20.Fragment, null, showEditLineItemButton && /* @__PURE__ */React20.createElement(EditLineItemButton_default, {
    lineItem,
    open: currentButtonHovered === "copy-edit" || !currentButtonHovered,
    onMouseEnter: () => setCurrentButtonHovered("copy-edit"),
    onMouseLeave: () => setCurrentButtonHovered(void 0)
  }), showDuplicateItemButton && /* @__PURE__ */React20.createElement(DuplicateLineItemButton_default, {
    lineItem,
    open: currentButtonHovered === "copy-edit" || !currentButtonHovered,
    onMouseEnter: () => setCurrentButtonHovered("copy-edit"),
    onMouseLeave: () => setCurrentButtonHovered(void 0),
    onSuccess: (_data, mutationKey) => removeError(mutationKey),
    onError: (error, mutationKey) => addError(mutationKey, error)
  })), /* @__PURE__ */React20.createElement(RemoveLineItemButton_default, {
    lineItem,
    open: currentButtonHovered === "remove",
    onMouseEnter: () => setCurrentButtonHovered("remove"),
    onMouseLeave: () => setCurrentButtonHovered(void 0),
    onSuccess: (_data, mutationKey) => removeError(mutationKey),
    onError: (error, mutationKey) => addError(mutationKey, error)
  }));
};
var LineItemActions_default = LineItemActions;

// src/library/components/design-system/line-item/LineItemPanel.tsx
var LineItemPanel = _ref40 => {
  let {
    lineItem,
    showLineItemActions = true,
    children
  } = _ref40;
  return /* @__PURE__ */React21.createElement(Panel6, {
    className: "pd-p-6 pd-pt-8"
  }, showLineItemActions && /* @__PURE__ */React21.createElement(LineItemActions_default, {
    lineItem
  }), children);
};
var LineItemPanel_default = LineItemPanel;

// src/library/components/design-system/line-item/LineItemTitle.tsx
import { getLineItemQuantity } from "@printdeal/checkout-shared";
import { Heading as Heading4 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage14, useIntl as useIntl7 } from "react-intl";
import { addDataLayerEntry as addDataLayerEntry4 } from "@printdeal/data-layer-manager";
import React22 from "react";

// src/library/helpers/LocaleHelper.ts
var getLocaleCodeFromLocale = locale => locale.slice(0, 2);

// src/library/components/design-system/line-item/LineItemTitle.tsx
var LineItemTitle = _ref41 => {
  let {
    lineItem
  } = _ref41;
  var _a, _b, _c, _d;
  const intl = useIntl7();
  const localizedProductName = (_a = lineItem.custom) == null ? void 0 : _a.fields.localizedProductName;
  const merchandisingProductName = (_b = lineItem.custom) == null ? void 0 : _b.fields.merchandisingProductName;
  const merchProductURL = (_c = lineItem.custom) == null ? void 0 : _c.fields.merchProductURL;
  const lineItemQuantity = getLineItemQuantity(lineItem);
  const quantity = lineItemQuantity && /* @__PURE__ */React22.createElement(FormattedMessage14, {
    id: "checkout.lineItem.quantityCount",
    defaultMessage: "{quantity} {quantity, plural, one {piece} other {pieces}}",
    values: {
      quantity: lineItemQuantity
    }
  });
  const lineItemTitle = /* @__PURE__ */React22.createElement(React22.Fragment, null, (_d = localizedProductName == null ? void 0 : localizedProductName[getLocaleCodeFromLocale(intl.locale)]) != null ? _d : merchandisingProductName, ",", " ", quantity);
  const isUrlValid = url => {
    try {
      new URL(url);
      return true;
    } catch (error) {
      return false;
    }
  };
  if (merchProductURL && isUrlValid(merchProductURL)) {
    const parsedMerchProductURL = new URL(merchProductURL);
    return /* @__PURE__ */React22.createElement(Heading4, {
      as: "h3"
    }, /* @__PURE__ */React22.createElement("a", {
      href: parsedMerchProductURL.href,
      onClick: () => {
        addDataLayerEntry4("click_product");
      }
    }, lineItemTitle));
  }
  return /* @__PURE__ */React22.createElement(Heading4, {
    as: "h3"
  }, lineItemTitle);
};
var LineItemTitle_default = LineItemTitle;

// src/library/components/line-item/quote/ExpiredQuoteBadge.tsx
import { Badge, Root } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage15 } from "react-intl";
import React23 from "react";
var ExpiredQuoteBadge = _ref42 => {
  let {
    lineItemId
  } = _ref42;
  var _a;
  const {
    expiredQuotesError
  } = useCart();
  const isQuoteLineItemExpired = (_a = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a.some(detail => detail.lineItemId === lineItemId);
  return isQuoteLineItemExpired && /* @__PURE__ */React23.createElement(Root, null, /* @__PURE__ */React23.createElement(Badge, {
    variant: "error"
  }, /* @__PURE__ */React23.createElement(FormattedMessage15, {
    id: "cart.messages.expiredQuoteLineItemBadge",
    defaultMessage: "Quote expired"
  })));
};
var ExpiredQuoteBadge_default = ExpiredQuoteBadge;

// src/library/components/design-system/line-item/LineItemPrice.tsx
import { Heading as Heading5 } from "@printdeal/ui-library";
import React24 from "react";
var LineItemPrice = _ref43 => {
  let {
    lineItem
  } = _ref43;
  var _a, _b, _c;
  const {
    cart
  } = useCart();
  const {
    lineItemsTotal
  } = useEntityTotals({
    entity: cart
  });
  const lineItemPrice = lineItemsTotal == null ? void 0 : lineItemsTotal.get(lineItem.id);
  return /* @__PURE__ */React24.createElement(Heading5, {
    as: "h3"
  }, /* @__PURE__ */React24.createElement("div", {
    className: "pd-flex"
  }, /* @__PURE__ */React24.createElement("div", {
    className: "pd-flex pd-items-center pd-gap-2"
  }, /* @__PURE__ */React24.createElement(Money_default, {
    value: (_b = (_a = lineItemPrice == null ? void 0 : lineItemPrice.product) == null ? void 0 : _a.price.totalGross.centAmount) != null ? _b : 0,
    currency: (_c = lineItemPrice == null ? void 0 : lineItemPrice.product) == null ? void 0 : _c.price.totalGross.currencyCode
  }))));
};
var LineItemPrice_default = LineItemPrice;

// src/library/components/design-system/line-item/LineItemDescription.tsx
import { getAttributeDescription } from "@printdeal/business-logic";
import { FormattedMessage as FormattedMessage16, useIntl as useIntl8 } from "react-intl";
import { isLineItemReviewGroupLead as isLineItemReviewGroupLead2 } from "@printdeal/checkout-shared";
import React25, { Fragment } from "react";
import { DescriptionList } from "@printdeal/ui-library";

// src/library/helpers/LineItemHelpers.ts
import { keyValueObjectToStringArray as keyValueObjectToStringArray3 } from "@printdeal/transformers";
var hasTimedDeliveryOnLineItem = lineItem => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.timedDelivery);
};
var hasSplitShipmentOnLineItem = lineItem => {
  var _a;
  const shippingAddressPerLineItem = (_a = lineItem.custom) == null ? void 0 : _a.fields.shippingAddressPerLineItem;
  return Boolean(shippingAddressPerLineItem && shippingAddressPerLineItem.length > 1);
};
var splitAttributeAndValues = localizedDescription => localizedDescription.split(", ").map(attribute => {
  const [attributeName, attributeValue] = attribute.split(": ");
  return {
    attributeName,
    attributeValue
  };
});
function parseShippingAddressPerLineItem(unparsedShippingAddress) {
  return keyValueObjectToStringArray3(unparsedShippingAddress);
}
function getShippingAddressesFromLineItem(lineItem) {
  var _a;
  if (!((_a = lineItem.custom) == null ? void 0 : _a.fields.shippingAddressPerLineItem)) {
    return void 0;
  }
  return lineItem.custom.fields.shippingAddressPerLineItem.map(parseShippingAddressPerLineItem);
}
function isBrochureProduct(lineItem) {
  if (!lineItem.productKey) {
    return false;
  }
  const brochureProducts = ["PRD-AGDTXPWU", "PRD-DBHTSZCB", "PRD-TRGOOXAB"];
  return Boolean(brochureProducts.includes(lineItem.productKey));
}

// src/library/components/design-system/line-item/LineItemDescription.tsx
var LineItemDescription = _ref44 => {
  let {
    lineItem
  } = _ref44;
  var _a;
  const {
    locale
  } = useIntl8();
  const productDescription = getAttributeDescription(lineItem, getLocaleCodeFromLocale(locale));
  const descriptionItems = productDescription && splitAttributeAndValues(productDescription);
  const reviewGroupSiblings = (_a = lineItem.custom) == null ? void 0 : _a.fields.reviewGroupSiblings;
  return /* @__PURE__ */React25.createElement(React25.Fragment, null, descriptionItems ? /* @__PURE__ */React25.createElement(DescriptionList, null, descriptionItems.map(descriptionItem => /* @__PURE__ */React25.createElement(Fragment, {
    key: descriptionItem.attributeName.trim()
  }, /* @__PURE__ */React25.createElement(DescriptionList.Title, null, descriptionItem.attributeName.trim(), ":"), /* @__PURE__ */React25.createElement(DescriptionList.Content, null, descriptionItem.attributeValue)))) : /* @__PURE__ */React25.createElement("div", {
    className: "pd-text-sm"
  }, productDescription), isLineItemReviewGroupLead2(lineItem) && reviewGroupSiblings && reviewGroupSiblings.length > 0 && /* @__PURE__ */React25.createElement("div", {
    className: "pd-mt-3"
  }, reviewGroupSiblings.map(reviewGroupSibling => {
    var _a2;
    const localizedDescription = (_a2 = reviewGroupSibling.custom) == null ? void 0 : _a2.fields.childProductDescription[getLocaleCodeFromLocale(locale)];
    const quantity = reviewGroupSibling.quantity && /* @__PURE__ */React25.createElement("span", null, /* @__PURE__ */React25.createElement(FormattedMessage16, {
      id: "checkout.lineItem.quantityCount",
      defaultMessage: "{quantity} {quantity, plural, one {piece} other {pieces}}",
      values: {
        quantity: reviewGroupSibling.quantity
      }
    }));
    return /* @__PURE__ */React25.createElement("div", {
      className: "pd-text-sm",
      key: localizedDescription
    }, localizedDescription, ",", quantity);
  })));
};
var LineItemDescription_default = LineItemDescription;

// src/library/components/design-system/line-item/LineItemArtwork.tsx
import React26, { useContext as useContext6, useEffect as useEffect9, useState as useState7 } from "react";
import splitOnFirst from "split-on-first";
import { isAlternativeUploadsUrl } from "@printdeal/business-logic";
import axios4 from "axios";
import { Button as Button5, Thumbnail } from "@printdeal/ui-library";
var LineItemArtwork = _ref45 => {
  let {
    lineItem,
    showEditArtwork = false
  } = _ref45;
  var _a, _b, _c;
  const {
    CheckoutPreviewModal,
    CheckoutFileDeliveryButton
  } = useContext6(CheckoutViewContext_default);
  const [showPreview, setShowPreview] = useState7(false);
  const [path, setPath] = useState7(void 0);
  const mcpDocumentsSource = (_a = lineItem.custom) == null ? void 0 : _a.fields.mcpDocumentsSource;
  const documentReference = mcpDocumentsSource && splitOnFirst(mcpDocumentsSource[0], ":")[1];
  const alternativeUploadsUrl = isAlternativeUploadsUrl(lineItem);
  const showPreviewModal = Boolean(!["bespoke", "hybrid"].includes(((_b = lineItem.custom) == null ? void 0 : _b.fields.quoteProductType) || "") && mcpDocumentsSource);
  const onPreviewClick = () => {
    if (showPreviewModal) {
      setShowPreview(true);
    }
  };
  useEffect9(() => {
    const execute = () => __async(void 0, null, function* () {
      var _a2;
      const retrievedPath = documentReference ? "https://previews.cimpress.io/v2/preview?documentReferenceUri=".concat(encodeURIComponent(documentReference), "&width=400") : (_a2 = lineItem.custom) == null ? void 0 : _a2.fields.userUploadsUrl;
      if (retrievedPath) {
        yield axios4.get(retrievedPath);
        setPath(retrievedPath);
      }
    });
    if (documentReference) {
      execute().catch(() => {});
    }
  }, [documentReference, (_c = lineItem.custom) == null ? void 0 : _c.fields.userUploadsUrl]);
  return (documentReference || alternativeUploadsUrl) && /* @__PURE__ */React26.createElement(React26.Fragment, null, /* @__PURE__ */React26.createElement(Thumbnail, {
    size: "lg"
  }, /* @__PURE__ */React26.createElement("img", {
    src: alternativeUploadsUrl || path,
    alt: "Thumbnail"
  }), /* @__PURE__ */React26.createElement("div", {
    className: "pd-relative"
  }, /* @__PURE__ */React26.createElement("div", {
    className: "pd-absolute pd-bottom-0 pd-right-0 pd-mb-2 pd-mr-2"
  }, /* @__PURE__ */React26.createElement("div", {
    className: "pd-flex pd-gap-2"
  }, /* @__PURE__ */React26.createElement(Button5, {
    variant: "secondary",
    iconBefore: "zoom-plus",
    onClick: showPreviewModal ? onPreviewClick : void 0
  }), showEditArtwork && CheckoutFileDeliveryButton && /* @__PURE__ */React26.createElement(CheckoutFileDeliveryButton, {
    lineItem
  }, /* @__PURE__ */React26.createElement(Button5, {
    variant: "secondary",
    iconAfter: "edit",
    type: "submit"
  })))))), showPreviewModal && CheckoutPreviewModal && /* @__PURE__ */React26.createElement(CheckoutPreviewModal, {
    lineItem,
    showPreview,
    setShowPreview
  }));
};
var LineItemArtwork_default = LineItemArtwork;

// src/library/components/design-system/line-item/LineItemServices.tsx
import { Badge as Badge2, CheckboxField, LinkAsButton as LinkAsButton4 } from "@printdeal/ui-library";
import { Experiment as Experiment2, useExperiment } from "@printdeal/feature-management/react";
import { Money as Money2, SupportArticleModal } from "@printdeal/product-selector";
import { FormattedMessage as FormattedMessage17, useIntl as useIntl9 } from "react-intl";
import React27, { useEffect as useEffect10, useMemo as useMemo4, useState as useState9 } from "react";
import { addDataLayerEntry as addDataLayerEntry5 } from "@printdeal/data-layer-manager";
import { getAssociatedGroupedLineItems as getAssociatedGroupedLineItems2 } from "@printdeal/business-logic";

// src/library/queries/line-item/useGetLineItemOptionsQuery.ts
import { useQuery as useQuery4 } from "@tanstack/react-query";
import { useState as useState8 } from "react";
function useGetLineItemOptionsQuery(_ref46) {
  let {
    lineItemId
  } = _ref46;
  const {
    cartId
  } = useCart();
  const [cutOffTime, setCutOffTime] = useState8(null);
  return useQuery4({
    queryKey: ["getShippingOptions" /* getShippingOptions */, lineItemId, cartId],
    queryFn: () => __async(this, null, function* () {
      if (!cartId || !lineItemId) {
        throw new Error("Cannot get shipping options for a lineitem without a cart id and or line item id");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.getLineItemOptions(cartId, lineItemId);
      if (data.cutOffTime) {
        const [hours, minutes, seconds] = data.cutOffTime.split(":").map(time => parseInt(time, 10));
        const cutOffDate = ( /* @__PURE__ */new Date()).setHours(hours, minutes, seconds);
        setCutOffTime(cutOffDate);
      }
      return data;
    }),
    retry: false,
    enabled: Boolean(cartId) && Boolean(lineItemId),
    refetchInterval: cutOffTime ? Math.max(cutOffTime - ( /* @__PURE__ */new Date()).getTime() + 3e4, 0) : false
  });
}

// src/library/components/design-system/line-item/LineItemServices.tsx
var LineItemServices = _ref47 => {
  let {
    lineItem
  } = _ref47;
  const intl = useIntl9();
  const {
    cart
  } = useCart();
  const {
    data
  } = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  const fileServices = useMemo4(() => {
    var _a;
    const services = (_a = data == null ? void 0 : data.services) != null ? _a : [];
    return services.filter(service => {
      var _a2;
      return (_a2 = service.name) == null ? void 0 : _a2.toLowerCase().startsWith("file");
    });
  }, [data == null ? void 0 : data.services]);
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "editLineItem" /* editLineItem */
  });
  const [openedSupport, setOpenedSupportModal] = useState9(void 0);
  const fileServiceFromLineItem = useMemo4(() => {
    var _a, _b;
    return ((_b = (_a = cart == null ? void 0 : cart.customLineItems.find(cl => {
      var _a2, _b2;
      return ((_b2 = (_a2 = cl.custom) == null ? void 0 : _a2.fields.serviceName) == null ? void 0 : _b2.toLowerCase().startsWith("file")) && cl.custom.fields.lineItemReference === lineItem.id;
    })) == null ? void 0 : _a.custom) == null ? void 0 : _b.fields.serviceKey) || void 0;
  }, [cart == null ? void 0 : cart.customLineItems]);
  const [serviceChecked, setServiceChecked] = useState9(fileServiceFromLineItem);
  const {
    experiment: exp1835Data
  } = useExperiment("servicesprouts_exp1835_explain_what_file_check_does_in_cart");
  const isExp1835Variant = exp1835Data.variation === "variant";
  useEffect10(() => {
    if (fileServiceFromLineItem) {
      addDataLayerEntry5("line_item_has_service");
    }
  }, [fileServiceFromLineItem]);
  const handleSetService = (event, service) => {
    var _a;
    const {
      checked
    } = event.target;
    const lineItems = [lineItem];
    setServiceChecked(checked ? service.serviceKey : void 0);
    const servicesPayload = checked ? [service.serviceKey] : [];
    if (service.name === "File Check") {
      addDataLayerEntry5("file_check_in_cart", {
        previousValue: !checked,
        newValue: checked,
        serviceKey: service.serviceKey,
        design_choice: checked ? "manual_file_check_selected" : "manual_file_check_de_selected"
      });
    } else {
      addDataLayerEntry5("line_item_service_clicked", {
        previousValue: !checked,
        newValue: checked,
        service: service.serviceKey
      });
    }
    if ((_a = lineItem.custom) == null ? void 0 : _a.fields.multipleDesignsGroup) {
      lineItems.push(...getAssociatedGroupedLineItems2(cart, lineItem));
    }
    updateLineItemMutation.mutateAsync({
      lineItemId: lineItem.id,
      payload: {
        editLineItem: lineItems.map(_ref48 => {
          let {
            id: lineItemId
          } = _ref48;
          return {
            lineItemId,
            services: servicesPayload
          };
        })
      }
    }).catch(() => {
      setServiceChecked(fileServiceFromLineItem);
    });
  };
  const handleSupportModalClose = service => {
    setOpenedSupportModal(void 0);
    if (service.name === "File Check") {
      addDataLayerEntry5("file_check_in_cart", {
        previousValue: false,
        newValue: true,
        serviceKey: service.serviceKey,
        design_choice: "manual_file_check_more_info_closed"
      });
    } else {
      addDataLayerEntry5("line_item_service_support_modal_closed");
    }
  };
  const handleSupportModalOpen = (event, service) => {
    event.preventDefault();
    setOpenedSupportModal(service);
    if (service.name === "File Check") {
      addDataLayerEntry5("file_check_in_cart", {
        previousValue: false,
        newValue: true,
        serviceKey: service.serviceKey,
        design_choice: "manual_file_check_more_info_opened"
      });
    } else {
      addDataLayerEntry5("line_item_service_support_modal_opened");
    }
  };
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, fileServices.length ? /* @__PURE__ */React27.createElement("hr", {
    className: "pd-mt-3"
  }) : null, fileServices.map(service => {
    var _a;
    return /* @__PURE__ */React27.createElement("div", {
      className: "pd-mt-3",
      key: "".concat(lineItem.id, "-").concat(service.serviceKey)
    }, /* @__PURE__ */React27.createElement(CheckboxField, {
      disabled: isBrochureProduct(lineItem) || updateLineItemMutation.isPending,
      checked: serviceChecked === service.serviceKey,
      onChange: event => handleSetService(event, service),
      name: "artwork-service",
      id: "".concat(lineItem.id, "-").concat(service.serviceKey),
      variant: "multiline",
      badge: /* @__PURE__ */React27.createElement(Experiment2, {
        id: "cash_it_exp1756_increase_file_check_certainty_in_check-out"
      }, /* @__PURE__ */React27.createElement(Experiment2.Variant, null, /* @__PURE__ */React27.createElement(Badge2, {
        variant: "success"
      }, /* @__PURE__ */React27.createElement(FormattedMessage17, {
        id: "services.label.errorFreeDesign",
        defaultMessage: "Error Free Design Guaranteed"
      })))),
      label: /* @__PURE__ */React27.createElement("div", {
        className: "pd-flex pd-items-center"
      }, /* @__PURE__ */React27.createElement("span", null, service.displayName[getLocaleCodeFromLocale(intl.locale)]), service.prices.totalGross.centAmount > 0 && /* @__PURE__ */React27.createElement("span", {
        className: "pd-ml-2 pd-whitespace-nowrap"
      }, "( +", /* @__PURE__ */React27.createElement(Money2, {
        value: service.prices.totalNet.centAmount,
        currency: service.prices.totalNet.currencyCode
      }), ")")),
      description: isExp1835Variant && service.shortDescription[getLocaleCodeFromLocale(intl.locale)] ? /* @__PURE__ */React27.createElement("p", {
        className: "pd-text-dim-500"
      }, service.shortDescription[getLocaleCodeFromLocale(intl.locale)]) : null,
      secondaryAction: service.supportArticleId && /* @__PURE__ */React27.createElement(LinkAsButton4, {
        variant: "secondary",
        onClick: event => handleSupportModalOpen(event, service),
        iconBefore: "info",
        screenReaderLabel: intl.formatMessage({
          id: "service.".concat((_a = service.name) == null ? void 0 : _a.toLowerCase().replace(" ", ""), ".secondaryAction.screenReaderLabel"),
          defaultMessage: "More Information"
        })
      })
    }), /* @__PURE__ */React27.createElement(SupportArticleModal, {
      show: (openedSupport == null ? void 0 : openedSupport.serviceKey) === service.serviceKey,
      onClose: () => handleSupportModalClose(service),
      supportArticleId: service.supportArticleId
    }));
  }));
};
var LineItemServices_default = LineItemServices;

// src/library/components/design-system/checkout/cart-page/CartLineItems.tsx
var CartLineItems = _ref49 => {
  let {
    lineItem
  } = _ref49;
  return /* @__PURE__ */React28.createElement(LineItemPanel_default, {
    key: lineItem.id,
    lineItem
  }, /* @__PURE__ */React28.createElement(CheckoutDevOnly_default, {
    className: "pd-my-2",
    jsonObject: {
      lineItemId: lineItem.id
    }
  }), /* @__PURE__ */React28.createElement("div", {
    className: "pd-mb-3 pd-flex pd-justify-between pd-gap-4"
  }, /* @__PURE__ */React28.createElement(LineItemTitle_default, {
    lineItem
  }), /* @__PURE__ */React28.createElement(LineItemPrice_default, {
    lineItem
  })), /* @__PURE__ */React28.createElement("div", {
    className: "pd-flex pd-justify-between pd-gap-4"
  }, /* @__PURE__ */React28.createElement("div", null, /* @__PURE__ */React28.createElement(ExpiredQuoteBadge_default, {
    lineItemId: lineItem.id
  }), /* @__PURE__ */React28.createElement(LineItemDescription_default, {
    lineItem
  })), /* @__PURE__ */React28.createElement(LineItemArtwork_default, {
    lineItem,
    showEditArtwork: true
  })), !isBrochureProduct(lineItem) ? /* @__PURE__ */React28.createElement(LineItemServices_default, {
    lineItem,
    key: lineItem.id
  }) : /* @__PURE__ */React28.createElement(Experiment3, {
    id: "exp1692_alternative_upload_file_check_pdp"
  }, /* @__PURE__ */React28.createElement(Experiment3.Variant, null, /* @__PURE__ */React28.createElement(LineItemServices_default, {
    lineItem,
    key: lineItem.id
  }))));
};
var CartLineItems_default = CartLineItems;

// src/library/components/cart/quote/ExpiredQuotesValidator.tsx
import { Root as Root2 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage18 } from "react-intl";
import React29 from "react";
var ExpiredQuotesValidator = () => {
  var _a;
  const {
    expiredQuotesError
  } = useCart();
  return ((_a = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a.length) && /* @__PURE__ */React29.createElement(Root2, null, /* @__PURE__ */React29.createElement(ErrorAlert_default, {
    sentryException: void 0
  }, /* @__PURE__ */React29.createElement(FormattedMessage18, {
    id: "cart.messages.containsExpiredQuotes",
    defaultMessage: "Your cart contains expired quotes. Please review your cart and remove any expired quotes, before continuing with your order."
  })));
};
var ExpiredQuotesValidator_default = ExpiredQuotesValidator;

// src/library/components/design-system/payment-methods/PaymentMethodIconGrid.tsx
import { Brand as Brand3 } from "@printdeal/ui-library";
import { configurationProvider as configurationProvider4 } from "@printdeal/configuration";
import React30 from "react";
var PaymentMethodIconGrid = () => {
  const defaultPaymentMethods = configurationProvider4.getValueAsArray("DEFAULT_PAYMENT_METHODS");
  if (!defaultPaymentMethods.length) {
    return void 0;
  }
  return /* @__PURE__ */React30.createElement("div", {
    className: "pd-flex pd-justify-center pd-gap-4"
  }, defaultPaymentMethods.map(paymentMethod => /* @__PURE__ */React30.createElement(Brand3, {
    brand: paymentMethod,
    key: paymentMethod,
    className: "pd-h-7"
  })));
};
var PaymentMethodIconGrid_default = PaymentMethodIconGrid;

// src/library/components/cart/quote/CreateQuoteFromCartButton.tsx
import React31, { useEffect as useEffect11, useMemo as useMemo5 } from "react";
import { LinkAsButton as LinkAsButton5 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage19 } from "react-intl";
import { useCartVersionMismatchPrevention as useCartVersionMismatchPrevention5 } from "@printdeal/checkout-shared/dist/frontend";
import { useAuthentication as useAuthentication5 } from "@printdeal/authentication";
import { addDataLayerEntry as addDataLayerEntry6 } from "@printdeal/data-layer-manager";

// src/library/queries/quote/useCreateQuoteFromCartMutation.ts
import { useMutation as useMutation8 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication4 } from "@printdeal/authentication";

// src/library/http-clients/QuotesHttpClient.ts
import axios5 from "axios";
import { configurationProvider as configurationProvider5 } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor as authenticateHttpRequestInterceptor3 } from "@printdeal/authentication";
var QuoteHttpClient = class {
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider5.getValue("QUOTES_API_BASE_URL");
      this.httpClient = axios5.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor3);
    }
    return this.httpClient;
  }
  createQuoteFromCart(payload) {
    return __async(this, null, function* () {
      return this.client.post("/quotes/cart-as-quote", payload);
    });
  }
  getExpiredQuotes(cartId) {
    return __async(this, null, function* () {
      return this.client.get("/quotes/validate-cart/".concat(cartId));
    });
  }
  getQuote(quoteId) {
    return __async(this, null, function* () {
      return this.client.get("quotes/".concat(quoteId));
    });
  }
};
var quoteHttpClient = new QuoteHttpClient();
var QuotesHttpClient_default = quoteHttpClient;

// src/library/queries/quote/useCreateQuoteFromCartMutation.ts
function useCreateQuoteFromCartMutation(_ref50) {
  let {
    onSuccess
  } = _ref50;
  const {
    isUserLoggedIn
  } = useAuthentication4();
  return useMutation8({
    mutationKey: ["create-quote-from-cart"],
    mutationFn: requestData => {
      if (!isUserLoggedIn) {
        throw new Error("Cannot create quote from cart when not logged in");
      }
      return QuotesHttpClient_default.createQuoteFromCart(requestData);
    },
    onSuccess: quoteResponse => {
      if (typeof onSuccess === "function") {
        onSuccess(quoteResponse.data);
      }
    }
  });
}

// src/library/components/cart/quote/CreateQuoteFromCartButton.tsx
var CreateQuoteFromCartButton = _ref51 => {
  let {
    onSuccess
  } = _ref51;
  const {
    cartId
  } = useCart();
  const {
    isCartMutationPending
  } = useCartVersionMismatchPrevention5();
  const createQuoteFromCartMutation = useCreateQuoteFromCartMutation({
    onSuccess
  });
  const {
    decodedToken,
    isUserLoggedIn
  } = useAuthentication5();
  const shouldDisableMutation = useMemo5(() => !cartId || !isUserLoggedIn || isCartMutationPending || createQuoteFromCartMutation.isPending, [cartId, isCartMutationPending, createQuoteFromCartMutation.isPending, isUserLoggedIn]);
  useEffect11(() => {
    if (createQuoteFromCartMutation.isSuccess) {
      addDataLayerEntry6("save_cart");
    }
  }, [createQuoteFromCartMutation.isSuccess]);
  const handleOnClick = event => {
    event.preventDefault();
    if (shouldDisableMutation) {
      return;
    }
    createQuoteFromCartMutation.mutate({
      cartId,
      quoteAcquisitionChannel: {
        source: "launchpad",
        referrer_url: window.location.href,
        // this is the user account id
        source_agent: decodedToken.account.id
      }
    });
  };
  return /* @__PURE__ */React31.createElement("div", {
    className: "pd-flex pd-w-full pd-flex-col pd-gap-2"
  }, createQuoteFromCartMutation.isError && /* @__PURE__ */React31.createElement(ErrorAlert_default, {
    sentryException: {
      e: createQuoteFromCartMutation.error,
      tags: {
        fileLocation: "CreateQuoteFromCartButton",
        featureFunction: "CreateQuoteFromCartButton"
      },
      fingerPrint: ["checkout", "create-quote-from-cart"]
    }
  }, /* @__PURE__ */React31.createElement(FormattedMessage19, {
    id: "cart.messages.createQuoteFailed",
    defaultMessage: "Failed to create quote"
  })), /* @__PURE__ */React31.createElement(LinkAsButton5, {
    iconBefore: createQuoteFromCartMutation.isPending ? void 0 : "save",
    onClick: handleOnClick,
    variant: "secondary",
    disabled: shouldDisableMutation,
    className: "pd-text-sm",
    isLoading: createQuoteFromCartMutation.isPending
  }, /* @__PURE__ */React31.createElement(FormattedMessage19, {
    id: "cart.saveShoppingCartAsQuotation",
    defaultMessage: "Save cart as quote"
  })));
};
var CreateQuoteFromCartButton_default = CreateQuoteFromCartButton;

// src/library/components/design-system/checkout/CheckoutHeading.tsx
import { getMainLineItems as getMainLineItems2 } from "@printdeal/checkout-shared";
import { Heading as Heading6 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage20 } from "react-intl";
import React32 from "react";
var CheckoutHeading = _ref52 => {
  let {
    pageTitle,
    showTotalProducts = false
  } = _ref52;
  var _a;
  const {
    cart
  } = useCart();
  const {
    entityTotal
  } = useEntityTotals({
    entity: cart
  });
  const cartQuery = useGetCartQuery();
  return /* @__PURE__ */React32.createElement("div", {
    className: "pd-mb-5"
  }, /* @__PURE__ */React32.createElement(Heading6, {
    as: "h1",
    className: "pd-inline-block"
  }, pageTitle), showTotalProducts && cart && getMainLineItems2(cart).length > 0 && !cartQuery.isError && /* @__PURE__ */React32.createElement("div", {
    className: "pd-ml-4 pd-inline-block pd-text-xs"
  }, "(", /* @__PURE__ */React32.createElement(FormattedMessage20, {
    id: "checkout.totalProducts",
    defaultMessage: "{count} {count, plural, one {product} other {products}}",
    values: {
      count: getMainLineItems2(cart).length
    }
  }), "\xA0\u2014\xA0", /* @__PURE__ */React32.createElement(Money_default, {
    value: (_a = entityTotal == null ? void 0 : entityTotal.totalPrice.totalGross.centAmount) != null ? _a : 0,
    currency: entityTotal == null ? void 0 : entityTotal.totalPrice.totalGross.currencyCode
  }), ")"));
};
var CheckoutHeading_default = CheckoutHeading;

// src/library/hooks/payment/usePrefetchedPaymentMethodsForCart.ts
import { useQueryClient as useQueryClient2 } from "@tanstack/react-query";
import { useEffect as useEffect12 } from "react";
import { useAuthentication as useAuthentication6 } from "@printdeal/authentication";

// src/library/http-clients/PaymentHttpClient.ts
import axios6 from "axios";
import { configurationProvider as configurationProvider6 } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor as authenticateHttpRequestInterceptor4 } from "@printdeal/authentication";
var PaymentHttpClient = class {
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider6.getValue("PAYMENT_V2_API_BASE_URL");
      this.httpClient = axios6.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor4);
    }
    return this.httpClient;
  }
  getPaymentMethodsForCart(cartId) {
    let psp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "buckaroo";
    return __async(this, null, function* () {
      return this.client.get("/api/payments/methods", {
        params: {
          cartId,
          psp
        },
        headers: {
          // Disable API gateway caching, caching will be done by react query
          "Cache-Control": "max-age=0"
        }
      });
    });
  }
};
var paymentHttpClient = new PaymentHttpClient();
var PaymentHttpClient_default = paymentHttpClient;

// src/library/hooks/payment/usePrefetchedPaymentMethodsForCart.ts
function usePrefetchedPaymentMethodsForCart() {
  const {
    isUserLoggedIn
  } = useAuthentication6();
  const {
    cartId,
    cart
  } = useCart();
  const queryClient = useQueryClient2();
  useEffect12(() => {
    const prefetch = () => __async(this, null, function* () {
      if (isUserLoggedIn && Boolean(cartId)) {
        yield queryClient.prefetchQuery({
          queryKey: ["paymentMethodsForCart", cartId],
          queryFn: () => __async(this, null, function* () {
            if (!cartId) {
              throw new Error("Cannot get payment methods without cartId");
            }
            const {
              data
            } = yield PaymentHttpClient_default.getPaymentMethodsForCart(cartId);
            return data;
          })
        });
      }
    });
    prefetch().catch(() => {});
  }, [isUserLoggedIn, cartId, queryClient, cart == null ? void 0 : cart.totalPrice.centAmount]);
}

// src/library/components/design-system/checkout/cart-page/CartNotifications.tsx
import { FormattedMessage as FormattedMessage21 } from "react-intl";
import React33, { useEffect as useEffect13, useRef as useRef2 } from "react";
import { addDataLayerEntry as addDataLayerEntry7 } from "@printdeal/data-layer-manager";
import { Alert as Alert4 } from "@printdeal/ui-library";
var CartNotifications = () => {
  const {
    notifications,
    resetNotifications
  } = useCart();
  const hasMountedLongEnoughToResetNotifications = useRef2(false);
  useEffect13(() => {
    if (notifications.has("retrievedCartDuringLogin" /* retrievedCartDuringLogin */)) {
      addDataLayerEntry7("retrieved_cart_alert");
    }
    if (notifications.has("mergedCartDuringLogin" /* mergedCartDuringLogin */)) {
      addDataLayerEntry7("merged_cart_alert_view");
    }
    const timeout = setTimeout(() => {
      hasMountedLongEnoughToResetNotifications.current = true;
    }, 1e3);
    return () => {
      if (hasMountedLongEnoughToResetNotifications.current) {
        resetNotifications();
      } else {
        clearTimeout(timeout);
      }
    };
  }, [notifications]);
  return /* @__PURE__ */React33.createElement(React33.Fragment, null, notifications.has("retrievedCartDuringLogin" /* retrievedCartDuringLogin */) && /* @__PURE__ */React33.createElement(Alert4, {
    variant: "warning",
    isDismissible: true
  }, /* @__PURE__ */React33.createElement(FormattedMessage21, {
    id: "cart.notification.retrievedCart",
    defaultMessage: "You still had some products in your cart from your last visit. For easy shopping, these products have been added again."
  })), notifications.has("mergedCartDuringLogin" /* mergedCartDuringLogin */) && /* @__PURE__ */React33.createElement(Alert4, {
    variant: "warning",
    isDismissible: true
  }, /* @__PURE__ */React33.createElement(FormattedMessage21, {
    id: "cart.notification.mergedCart",
    defaultMessage: "You still had some products in your cart from your last visit. We added these to the products currently in your cart."
  })));
};
var CartNotifications_default = CartNotifications;

// src/library/components/design-system/checkout/layout/CheckoutStepper.tsx
import { Stepper as Stepper2 } from "@printdeal/ui-library";
import { useAuthentication as useAuthentication7 } from "@printdeal/authentication";
import React35, { useContext as useContext8 } from "react";
import { FormattedMessage as FormattedMessage22 } from "react-intl";

// src/library/components/design-system/checkout/layout/CheckoutStepperItem.tsx
import React34, { useContext as useContext7 } from "react";
import { LinkAsButton as LinkAsButton6, Stepper } from "@printdeal/ui-library";
var CheckoutStepperItem = _ref53 => {
  let {
    children,
    to,
    state,
    active = false,
    completed = false,
    firstItem = false
  } = _ref53;
  const {
    navigate
  } = useContext7(CheckoutViewContext_default);
  const handleClick = () => {
    if (to) {
      navigate(to, {
        state
      }).catch(() => {});
    }
  };
  const completedVariant = completed ? "success" : "default";
  return /* @__PURE__ */React34.createElement(React34.Fragment, null, !firstItem && /* @__PURE__ */React34.createElement(Stepper.Edge, {
    variant: completed ? "success" : "default"
  }), /* @__PURE__ */React34.createElement(LinkAsButton6, {
    onClick: handleClick,
    className: "pd-cursor-pointer"
  }, /* @__PURE__ */React34.createElement(Stepper.Node, {
    variant: active ? "primary" : completedVariant
  }, /* @__PURE__ */React34.createElement("span", null, children))));
};
var CheckoutStepperItem_default = CheckoutStepperItem;

// src/library/components/design-system/checkout/layout/CheckoutStepper.tsx
var checkoutSteps = ["cart", "login", "delivery", "paymentMethod"];
var CheckoutStepper = () => {
  const {
    isUserLoggedIn
  } = useAuthentication7();
  const {
    paths,
    location
  } = useContext8(CheckoutViewContext_default);
  const getStepperItemProps = step => {
    const checkoutStepPathMap = {
      cart: "cartPage",
      login: "loginPage",
      delivery: "deliveryPage",
      paymentMethod: "paymentMethodPage"
    };
    const stepPath = paths[checkoutStepPathMap[step]].path;
    const active = location ? location.toLowerCase().includes(stepPath.toLowerCase()) : false;
    const activeStepIndex = checkoutSteps.findIndex(checkoutStep => {
      const {
        path
      } = paths[checkoutStepPathMap[checkoutStep]];
      return location == null ? void 0 : location.toLowerCase().includes(path.toLowerCase());
    });
    const completed = checkoutSteps.indexOf(step) < activeStepIndex || active && step !== "cart";
    if (checkoutSteps.indexOf(step) >= checkoutSteps.indexOf("login") && !isUserLoggedIn) {
      return {
        step,
        active,
        completed,
        to: paths.loginPage.path,
        state: {
          redirectUrl: step === "login" ? paths.cartPage.path : stepPath
        }
      };
    }
    return {
      step,
      active,
      completed,
      to: stepPath
    };
  };
  return /* @__PURE__ */React35.createElement("div", {
    className: "pd-grid pd-grid-cols-6 pd-py-6"
  }, /* @__PURE__ */React35.createElement(Stepper2, {
    className: "pd-col-span-4 pd-col-start-2"
  }, /* @__PURE__ */React35.createElement(React35.Fragment, null, /* @__PURE__ */React35.createElement(CheckoutStepperItem_default, __spreadProps(__spreadValues({}, getStepperItemProps("cart")), {
    firstItem: true
  }), /* @__PURE__ */React35.createElement(FormattedMessage22, {
    id: "checkout.navBar.cart",
    defaultMessage: "Cart"
  })), !isUserLoggedIn && /* @__PURE__ */React35.createElement(CheckoutStepperItem_default, __spreadValues({}, getStepperItemProps("login")), /* @__PURE__ */React35.createElement(FormattedMessage22, {
    id: "checkout.navBar.login.personalDetails",
    defaultMessage: "Personal details"
  })), /* @__PURE__ */React35.createElement(CheckoutStepperItem_default, __spreadValues({}, getStepperItemProps("delivery")), /* @__PURE__ */React35.createElement(FormattedMessage22, {
    id: "checkout.navBar.delivery",
    defaultMessage: "Delivery"
  })), /* @__PURE__ */React35.createElement(CheckoutStepperItem_default, __spreadValues({}, getStepperItemProps("paymentMethod")), /* @__PURE__ */React35.createElement(FormattedMessage22, {
    id: "checkout.navBar.paymentMethod",
    defaultMessage: "Payment method"
  })))));
};
var CheckoutStepper_default = CheckoutStepper;

// src/library/views/CartView.tsx
var CartView = () => {
  const intl = useIntl10();
  const {
    isUserLoggedIn
  } = useAuthentication8();
  const {
    cart: cartObject
  } = useCart();
  const {
    navigate,
    paths
  } = useContext9(CheckoutViewContext_default);
  usePrefetchedPaymentMethodsForCart();
  usePrefetchAddresses();
  useEffect14(() => {
    EcommerceObjectHelper.clearEcommerceObject();
    addDataLayerEntry8("view_cart", EcommerceObjectHelper.createEcommerceObject(cartObject));
  }, [cartObject]);
  return /* @__PURE__ */React36.createElement(Container, {
    className: "pd-py-6"
  }, /* @__PURE__ */React36.createElement(CheckoutStepper_default, null), /* @__PURE__ */React36.createElement(CheckoutHeading_default, {
    pageTitle: intl.formatMessage({
      id: "checkout.cartView.title",
      defaultMessage: "Cart"
    }),
    showTotalProducts: true
  }), /* @__PURE__ */React36.createElement(CartQuery_default, null, cart => {
    const lineItems = getMainLineItems3(cart);
    return /* @__PURE__ */React36.createElement("div", {
      className: "pd-grid pd-grid-cols-3 pd-items-start pd-gap-4"
    }, /* @__PURE__ */React36.createElement("div", {
      className: "pd-col-span-3 md:pd-col-span-2"
    }, /* @__PURE__ */React36.createElement("div", {
      className: "pd-grid pd-gap-4"
    }, /* @__PURE__ */React36.createElement(CheckoutDevOnly_default, {
      jsonObject: {
        cartId: cart.id,
        cartVersion: cart.version
      }
    }), /* @__PURE__ */React36.createElement(CartErrorNotifications_default, {
      fileLocation: "CartView.tsx"
    }), /* @__PURE__ */React36.createElement(CartNotifications_default, null), /* @__PURE__ */React36.createElement(ExpiredQuotesValidator_default, null), /* @__PURE__ */React36.createElement(Alert5, {
      className: "pd-mb-5"
    }, /* @__PURE__ */React36.createElement(FormattedMessage23, {
      id: "checkout.uploadYourFilesAfterPlacingOrder",
      defaultMessage: "You can upload your missing files after you placed your order."
    })), /* @__PURE__ */React36.createElement("div", {
      className: "pd-grid pd-gap-10"
    }, lineItems.map(lineItem => /* @__PURE__ */React36.createElement(CartLineItems_default, {
      key: lineItem.id,
      lineItem
    }))))), /* @__PURE__ */React36.createElement("div", {
      className: "pd-sticky pd-top-3 pd-col-span-3 pd-flex pd-flex-col pd-gap-4 md:pd-col-span-1"
    }, /* @__PURE__ */React36.createElement("div", {
      className: "pd-order-1 md:pd-order-none"
    }, /* @__PURE__ */React36.createElement(CheckoutSummary_default, {
      isKiyohEnabled: true,
      nextStepButton: /* @__PURE__ */React36.createElement(Button6, {
        className: "pd-w-full",
        iconAfter: "chevron-right",
        "data-cy": "nextStepButton",
        onClick: () => {
          navigate(paths.deliveryPage.path).catch(() => {});
          addDataLayerEntry8("cart_next");
        }
      }, isUserLoggedIn ? /* @__PURE__ */React36.createElement(FormattedMessage23, {
        id: "checkout.nextStepToDelivery",
        defaultMessage: "To delivery"
      }) : /* @__PURE__ */React36.createElement(FormattedMessage23, {
        id: "checkout.nextStepToLogin",
        defaultMessage: "To login"
      }))
    })), /* @__PURE__ */React36.createElement(CheckoutDevOnly_default, {
      className: "pd-order-none md:pd-order-1"
    }, /* @__PURE__ */React36.createElement(DeleteCartButton_default, null)), isUserLoggedIn && /* @__PURE__ */React36.createElement(StoreToggle2, {
      id: "drukwerkdeal-nl_printdeal-be"
    }, /* @__PURE__ */React36.createElement(StoreToggle2.Enabled, null, /* @__PURE__ */React36.createElement(Panel7, {
      className: "pd-order-none pd-flex pd-p-4 md:pd-order-1"
    }, /* @__PURE__ */React36.createElement(CreateQuoteFromCartButton_default, {
      onSuccess: _ref54 => {
        let {
          quoteId,
          success
        } = _ref54;
        navigate("".concat(paths.accountDashboardPage.path, "/quoting/").concat(quoteId, "?quoteCreated=").concat(success)).catch(() => {});
      }
    })))), /* @__PURE__ */React36.createElement("div", {
      className: "pd-order-1"
    }, /* @__PURE__ */React36.createElement(PaymentMethodIconGrid_default, null))));
  }));
};
var CartView_default = CartView;

// src/library/components/context-providers/cart/CartProvider.tsx
import React37, { useCallback, useEffect as useEffect15, useMemo as useMemo6, useState as useState10 } from "react";
import { useMutation as useMutation9, useQuery as useQuery6, useQueryClient as useQueryClient3 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication9 } from "@printdeal/authentication";
import { CartChangeAfterLogin, getVisibleCartChangeAfterLogin } from "@printdeal/checkout-shared";
import { ErrorManagement as ErrorManagement4 } from "@printdeal/error-management/react";

// src/library/queries/quote/useGetExpiredQuotesQuery.ts
import { useQuery as useQuery5 } from "@tanstack/react-query";
function useGetExpiredQuotesQuery(condition, cartId) {
  return useQuery5({
    queryKey: ["getExpiredQuotes", cartId],
    queryFn: () => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cannot get expired quotes when there is no cart id");
      }
      const {
        data
      } = yield QuotesHttpClient_default.getExpiredQuotes(cartId);
      return data;
    }),
    retry: false,
    enabled: Boolean(cartId) && condition
  });
}

// src/library/components/context-providers/cart/CartProvider.tsx
var localStorageKey = "cartId";
function getCartIdFromLocalStorage() {
  if (typeof window !== "undefined") {
    return window.localStorage.getItem(localStorageKey) || void 0;
  }
  return void 0;
}
function setCartIdInLocalStorage(cartId) {
  if (typeof window !== "undefined") {
    if (cartId) {
      window.localStorage.setItem(localStorageKey, cartId);
    } else {
      window.localStorage.removeItem(localStorageKey);
    }
  }
}
var CartProvider = _ref55 => {
  let {
    children,
    cartId: cartIdProp
  } = _ref55;
  var _a, _b, _c;
  const authenticationService = useAuthentication9();
  const [errors, setErrors] = useState10( /* @__PURE__ */new Map());
  const [notifications, setNotifications] = useState10( /* @__PURE__ */new Map());
  const [hasQuotes, setHasQuotes] = useState10(false);
  const [lastValidatedCartVersion, setLastValidatedCartVersion] = useState10(void 0);
  const [expiredQuotesError, setExpiredQuotesError] = useState10(void 0);
  const [cartId, setCartIdInState] = useState10(cartIdProp || getCartIdFromLocalStorage());
  const [cartAfterLogin, setCartAfterLogin] = useState10(void 0);
  const queryKey = "getCart" /* getCart */;
  function setCartIdInStateAndLocalStorage(newCartId) {
    setCartIdInState(newCartId);
    setCartIdInLocalStorage(newCartId);
  }
  const addError = (key, error) => {
    setErrors(previousErrors => new Map(previousErrors).set(key, {
      error
    }));
  };
  const removeError = key => {
    setErrors(previousErrors => {
      const newErrors = new Map(previousErrors);
      newErrors.delete(key);
      return newErrors;
    });
  };
  const removeAllErrors = () => {
    setErrors( /* @__PURE__ */new Map());
  };
  const addNotification = key => {
    setNotifications(previousNotifications => new Map(previousNotifications).set(key, true));
  };
  const removeNotification = key => {
    setNotifications(previousNotifications => {
      const newNotifications = new Map(previousNotifications);
      newNotifications.delete(key);
      return newNotifications;
    });
  };
  const resetNotifications = () => {
    setNotifications( /* @__PURE__ */new Map());
  };
  const queryClient = useQueryClient3();
  const cartQuery = useQuery6({
    queryKey: [queryKey, cartId],
    queryFn: () => __async(void 0, null, function* () {
      if (!cartId) {
        throw new Error("Cannot get cart without a cart id");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.getCart(cartId);
      return data;
    }),
    enabled: Boolean(cartId)
  });
  const cartVersion = cartId ? (_a = cartQuery.data) == null ? void 0 : _a.version : void 0;
  const cart = cartId ? cartQuery.data : void 0;
  const invalidateCart = useCallback(() => {
    const execute = () => __async(void 0, null, function* () {
      yield queryClient.invalidateQueries({
        queryKey: [queryKey, cartId]
      });
    });
    execute().catch(() => {});
  }, [queryClient, queryKey, cartId]);
  const setCartData = useCallback(data => {
    queryClient.setQueryData([queryKey, data.id], data);
    setCartIdInStateAndLocalStorage(data.id);
  }, [queryClient, queryKey]);
  const locallyRemoveCart = useCallback(() => {
    setCartIdInStateAndLocalStorage(void 0);
    resetNotifications();
  }, []);
  const recalculateCartMutation = useMutation9({
    mutationKey: ["recalculateCart" /* recalculateCart */],
    mutationFn: id => __async(void 0, null, function* () {
      if (!id) {
        throw new Error("Cart cannot be recalculated without a cartId");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.patchCart(id, {
        action: {
          name: "recalculateCart"
        }
      });
      return data;
    }),
    onMutate: () => {
      removeError("recalculateCart" /* recalculateCart */);
    },
    onSuccess: data => {
      setCartData(data);
    },
    onError: error => {
      addError("recalculateCart" /* recalculateCart */, error);
      ErrorManagement4.exception({
        exception: error,
        tags: {
          fileLocation: "CartProvider",
          featureFunction: "patch-cart-mutation-error"
        },
        fingerprint: ["checkout", "recalculate-cart-mutation-error"]
      });
    }
  });
  const getExpiredQuotes = useGetExpiredQuotesQuery(hasQuotes, cartId);
  useEffect15(() => {
    if (cart) {
      if (hasQuoteLineItem(cart) && cartVersion !== lastValidatedCartVersion) {
        setHasQuotes(true);
        setLastValidatedCartVersion(cartVersion);
      } else {
        setHasQuotes(false);
      }
    }
  }, [cart, cartVersion, lastValidatedCartVersion]);
  useEffect15(() => {
    var _a2;
    if (getExpiredQuotes.status === "pending" || getExpiredQuotes.status === "success") {
      setExpiredQuotesError(void 0);
    }
    if (getExpiredQuotes.status === "error") {
      setExpiredQuotesError((_a2 = getExpiredQuotes.error.response) == null ? void 0 : _a2.data);
    }
  }, [(_c = (_b = getExpiredQuotes.error) == null ? void 0 : _b.response) == null ? void 0 : _c.data, getExpiredQuotes.status]);
  useEffect15(() => {
    const unsubscribeFromLogin = authenticationService.onLogin(loginResponseData => {
      if ("cart" in loginResponseData && loginResponseData.cart) {
        setCartAfterLogin(loginResponseData.cart);
      }
    });
    const unsubscribeFromLogout = authenticationService.onLogout(locallyRemoveCart);
    return () => {
      unsubscribeFromLogin();
      unsubscribeFromLogout();
    };
  }, [authenticationService, locallyRemoveCart]);
  useEffect15(() => {
    if (cartAfterLogin) {
      const visibleCartChangeAfterLogin = getVisibleCartChangeAfterLogin(cart, cartAfterLogin);
      if (visibleCartChangeAfterLogin === CartChangeAfterLogin.mergedCart) {
        addNotification("mergedCartDuringLogin" /* mergedCartDuringLogin */);
      } else if (visibleCartChangeAfterLogin === CartChangeAfterLogin.retrievedCart) {
        addNotification("retrievedCartDuringLogin" /* retrievedCartDuringLogin */);
      }
      setCartData(cartAfterLogin);
      setCartAfterLogin(void 0);
      recalculateCartMutation.mutate(cartAfterLogin.id);
    }
  }, [cart, cartAfterLogin, recalculateCartMutation, setCartData]);
  useEffect15(() => {
    if (typeof window !== "undefined") {
      const handleStorageChange = event => {
        if (event.key === localStorageKey) {
          const newCartId = event.newValue || void 0;
          if (newCartId !== cartId) {
            setCartIdInState(newCartId);
          }
        }
      };
      window.addEventListener("storage", handleStorageChange);
      return () => {
        window.removeEventListener("storage", handleStorageChange);
      };
    }
    return void 0;
  }, [cartId]);
  useEffect15(() => {
    if (authenticationService.isTokenExpired) {
      locallyRemoveCart();
    }
  }, [authenticationService.isTokenExpired, locallyRemoveCart]);
  useEffect15(() => {
    if (cartQuery.error && cartQuery.error.response && cartQuery.error.response.status >= 400 && cartQuery.error.response.status < 500) {
      locallyRemoveCart();
    }
  }, [cartQuery.error, locallyRemoveCart]);
  const contextValue = useMemo6(() => ({
    cartId,
    setCartId: setCartIdInStateAndLocalStorage,
    cart,
    invalidateCart,
    setCartData,
    locallyRemoveCart,
    queries: {
      cartQuery
    },
    errors,
    notifications,
    addError,
    removeError,
    removeAllErrors,
    addNotification,
    removeNotification,
    resetNotifications,
    expiredQuotesError
  }), [cartId, cart, invalidateCart, setCartData, locallyRemoveCart, cartQuery, errors, notifications, expiredQuotesError]);
  return /* @__PURE__ */React37.createElement(CartContext_default.Provider, {
    value: contextValue
  }, children);
};
var CartProvider_default = CartProvider;

// src/library/queries/line-item/useReOrderLineItemsMutation.ts
import { useMutation as useMutation10 } from "@tanstack/react-query";
import { AddLineItemHelper as AddLineItemHelper2 } from "@printdeal/checkout-shared";
import { isQuoteLineItem as isQuoteLineItem2 } from "@printdeal/business-logic";
import { nanoid as nanoid2 } from "nanoid";
function useReOrderLineItemsMutation() {
  const mutationKey = "reOrderLineItems" /* reOrderLineItems */;
  const addQuoteToCartMutation = useAddQuoteToCartMutation();
  const addLineItemMutation = useAddLineItemMutation();
  const reAssignGroupIds = lineItems => {
    const groupIds = [];
    lineItems.forEach(lineItem => {
      var _a;
      if (((_a = lineItem.custom) == null ? void 0 : _a.fields.isReviewGroupLead) === true) {
        groupIds.push({
          oldGroupId: lineItem.custom.fields.reviewGroup,
          newGroupId: nanoid2()
        });
      }
    });
    groupIds.forEach(_ref56 => {
      let {
        oldGroupId,
        newGroupId
      } = _ref56;
      lineItems.forEach(lineItem => {
        var _a, _b;
        if (((_a = lineItem.custom) == null ? void 0 : _a.fields.reviewGroup) && lineItem.custom.fields.reviewGroup === oldGroupId) {
          lineItem.custom.fields.reviewGroup = newGroupId;
          lineItem.custom.fields.fulfillmentGroup = newGroupId;
        }
        if (((_b = lineItem.custom) == null ? void 0 : _b.fields.multipleDesignsGroup) && lineItem.custom.fields.multipleDesignsGroup === oldGroupId) {
          lineItem.custom.fields.reviewGroup = newGroupId;
          lineItem.custom.fields.fulfillmentGroup = newGroupId;
          lineItem.custom.fields.multipleDesignsGroup = newGroupId;
        }
      });
    });
    return lineItems;
  };
  const splitLineItems = (order, lineItemIds) => {
    const addQuoteLineItemRequestData = [];
    const regularLineItems = [];
    order.lineItems.filter(lineItem => lineItemIds.includes(lineItem.id)).forEach(lineItem => {
      if (isQuoteLineItem2(lineItem)) {
        addQuoteLineItemRequestData.push({
          quoteId: lineItem.custom.fields.quoteId,
          quoteLineItemId: lineItem.custom.fields.quoteLineItemId
        });
      } else {
        regularLineItems.push(lineItem);
      }
    });
    return {
      addQuoteLineItemRequestData,
      regularLineItems
    };
  };
  return useMutation10({
    mutationKey: [mutationKey],
    mutationFn: _0 => __async(this, [_0], function (_ref57) {
      let {
        order,
        lineItemIds,
        withFile,
        artworks
      } = _ref57;
      return function* () {
        if (!lineItemIds.length) {
          throw new Error("At least one line item id should be passed to call this mutation");
        }
        const {
          addQuoteLineItemRequestData,
          regularLineItems
        } = splitLineItems(order, lineItemIds);
        if (regularLineItems.length > 0) {
          const addLineItemPayload = AddLineItemHelper2.buildLineItemsFromExistingLineItems({
            orderOrCart: order,
            lineItems: reAssignGroupIds(regularLineItems),
            isReorder: true,
            isWithFile: withFile != null ? withFile : false,
            artworks
          });
          yield addLineItemMutation.mutateAsync(addLineItemPayload);
        }
        if (addQuoteLineItemRequestData.length > 0) {
          yield addQuoteToCartMutation.mutateAsync(addQuoteLineItemRequestData);
        }
      }();
    })
  });
}

// src/library/views/PaymentMethodView.tsx
import { addDataLayerEntry as addDataLayerEntry13 } from "@printdeal/data-layer-manager";
import React50, { useContext as useContext13, useEffect as useEffect22 } from "react";
import { FormattedMessage as FormattedMessage31, useIntl as useIntl19 } from "react-intl";
import { Brand as Brand6, Container as Container2, Heading as Heading7, Link as Link4, Panel as Panel9 } from "@printdeal/ui-library";
import { Experiment as Experiment4 } from "@printdeal/feature-management/react";
import clsx2 from "clsx";

// src/library/components/cart/payment-method/PaymentMethodSelector.tsx
import { Alert as Alert6, Badge as Badge3, LoadingModal, Panel as Panel8, RadioGroup, SelectField, Spinner as Spinner4 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage24, defineMessages as defineMessages3, useIntl as useIntl11 } from "react-intl";
import React40, { useState as useState11 } from "react";
import { addDataLayerEntry as addDataLayerEntry9 } from "@printdeal/data-layer-manager";
import { getLastUpdatedPayment } from "@printdeal/checkout-shared";

// src/library/queries/payment-method/useGetPaymentMethodsQuery.ts
import { useQuery as useQuery7 } from "@tanstack/react-query";
function useGetPaymentMethodsQuery() {
  const {
    cartId
  } = useCart();
  return useQuery7({
    queryKey: ["paymentMethodsForCart", cartId],
    queryFn: () => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cannot get payment methods without cartId");
      }
      const {
        data
      } = yield PaymentHttpClient_default.getPaymentMethodsForCart(cartId);
      return data;
    }),
    staleTime: Math.round(15 * 60 * 1e3)
    // 15 minutes
  });
}

// src/library/components/cart/payment-method/PaymentMethodIcon.tsx
import { Brand as Brand4 } from "@printdeal/ui-library";
import React38 from "react";
var PaymentMethodIcon = _ref58 => {
  let {
    paymentMethodId
  } = _ref58;
  switch (paymentMethodId) {
    case "ideal":
      return /* @__PURE__ */React38.createElement(Brand4, {
        brand: "ideal",
        className: "pd-h-7"
      });
    case "bcmc":
    case "bcmc_mobile":
      return /* @__PURE__ */React38.createElement(Brand4, {
        brand: "bancontactmrcash",
        className: "pd-h-7"
      });
    case "creditCard":
      return /* @__PURE__ */React38.createElement(Brand4, {
        brand: "creditcards",
        className: "pd-h-7"
      });
    case "paypal":
      return /* @__PURE__ */React38.createElement(Brand4, {
        brand: "paypal",
        className: "pd-h-7"
      });
    case "cartebancaire":
      return /* @__PURE__ */React38.createElement(Brand4, {
        brand: "cartebancaire",
        className: "pd-h-7"
      });
    default:
      return null;
  }
};
var PaymentMethodIcon_default = PaymentMethodIcon;

// src/library/helpers/PaymentHelpers.ts
function getMandateFromPayment(payment) {
  var _a;
  return (_a = payment.custom) == null ? void 0 : _a.fields.mandateId;
}
function hasPaymentInfo(cartOrOrder) {
  var _a;
  return Boolean((_a = cartOrOrder.paymentInfo) == null ? void 0 : _a.payments.length);
}

// src/library/queries/cart/usePatchCartMutation.ts
import { useMutation as useMutation11 } from "@tanstack/react-query";
import { ErrorManagement as ErrorManagement5 } from "@printdeal/error-management/react";
function usePatchCartMutation(_ref59) {
  let {
    context: {
      mutationKey
    }
  } = _ref59;
  const {
    cartId,
    setCartData
  } = useCart();
  return useMutation11({
    mutationKey: [mutationKey],
    mutationFn: payload => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cart cannot be patched without a cartId");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.patchCart(cartId, payload);
      return data;
    }),
    onSuccess: data => {
      setCartData(data);
    },
    onError: error => {
      ErrorManagement5.exception({
        exception: error,
        tags: {
          fileLocation: "usePatchCartMutation",
          featureFunction: "patch-cart-mutation-error"
        },
        fingerprint: ["checkout", "usePatchCartMutation"]
      });
    }
  });
}

// src/library/components/design-system/loading-indicators/ProgressSteps.tsx
import { Icon, Spinner as Spinner3 } from "@printdeal/ui-library";
import React39 from "react";
var ProgressSteps = _ref60 => {
  let {
    steps
  } = _ref60;
  return /* @__PURE__ */React39.createElement("div", {
    className: "pd-flex pd-flex-col"
  }, steps.map(step => /* @__PURE__ */React39.createElement("div", {
    className: "pd-flex pd-items-center pd-gap-2"
  }, steps.length > 1 && /* @__PURE__ */React39.createElement("span", null, step.isCompleted ? /* @__PURE__ */React39.createElement(Icon, {
    size: "sm",
    icon: "check"
  }) : /* @__PURE__ */React39.createElement(Spinner3, {
    size: "sm"
  })), step.text)));
};
var ProgressSteps_default = ProgressSteps;

// src/library/components/cart/payment-method/PaymentMethodSelector.tsx
var mandateStatusLabels = defineMessages3({
  1: {
    id: "checkout.mandateStatusLabel.1",
    defaultMessage: "Not registered by bank"
  },
  2: {
    id: "checkout.mandateStatusLabel.2",
    defaultMessage: "Incasso failed multiple times"
  },
  3: {
    id: "checkout.mandateStatusLabel.3",
    defaultMessage: "Account is private"
  },
  4: {
    id: "checkout.mandateStatusLabel.4",
    defaultMessage: "Account is blocked"
  },
  5: {
    id: "checkout.mandateStatusLabel.5",
    defaultMessage: "Form was invalid"
  },
  6: {
    id: "checkout.mandateStatusLabel.6",
    defaultMessage: "Revoked by customer"
  },
  7: {
    id: "checkout.mandateStatusLabel.7",
    defaultMessage: "Created"
  },
  8: {
    id: "checkout.mandateStatusLabel.8",
    defaultMessage: "Pending"
  },
  9: {
    id: "checkout.mandateStatusLabel.9",
    defaultMessage: "Approved"
  },
  99: {
    id: "checkout.mandateStatusLabel.99",
    defaultMessage: "Mandate max amount less than order amount."
  }
});
var paymentMethodLabels = defineMessages3({
  mandate: {
    id: "checkout.paymentMethodLabel.mandate",
    defaultMessage: "Mandate"
  },
  creditcard: {
    id: "checkout.paymentMethodLabel.creditcard",
    defaultMessage: "Creditcard"
  },
  onaccount: {
    id: "checkout.paymentMethodLabel.onaccount",
    defaultMessage: "Pay afterwards on account"
  },
  ideal: {
    id: "checkout.paymentMethodLabel.ideal",
    defaultMessage: "iDEAL"
  },
  paypal: {
    id: "checkout.paymentMethodLabel.paypal",
    defaultMessage: "PayPal"
  },
  bcmc: {
    id: "checkout.paymentMethodLabel.bcmc",
    defaultMessage: "Ban Contact Mister Cash"
  },
  bcmc_mobile: {
    id: "checkout.paymentMethodLabel.bcmc_mobile",
    defaultMessage: "Ban Contact Mister Cash mobile"
  }
});
var PaymentMethodSelector = () => {
  var _a, _b, _c, _d;
  const intl = useIntl11();
  const getPaymentMethodsQuery = useGetPaymentMethodsQuery();
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "setPaymentMethod" /* setPaymentMethod */
    }
  });
  const {
    cart
  } = useCart();
  const paymentOnCart = cart && getLastUpdatedPayment(cart);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState11(paymentOnCart == null ? void 0 : paymentOnCart.paymentMethodInfo.method);
  const mandateOnCart = cart && (paymentOnCart == null ? void 0 : paymentOnCart.paymentMethodInfo.method) === "mandate" ? getMandateFromPayment(paymentOnCart) : void 0;
  const [selectedMandate, setSelectedMandate] = useState11(mandateOnCart);
  const mandatePaymentMethod = (_a = getPaymentMethodsQuery.data) == null ? void 0 : _a.methods.find(paymentMethod => paymentMethod.id === "mandate");
  const handlePaymentMethodChange = (paymentMethodId, mandateId) => {
    if (paymentMethodId === "mandate" && !mandateId) {
      return;
    }
    patchCartMutation.mutate({
      action: {
        name: "setPaymentMethod",
        value: __spreadValues({
          paymentMethodId
        }, mandateId ? {
          mandateId
        } : {})
      }
    });
  };
  return /* @__PURE__ */React40.createElement("div", {
    className: "pd-grid pd-gap-4"
  }, /* @__PURE__ */React40.createElement(Alert6, {
    variant: "info"
  }, /* @__PURE__ */React40.createElement(FormattedMessage24, {
    id: "checkout.paymentSectionInfoAlert",
    defaultMessage: "Choose a payment method here. And pay after you have placed your order."
  })), getPaymentMethodsQuery.isLoading && /* @__PURE__ */React40.createElement("div", {
    className: "pd-flex pd-justify-center"
  }, /* @__PURE__ */React40.createElement(Spinner4, {
    size: "lg"
  })), (getPaymentMethodsQuery.isError || ((_b = getPaymentMethodsQuery.data) == null ? void 0 : _b.methods.length) === 0) && /* @__PURE__ */React40.createElement(Alert6, {
    variant: "error"
  }, /* @__PURE__ */React40.createElement(FormattedMessage24, {
    id: "checkout.errorMessage.errorWhileLoadingPaymentMethods",
    defaultMessage: "An error occurred while loading the payment methods."
  })), patchCartMutation.isError && /* @__PURE__ */React40.createElement(ErrorAlert_default, {
    sentryException: {
      e: patchCartMutation.error,
      tags: {
        fileLocation: "PaymentMethodSelector.tsx",
        featureFunction: "patchCartMutation"
      },
      fingerPrint: ["checkout-frontend", "payment-method-selector", "patch-cart-mutation"]
    }
  }, /* @__PURE__ */React40.createElement(FormattedMessage24, {
    id: "checkout.errorMessage.errorWhileUpdatingPaymentMethod",
    defaultMessage: "An error occurred while updating your payment method."
  })), ((_c = getPaymentMethodsQuery.data) == null ? void 0 : _c.methods.length) && /* @__PURE__ */React40.createElement(Panel8, null, /* @__PURE__ */React40.createElement(RadioGroup, {
    id: "paymentMethodSelector",
    name: "paymentMethodSelector",
    label: intl.formatMessage({
      id: "checkout.paymentMethodView.title",
      defaultMessage: "Payment method"
    })
  }, getPaymentMethodsQuery.data.methods.filter(paymentMethod => {
    var _a2;
    return paymentMethod.id !== "mandate" || Boolean((_a2 = paymentMethod.mandates) == null ? void 0 : _a2.length);
  }).map(paymentMethod => {
    const paymentMethodIdLowerCase = paymentMethod.id.toLowerCase();
    return /* @__PURE__ */React40.createElement(RadioGroup.Field, {
      key: paymentMethod.id,
      id: "paymentMethodSelector-".concat(paymentMethod.id),
      value: paymentMethod.id,
      checked: paymentMethod.id === selectedPaymentMethod,
      disabled: patchCartMutation.isPending,
      label: paymentMethodIdLowerCase in paymentMethodLabels ? /* @__PURE__ */React40.createElement(FormattedMessage24, {
        id: paymentMethodLabels[paymentMethodIdLowerCase].id,
        defaultMessage: paymentMethodLabels[paymentMethodIdLowerCase].defaultMessage
      }) : paymentMethod.name,
      description: /* @__PURE__ */React40.createElement(PaymentMethodIcon_default, {
        paymentMethodId: paymentMethod.id
      }),
      badge: /* @__PURE__ */React40.createElement(Badge3, {
        variant: "success-outline"
      }, Number(paymentMethod.costs.centAmount) === 0 ? /* @__PURE__ */React40.createElement(FormattedMessage24, {
        id: "checkout.priceLabel.free",
        defaultMessage: "Free"
      }) : /* @__PURE__ */React40.createElement(Money_default, {
        value: Number(paymentMethod.costs.centAmount),
        currency: paymentMethod.costs.currency
      })),
      onChange: () => {
        handlePaymentMethodChange(paymentMethod.id);
        setSelectedPaymentMethod(paymentMethod.id);
        EcommerceObjectHelper.clearEcommerceObject();
        addDataLayerEntry9("add_payment_info", EcommerceObjectHelper.createEcommercePaymentInfoObject(cart, paymentMethod.id));
        addDataLayerEntry9("choose_payment_method", {
          payment_method: paymentMethod.id
        });
      }
    });
  })), selectedPaymentMethod === "mandate" && /* @__PURE__ */React40.createElement("div", {
    className: "pd-mt-3"
  }, /* @__PURE__ */React40.createElement(SelectField, {
    id: "paymentMethodSelector-mandate",
    name: "paymentMethodSelector_mandate",
    required: true,
    value: selectedMandate,
    onChange: event => {
      handlePaymentMethodChange("mandate", event.target.value || void 0);
      setSelectedMandate(event.target.value || void 0);
    }
  }, /* @__PURE__ */React40.createElement(SelectField.Option, {
    value: ""
  }, intl.formatMessage({
    id: "checkout.formPlaceholder.mandate",
    defaultMessage: "Select a mandate"
  })), (_d = mandatePaymentMethod == null ? void 0 : mandatePaymentMethod.mandates) == null ? void 0 : _d.map(mandate => {
    const unusableStatusLabel = !mandate.usable && mandate.statusId in mandateStatusLabels ? " (".concat(intl.formatMessage(mandateStatusLabels[mandate.statusId]), ")") : "";
    return /* @__PURE__ */React40.createElement(SelectField.Option, {
      key: mandate.id,
      value: mandate.id,
      disabled: !mandate.usable
    }, "".concat(mandate.name, " - ").concat(mandate.ibanNumber, " - ").concat(mandate.accountName, " - ").concat(intl.formatMessage({
      id: "checkout.mandate.maxAmountMessage",
      defaultMessage: "Mandate max amount"
    }), ": ").concat(intl.formatNumber(mandate.maxAmount, {
      style: "currency",
      currency: "EUR"
    })).concat(unusableStatusLabel));
  })))), /* @__PURE__ */React40.createElement(LoadingModal, {
    title: "",
    onClose: () => {},
    isOpen: patchCartMutation.isPending
  }, /* @__PURE__ */React40.createElement(ProgressSteps_default, {
    steps: [{
      text: /* @__PURE__ */React40.createElement(FormattedMessage24, {
        id: "checkout.spinnerLabel.updatingPaymentMethod",
        defaultMessage: "Updating your payment method"
      }),
      isCompleted: false
    }]
  })));
};
var PaymentMethodSelector_default = PaymentMethodSelector;

// src/library/components/cart/place-order/PlaceOrderButton.tsx
import { Button as Button7, Link as Link3, LoadingModal as LoadingModal2, Tooltip as Tooltip2 } from "@printdeal/ui-library";
import React41, { useContext as useContext10 } from "react";
import { FormattedMessage as FormattedMessage25, useIntl as useIntl12 } from "react-intl";
import { useCartVersionMismatchPrevention as useCartVersionMismatchPrevention6 } from "@printdeal/checkout-shared/dist/frontend";
import { addDataLayerEntry as addDataLayerEntry10 } from "@printdeal/data-layer-manager";
import { ErrorManagement as ErrorManagement6 } from "@printdeal/error-management/react";

// src/library/queries/cart/usePlaceOrderMutation.ts
import { useMutation as useMutation12 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication10 } from "@printdeal/authentication";
function usePlaceOrderMutation() {
  const {
    isUserLoggedIn
  } = useAuthentication10();
  const {
    cartId
  } = useCart();
  return useMutation12({
    mutationKey: ["placeOrder" /* placeOrder */],
    mutationFn: () => __async(this, null, function* () {
      if (!isUserLoggedIn) {
        throw new Error("Cannot place an order when not logged in");
      }
      if (!cartId) {
        throw new Error("Cannot place an order without cartId");
      }
      const {
        data: order
      } = yield ShoppingCartHttpClient_default.placeOrder(cartId);
      return order;
    }),
    retry: false
  });
}

// src/library/components/cart/place-order/PlaceOrderButton.tsx
var PlaceOrderButton = () => {
  const intl = useIntl12();
  const placeOrderMutation = usePlaceOrderMutation();
  const {
    navigate,
    paths
  } = useContext10(CheckoutViewContext_default);
  const {
    cart
  } = useCart();
  const {
    isCartMutationPending
  } = useCartVersionMismatchPrevention6();
  const paymentMethodOnCart = Boolean(cart && hasPaymentInfo(cart));
  return /* @__PURE__ */React41.createElement(React41.Fragment, null, /* @__PURE__ */React41.createElement(Tooltip2, {
    placement: "top",
    className: "pd-w-full",
    trigger: /* @__PURE__ */React41.createElement(Button7, {
      as: !paymentMethodOnCart ? Tooltip2.Trigger : "button",
      iconAfter: "chevron-right",
      disabled: !paymentMethodOnCart || isCartMutationPending,
      className: "pd-w-full",
      onClick: () => {
        placeOrderMutation.mutateAsync().then(data => {
          const order = data;
          EcommerceObjectHelper.clearEcommerceObject();
          addDataLayerEntry10("purchase", EcommerceObjectHelper.createEcommercePurchaseObject(cart, order));
          navigate("".concat(paths.thanksForOrderPage.path, "?itemId=").concat(order.id), {
            state: {
              order
            }
          }).catch(() => {});
        }).catch(() => {
          ErrorManagement6.exception({
            exception: placeOrderMutation.error,
            tags: {
              fileLocation: "PlaceOrderFunctions",
              featureFunction: "placeOrderError"
            },
            fingerprint: ["checkout-place-order-error"]
          });
        });
      },
      "data-cy": "placeOrderButton"
    }, /* @__PURE__ */React41.createElement(FormattedMessage25, {
      id: "checkout.placeOrderButton",
      defaultMessage: "Place order"
    }))
  }, /* @__PURE__ */React41.createElement(FormattedMessage25, {
    id: "checkout.selectPaymentMethodBeforePlacingOrder",
    defaultMessage: "Please select a payment method before placing your order."
  })), /* @__PURE__ */React41.createElement("p", {
    className: "pd-text-xs"
  }, /* @__PURE__ */React41.createElement(FormattedMessage25, {
    id: "checkout.termsAndConditionsSentence",
    defaultMessage: "By confirming this order I declare that I\\'m authorized to place this order with payment obligation as a private person or representative of the company and I agree with the {termsAndConditionsLink} and upload specifications.",
    description: "Terms and condition sentence in the checkout",
    values: {
      termsAndConditionsLink: /* @__PURE__ */React41.createElement(Link3, {
        href: intl.formatMessage({
          id: "link.termsAndConditions.url",
          defaultMessage: "/nl/pages/voorwaarden"
        }),
        target: "_blank",
        rel: "noopener noreferrer"
      }, /* @__PURE__ */React41.createElement(FormattedMessage25, {
        id: "placeOrderMessages.termsAndConditions",
        defaultMessage: "terms and conditions"
      }))
    }
  })), /* @__PURE__ */React41.createElement(LoadingModal2, {
    title: intl.formatMessage({
      id: "checkout.placeOrderProgressTitle",
      defaultMessage: "Thanks for your order!"
    }),
    isOpen: placeOrderMutation.status === "pending",
    onClose: () => {}
  }, /* @__PURE__ */React41.createElement(FormattedMessage25, {
    id: "checkout.placeOrderProgressSentence",
    defaultMessage: "Your order is now being placed, just wait a little longer..."
  })));
};
var PlaceOrderButton_default = PlaceOrderButton;

// src/library/components/cart/coupon-code/CouponForm.tsx
import React44, { useMemo as useMemo7 } from "react";

// src/library/components/cart/coupon-code/RemoveCouponCodeButton.tsx
import { FormattedMessage as FormattedMessage26 } from "react-intl";
import { LinkAsButton as LinkAsButton7 } from "@printdeal/ui-library";
import { addDataLayerEntry as addDataLayerEntry11 } from "@printdeal/data-layer-manager";
import React42, { useEffect as useEffect16 } from "react";
var RemoveCouponCodeButton = _ref61 => {
  let {
    coupons
  } = _ref61;
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "removeCoupon" /* removeCoupon */
    }
  });
  useEffect16(() => {
    if (patchCartMutation.status === "success") {
      addDataLayerEntry11("checkout_coupon_removed");
    }
  }, [patchCartMutation.status]);
  const handleOnClick = coupon => {
    var _a;
    if (!((_a = coupon.discountCode.obj) == null ? void 0 : _a.code)) return;
    patchCartMutation.mutate({
      action: {
        name: "removeCouponCode",
        value: coupon.discountCode.obj.code
      }
    });
  };
  return coupons.map(coupon => {
    var _a, _b;
    return /* @__PURE__ */React42.createElement("div", {
      key: (_a = coupon.discountCode.obj) == null ? void 0 : _a.code
    }, /* @__PURE__ */React42.createElement(LinkAsButton7, {
      iconBefore: patchCartMutation.isPending ? void 0 : "trashcan",
      variant: "secondary",
      className: "pd-text-xs",
      onClick: () => handleOnClick(coupon),
      isLoading: patchCartMutation.isPending
    }, /* @__PURE__ */React42.createElement(FormattedMessage26, {
      id: "checkout.removeCoupon.labelText",
      defaultMessage: "Remove coupon"
    }), " ", "(", (_b = coupon.discountCode.obj) == null ? void 0 : _b.code, ")"), patchCartMutation.isError && /* @__PURE__ */React42.createElement("div", {
      className: "pd-mt-1 pd-text-xs pd-text-error-500"
    }, /* @__PURE__ */React42.createElement(FormattedMessage26, {
      id: "checkout.coupon.errorWhileRemovingCoupon",
      defaultMessage: "An unknown error occurred while removing the coupon."
    })));
  });
};
var RemoveCouponCodeButton_default = RemoveCouponCodeButton;

// src/library/components/cart/coupon-code/AddCouponCodeButton.tsx
import { Button as Button8, LinkAsButton as LinkAsButton8, TextField } from "@printdeal/ui-library";
import React43, { useEffect as useEffect17, useRef as useRef3, useState as useState12 } from "react";
import { FormattedMessage as FormattedMessage27, useIntl as useIntl13 } from "react-intl";
import { useAuthentication as useAuthentication11 } from "@printdeal/authentication";
import { addDataLayerEntry as addDataLayerEntry12 } from "@printdeal/data-layer-manager";
function getAddCouponErrorMessage(error, isUserLoggedIn) {
  var _a, _b;
  const errorCode = (_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error;
  if (errorCode === "DiscountCodeNotEligible") {
    if (isUserLoggedIn) {
      return /* @__PURE__ */React43.createElement(FormattedMessage27, {
        id: "checkout.coupon.couponCodeNotEligible.loggedInUser",
        defaultMessage: "\n            The entered coupon code could not be applied because our system indicates that you\n            are not eligible for it. The reason for this could be that you have already used\n            the coupon code in the past, the coupon code has already expired, or the coupon code\n            is not available for the account with which you are logged in.\n          "
      });
    }
    return /* @__PURE__ */React43.createElement(FormattedMessage27, {
      id: "checkout.coupon.couponCodeNotEligible.anonymousUser",
      defaultMessage: "\n          The entered coupon code could not be applied because our system indicates that you\n          are not eligible for it. The reason for this could be that you are not logged in yet.\n          Please try logging in first and then applying your coupon.\n        "
    });
  }
  if (errorCode === "DiscountCodeInvalid") {
    return /* @__PURE__ */React43.createElement(FormattedMessage27, {
      id: "checkout.coupon.couponCodeInvalid",
      defaultMessage: "The entered coupon code is invalid."
    });
  }
  return /* @__PURE__ */React43.createElement(FormattedMessage27, {
    id: "checkout.coupon.errorWhileApplyingCoupon",
    defaultMessage: "An unknown error occurred while applying the coupon."
  });
}
var AddCouponCodeButton = () => {
  const intl = useIntl13();
  const couponRef = useRef3(null);
  const {
    isUserLoggedIn
  } = useAuthentication11();
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "addCoupon" /* addCoupon */
    }
  });
  const [inputOpen, setInputOpen] = useState12(false);
  useEffect17(() => {
    if (patchCartMutation.status === "success") {
      addDataLayerEntry12("checkout_coupon_applied");
    }
    if (patchCartMutation.status === "error") {
      addDataLayerEntry12("checkout_error_coupon_field");
    }
  }, [patchCartMutation.status]);
  const handleOnClick = () => {
    var _a;
    const couponCode = (_a = couponRef.current) == null ? void 0 : _a.value.trim();
    if (!couponCode) return;
    patchCartMutation.mutateAsync({
      action: {
        name: "addCouponCode",
        value: couponCode
      }
    }).then(() => {
      addDataLayerEntry12("checkout_accept_coupon_field");
    });
  };
  return /* @__PURE__ */React43.createElement(React43.Fragment, null, !inputOpen && /* @__PURE__ */React43.createElement(LinkAsButton8, {
    onClick: () => {
      setInputOpen(true);
      addDataLayerEntry12("checkout_open_coupon_field");
    },
    variant: "secondary",
    className: "pd-text-xs pd-text-dim-500 hover:pd-text-primary-500"
  }, /* @__PURE__ */React43.createElement(FormattedMessage27, {
    id: "checkout.couponcode.linktext",
    defaultMessage: "Do you have a coupon code?"
  })), inputOpen && /* @__PURE__ */React43.createElement(React43.Fragment, null, /* @__PURE__ */React43.createElement(TextField, {
    validation: patchCartMutation.isError ? "error" : void 0,
    validationMessage: patchCartMutation.isError ? getAddCouponErrorMessage(patchCartMutation.error, isUserLoggedIn) : void 0,
    ref: couponRef,
    name: "text-input",
    id: "text-input",
    placeholder: intl.formatMessage({
      id: "checkout.coupon.labelText",
      defaultMessage: "Coupon"
    })
  }), /* @__PURE__ */React43.createElement(Button8, {
    variant: "secondary",
    size: "md",
    onClick: handleOnClick,
    className: "pd-mt-2 pd-w-full",
    isLoading: patchCartMutation.isPending
  }, /* @__PURE__ */React43.createElement(FormattedMessage27, {
    id: "checkout.addCoupon.buttonText",
    defaultMessage: "Apply"
  }))));
};
var AddCouponCodeButton_default = AddCouponCodeButton;

// src/library/components/cart/coupon-code/CouponForm.tsx
var CouponForm = () => {
  const {
    cart
  } = useCart();
  const coupons = useMemo7(() => cart == null ? void 0 : cart.discountCodes, [cart == null ? void 0 : cart.discountCodes]);
  if (coupons == null ? void 0 : coupons.length) {
    return /* @__PURE__ */React44.createElement(RemoveCouponCodeButton_default, {
      coupons
    });
  }
  return /* @__PURE__ */React44.createElement(AddCouponCodeButton_default, null);
};
var CouponForm_default = CouponForm;

// src/library/components/cart/CartReferenceField.tsx
import React46 from "react";
import { useIntl as useIntl14 } from "react-intl";

// src/library/components/DebounceField.tsx
import { Spinner as Spinner5, TextField as TextField2, useDebounce } from "@printdeal/ui-library";
import React45, { useEffect as useEffect18, useState as useState13 } from "react";
import { FormattedMessage as FormattedMessage28 } from "react-intl";
var DebounceField = _ref62 => {
  let {
    initialValue,
    mutationStatus,
    onUpdate,
    name,
    id,
    label,
    disabled = false
  } = _ref62;
  const [labelData, setLabel] = useState13(initialValue);
  const [validationState, setValidationState] = useState13(void 0);
  const debouncedValue = useDebounce(labelData, 500);
  useEffect18(() => {
    if (debouncedValue !== initialValue) {
      onUpdate(debouncedValue || "");
    }
  }, [debouncedValue]);
  useEffect18(() => {
    if (mutationStatus === "success" || mutationStatus === "error") {
      setValidationState(mutationStatus);
    }
  }, [mutationStatus]);
  return /* @__PURE__ */React45.createElement(TextField2, {
    name,
    id,
    label,
    disabled,
    value: labelData,
    onChange: event => setLabel(event.target.value.trimStart().replace(/\s{2,}/g, " ")),
    onKeyDown: () => setValidationState(void 0),
    onClick: () => setValidationState(void 0),
    iconAfter: mutationStatus === "pending" ? /* @__PURE__ */React45.createElement(Spinner5, {
      size: "sm",
      variant: "dim",
      screenReaderLabel: "Saving field..."
    }) : void 0,
    validation: validationState,
    validationMessage: mutationStatus === "error" ? /* @__PURE__ */React45.createElement(FormattedMessage28, __spreadValues({}, errorMessages.setReferenceLabel)) : void 0
  });
};
var DebounceField_default = DebounceField;

// src/library/components/cart/CartReferenceField.tsx
var CartReferenceField = _ref63 => {
  let {
    disabled = false
  } = _ref63;
  var _a;
  const intl = useIntl14();
  const {
    cart
  } = useCart();
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "setReferenceLabel" /* setReferenceLabel */
    }
  });
  const {
    mutate: patchCart
  } = patchCartMutation;
  return /* @__PURE__ */React46.createElement(DebounceField_default, {
    initialValue: ((_a = cart == null ? void 0 : cart.custom) == null ? void 0 : _a.fields.referenceLabel) || "",
    mutationStatus: patchCartMutation.status,
    onUpdate: value => patchCart({
      action: {
        name: "setReferenceLabel",
        value
      }
    }),
    name: "reference",
    id: "reference",
    label: intl.formatMessage({
      id: "checkout.label.reference",
      defaultMessage: "Reference/Description"
    }),
    disabled
  });
};
var CartReferenceField_default = CartReferenceField;

// src/library/components/cart/CartPoNumberField.tsx
import React47 from "react";
import { useIntl as useIntl15 } from "react-intl";
var CartPoNumberField = _ref64 => {
  let {
    disabled = false
  } = _ref64;
  var _a;
  const intl = useIntl15();
  const {
    cart
  } = useCart();
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "setPurchaseorderNumber" /* setPurchaseorderNumber */
    }
  });
  const {
    mutate: patchCart
  } = patchCartMutation;
  return /* @__PURE__ */React47.createElement(DebounceField_default, {
    initialValue: ((_a = cart == null ? void 0 : cart.custom) == null ? void 0 : _a.fields.PONumber) || "",
    mutationStatus: patchCartMutation.status,
    onUpdate: value => patchCart({
      action: {
        name: "setPurchaseOrderNumber",
        value
      }
    }),
    name: "poNumber",
    id: "poNumber",
    label: intl.formatMessage({
      id: "checkout.label.poNumber",
      defaultMessage: "PO number"
    }),
    disabled
  });
};
var CartPoNumberField_default = CartPoNumberField;

// src/library/components/design-system/checkout/CheckoutKiyohScore.tsx
import React48, { useContext as useContext11 } from "react";
import { FormattedMessage as FormattedMessage29, useIntl as useIntl16 } from "react-intl";
import { Brand as Brand5 } from "@printdeal/ui-library";
import { StoreToggle as StoreToggle3 } from "@printdeal/feature-management/react";
var CheckoutKiyohScore = () => {
  var _a, _b;
  const {
    locale
  } = useIntl16();
  const {
    kiyohScore
  } = useContext11(CheckoutViewContext_default);
  const last12MonthAverageRating = kiyohScore == null ? void 0 : kiyohScore.last12MonthAverageRating;
  const last12MonthNumberReviews = kiyohScore == null ? void 0 : kiyohScore.last12MonthNumberReviews;
  const last12MonthRecommendation = kiyohScore == null ? void 0 : kiyohScore.last12MonthRecommendation;
  const reviewUrl = (_b = (_a = kiyohScore == null ? void 0 : kiyohScore.reviewURLs) == null ? void 0 : _a.find(element => element.locale === locale)) == null ? void 0 : _b.reviewUrl;
  return reviewUrl && last12MonthAverageRating && last12MonthNumberReviews && last12MonthRecommendation ? /* @__PURE__ */React48.createElement(StoreToggle3, {
    id: "drukwerkdeal-nl_printdeal-be"
  }, /* @__PURE__ */React48.createElement(StoreToggle3.Enabled, null, /* @__PURE__ */React48.createElement("a", {
    href: reviewUrl,
    target: "_blank",
    className: "pd-order-last pd-flex pd-flex-col pd-text-center pd-text-sm",
    rel: "noreferrer"
  }, /* @__PURE__ */React48.createElement(Brand5, {
    brand: "kiyoh",
    className: "pd-mb-2 pd-h-16"
  }), /* @__PURE__ */React48.createElement("div", null, /* @__PURE__ */React48.createElement(FormattedMessage29, {
    id: "checkout.averageKiyohRating",
    defaultMessage: "Average Kiyoh rating"
  }), ":", /* @__PURE__ */React48.createElement("strong", null, last12MonthAverageRating)), /* @__PURE__ */React48.createElement("div", null, /* @__PURE__ */React48.createElement(FormattedMessage29, {
    id: "checkout.numberOfKiyohReviews",
    defaultMessage: "{number} reviews last 12 months",
    values: {
      number: last12MonthNumberReviews
    }
  })), /* @__PURE__ */React48.createElement("div", null, /* @__PURE__ */React48.createElement(FormattedMessage29, {
    id: "checkout.kiyohRecommendation",
    defaultMessage: "{percentage}% recommends us",
    values: {
      percentage: last12MonthRecommendation
    }
  }))))) : null;
};
var CheckoutKiyohScore_default = CheckoutKiyohScore;

// src/library/hooks/validators/useCartAddressesValidatorHook.ts
import { isBillingAddressCountryValidOnCart as billingAddressCountryValidator, isBillingAddressValidOnCart as billingAddressValidator, isShippingAddressCountryValidOnCart as shippingAddressCountryValidator, isShippingAddressValidOnCart as shippingAddressValidator } from "@printdeal/checkout-shared";
import { useEffect as useEffect19, useState as useState14 } from "react";
import { configurationProvider as configurationProvider7 } from "@printdeal/configuration";
import { defineMessages as defineMessages4, useIntl as useIntl17 } from "react-intl";
var errorMessages2 = defineMessages4({
  incompleteShippingAddress: {
    id: "checkout.incompleteShippingAddress",
    defaultMessage: "Your shipping address(es) are incomplete."
  },
  incompleteBillingAddress: {
    id: "checkout.incompleteBillingAddress",
    defaultMessage: "Your billing address is incomplete."
  },
  invalidShippingCountry: {
    id: "checkout.invalidShippingCountry",
    defaultMessage: "Unfortunately, the country for your shipping address is unavailable."
  },
  invalidBillingCountry: {
    id: "checkout.invalidBillingCountry",
    defaultMessage: "Unfortunately, the country for your billing address is unavailable."
  },
  emailMissingOnBillingAddress: {
    id: "checkout.emailMissingOnBillingAddress",
    defaultMessage: "Your billing address is missing an email address."
  }
});
function useCartAddressesValidatorHook() {
  const intl = useIntl17();
  const {
    cart
  } = useCart();
  const [addressValidation, setAddressValidation] = useState14({
    isBillingAddressValidOnCart: true,
    isShippingAddressValidOnCart: true,
    isBillingAddressCountryValidOnCart: true,
    isShippingAddressCountryValidOnCart: true,
    hasBillingAddressEmailAddress: true
  });
  const getErrors = () => {
    const errors = [];
    const {
      isBillingAddressValidOnCart,
      isShippingAddressValidOnCart,
      isBillingAddressCountryValidOnCart,
      isShippingAddressCountryValidOnCart,
      hasBillingAddressEmailAddress
    } = addressValidation;
    if (!isShippingAddressValidOnCart) {
      errors.push(intl.formatMessage(errorMessages2.incompleteShippingAddress));
    } else if (!isShippingAddressCountryValidOnCart) {
      errors.push(intl.formatMessage(errorMessages2.invalidShippingCountry));
    }
    if (!isBillingAddressValidOnCart) {
      errors.push(intl.formatMessage(errorMessages2.incompleteBillingAddress));
      if (!hasBillingAddressEmailAddress) {
        errors.push(intl.formatMessage(errorMessages2.emailMissingOnBillingAddress));
      }
    } else if (!isBillingAddressCountryValidOnCart) {
      errors.push(intl.formatMessage(errorMessages2.invalidBillingCountry));
    }
    return errors;
  };
  useEffect19(() => {
    var _a;
    if (!cart) return;
    setAddressValidation({
      isBillingAddressValidOnCart: billingAddressValidator(cart),
      isShippingAddressValidOnCart: shippingAddressValidator(cart),
      isBillingAddressCountryValidOnCart: billingAddressCountryValidator(cart, configurationProvider7.getValueAsArray("ADDRESS_COUNTRIES")),
      isShippingAddressCountryValidOnCart: shippingAddressCountryValidator(cart, configurationProvider7.getValueAsArray("ADDRESS_COUNTRIES")),
      hasBillingAddressEmailAddress: Boolean((_a = cart.billingAddress) == null ? void 0 : _a.email)
    });
  }, [cart]);
  return {
    areAllAddressesValidOnCart: Object.values(addressValidation).every(isValid => isValid),
    errors: getErrors()
  };
}

// src/library/hooks/validators/useValidateCartRedirectHook.ts
import { useContext as useContext12, useEffect as useEffect20 } from "react";
import { useIsMutating } from "@tanstack/react-query";
function useValidateCartRedirectHook() {
  const {
    cart,
    expiredQuotesError
  } = useCart();
  const {
    navigate,
    paths
  } = useContext12(CheckoutViewContext_default);
  const cartQuery = useGetCartQuery();
  const isPlaceOrderMutating = useIsMutating({
    mutationKey: ["patchCartMutation"],
    status: "pending"
  }) > 0;
  useEffect20(() => {
    var _a;
    if (cartQuery.isLoading || isPlaceOrderMutating) {
      return;
    }
    if (!(cart == null ? void 0 : cart.lineItems.length) || ((_a = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a.length)) {
      navigate(paths.cartPage.path).catch(() => {});
    }
  }, [cart, expiredQuotesError, cartQuery.status, isPlaceOrderMutating, cartQuery.isLoading, navigate, paths.cartPage.path]);
}

// src/library/components/design-system/payment-methods/CartValidationAlert.tsx
import { Alert as Alert7 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage30 } from "react-intl";
import React49 from "react";

// src/library/hooks/validators/useValidateCartHook.ts
import { useEffect as useEffect21, useState as useState15 } from "react";
import { validateCart } from "@printdeal/checkout-shared";
import { useIntl as useIntl18, defineMessages as defineMessages5 } from "react-intl";
var errorMessages3 = defineMessages5({
  incompleteBillingAddress: {
    id: "checkout.validation.billingAddressIncomplete",
    defaultMessage: "Billing address is incomplete"
  },
  invalidBillingAddressEmail: {
    id: "checkout.validation.billingAddressEmail",
    defaultMessage: "Billing address email is invalid"
  },
  invalidCart: {
    id: "checkout.validation.invalidCart",
    defaultMessage: "Invalid cart: {message}"
  },
  genericError: {
    id: "checkout.validation.genericError",
    defaultMessage: "Invalid Cart!!"
  }
});
function useValidateCartHook() {
  const {
    cart
  } = useCart();
  const [errors, setErrors] = useState15( /* @__PURE__ */new Set());
  const intl = useIntl18();
  useEffect21(() => {
    if (!cart) {
      return;
    }
    validateCart(cart).then(() => {
      setErrors( /* @__PURE__ */new Set());
    }).catch(outcome => {
      if (!outcome.errorMessage) {
        errors.add(intl.formatMessage(errorMessages3.genericError));
      } else {
        outcome.errorMessage.errors.forEach(error => {
          if (error.path.startsWith("billingAddress")) {
            if (error.path.endsWith("email")) {
              errors.add(intl.formatMessage(errorMessages3.invalidBillingAddressEmail));
            } else {
              errors.add(intl.formatMessage(errorMessages3.incompleteBillingAddress));
            }
          } else {
            errors.add(intl.formatMessage(errorMessages3.genericError));
          }
        });
      }
      setErrors(errors);
    });
  }, [cart, errors, intl]);
  return {
    errors
  };
}

// src/library/components/design-system/payment-methods/CartValidationAlert.tsx
var CartValidationAlert = () => {
  const {
    errors
  } = useValidateCartHook();
  return errors.size > 0 && /* @__PURE__ */React49.createElement(Alert7, {
    variant: "warning"
  }, /* @__PURE__ */React49.createElement(FormattedMessage30, {
    id: "checkout.pleaseReviewValidationErrors",
    defaultMessage: "Please review the following validation errors:"
  }), /* @__PURE__ */React49.createElement("ul", null, Array.from(errors).map(error => /* @__PURE__ */React49.createElement("li", {
    key: error
  }, error))));
};
var CartValidationAlert_default = CartValidationAlert;

// src/library/views/PaymentMethodView.tsx
var PaymentMethodView = () => {
  const intl = useIntl19();
  const {
    navigate,
    paths
  } = useContext13(CheckoutViewContext_default);
  const {
    areAllAddressesValidOnCart
  } = useCartAddressesValidatorHook();
  useValidateCartRedirectHook();
  useEffect22(() => {
    if (!areAllAddressesValidOnCart) {
      navigate(paths.deliveryPage.path, {
        state: {
          warningType: "error"
        }
      }).catch(() => {});
    }
  }, [areAllAddressesValidOnCart, navigate, paths.deliveryPage.path]);
  useEffect22(() => {
    addDataLayerEntry13("view_payment_info");
  }, []);
  return /* @__PURE__ */React50.createElement(Container2, {
    className: "pd-py-6"
  }, /* @__PURE__ */React50.createElement(CheckoutStepper_default, null), /* @__PURE__ */React50.createElement(Heading7, {
    as: "h1",
    className: "pd-mb-5"
  }, /* @__PURE__ */React50.createElement(FormattedMessage31, {
    id: "checkout.paymentMethodView.title",
    defaultMessage: "Payment method"
  })), /* @__PURE__ */React50.createElement(CartQuery_default, null, cart => /* @__PURE__ */React50.createElement("div", {
    className: "pd-grid pd-grid-cols-3 pd-items-start pd-gap-4"
  }, /* @__PURE__ */React50.createElement("div", {
    className: "pd-col-span-3 md:pd-col-span-2"
  }, /* @__PURE__ */React50.createElement("div", {
    className: "pd-grid pd-gap-4"
  }, /* @__PURE__ */React50.createElement(CheckoutDevOnly_default, {
    jsonObject: {
      cartId: cart.id,
      cartVersion: cart.version
    }
  }), /* @__PURE__ */React50.createElement(CartValidationAlert_default, null), /* @__PURE__ */React50.createElement(CartErrorNotifications_default, {
    fileLocation: "PaymentMethodView.tsx"
  }), /* @__PURE__ */React50.createElement(PaymentMethodSelector_default, null))), /* @__PURE__ */React50.createElement("div", {
    className: "pd-sticky pd-top-3 pd-col-span-3 pd-flex pd-flex-col pd-gap-4 md:pd-col-span-1"
  }, /* @__PURE__ */React50.createElement("div", {
    className: "pd-order-1 md:pd-order-none"
  }, /* @__PURE__ */React50.createElement(CheckoutSummary_default, {
    nextStepButton: /* @__PURE__ */React50.createElement(PlaceOrderButton_default, null)
  })), /* @__PURE__ */React50.createElement("div", {
    className: "pd-order-none pd-grid pd-gap-4 md:pd-order-1"
  }, /* @__PURE__ */React50.createElement(Panel9, null, /* @__PURE__ */React50.createElement("div", {
    className: "pd-grid pd-gap-3"
  }, /* @__PURE__ */React50.createElement(CouponForm_default, null), /* @__PURE__ */React50.createElement(CartReferenceField_default, null), /* @__PURE__ */React50.createElement(CartPoNumberField_default, null)))), /* @__PURE__ */React50.createElement("div", {
    className: "pd-order-last"
  }, /* @__PURE__ */React50.createElement(Experiment4, {
    id: "search4it_exp1728_-_kiyoh_reviews_vs_trustpilot_reviews",
    fallback: true
  }, /* @__PURE__ */React50.createElement(Experiment4.Control, null, /* @__PURE__ */React50.createElement(CheckoutKiyohScore_default, null)), /* @__PURE__ */React50.createElement(Experiment4.Variant, null, /* @__PURE__ */React50.createElement(Link4, {
    href: "https://nl.trustpilot.com/review/www.drukwerkdeal.nl",
    variant: "secondary",
    className: clsx2("pd-text-center pd-text-sm pd-font-normal", "pd-flex pd-flex-col pd-items-center pd-justify-center pd-gap-0 pd-p-6"),
    onClick: () => addDataLayerEntry13("trustpilot_click", {
      contentType: "checkout_summary_payment_method",
      locale: intl.locale
    }),
    target: "_blank"
  }, /* @__PURE__ */React50.createElement(Brand6, {
    brand: "trustpilot",
    className: "pd-h-16 pd-pb-2"
  }), /* @__PURE__ */React50.createElement("div", null, /* @__PURE__ */React50.createElement(FormattedMessage31, {
    id: "checkout.trustpilot.paymentMethodViewScore",
    defaultMessage: "Average Trustpilot score: <strong>4.5</strong> out of 5",
    values: {
      strong: chunks => /* @__PURE__ */React50.createElement("strong", null, chunks)
    }
  })), /* @__PURE__ */React50.createElement("div", {
    className: "pd-flex pd-flex-col"
  }, /* @__PURE__ */React50.createElement(FormattedMessage31, {
    id: "checkout.trustpilot.paymentMethodViewTotalReviews",
    defaultMessage: "1629 reviews in the last 12 months<span>91% recommend us</span>",
    values: {
      span: chunks => /* @__PURE__ */React50.createElement("span", null, chunks)
    }
  }))))))))));
};
var PaymentMethodView_default = PaymentMethodView;

// src/library/components/context-providers/checkout-view/CheckoutViewProvider.tsx
import React51, { useCallback as useCallback2, useMemo as useMemo8 } from "react";
import { useLocation as useLocation2 } from "@gatsbyjs/reach-router";
import { ErrorManagement as ErrorManagement7 } from "@printdeal/error-management/react";
var CheckoutViewProvider = _ref65 => {
  let {
    navigate,
    paths,
    location,
    kiyohScore,
    children,
    checkoutPreviewModal,
    checkoutFileDeliveryButton,
    customer
  } = _ref65;
  const navigateTo = useCallback2((to, options) => __async(void 0, null, function* () {
    yield navigate(to, options).catch(error => {
      ErrorManagement7.exception({
        exception: error,
        tags: {
          fileLocation: "CheckoutViewProvider",
          featureFunction: "navigateTo"
        },
        fingerprint: ["checkout-view-provider-navigate-to"]
      });
    });
  }), [navigate]);
  const contextValue = useMemo8(() => ({
    navigate: navigateTo,
    useLocation: () => useLocation2(),
    paths,
    location,
    kiyohScore,
    customer,
    // Temporary components and variables from Launchpad
    CheckoutPreviewModal: checkoutPreviewModal,
    CheckoutFileDeliveryButton: checkoutFileDeliveryButton
  }), [navigateTo, customer, paths, location, kiyohScore, checkoutPreviewModal, checkoutFileDeliveryButton]);
  return /* @__PURE__ */React51.createElement(CheckoutViewContext_default.Provider, {
    value: contextValue
  }, children);
};
var CheckoutViewProvider_default = CheckoutViewProvider;

// src/library/views/DeliveryView.tsx
import { FormattedMessage as FormattedMessage56 } from "react-intl";
import { Alert as Alert14, Button as Button18, Container as Container3, Heading as Heading13, Panel as Panel11 } from "@printdeal/ui-library";
import { addDataLayerEntry as addDataLayerEntry18 } from "@printdeal/data-layer-manager";
import { getMainLineItems as getMainLineItems5, isAddressOnCartComplete } from "@printdeal/checkout-shared";
import React84, { useContext as useContext15, useEffect as useEffect31 } from "react";
import { AddressContent as AddressContent3, usePrefetchAddresses as usePrefetchAddresses3 } from "@printdeal/address-frontend";

// src/library/components/design-system/checkout/delivery-page/DeliveryAlerts.tsx
import { Alert as Alert8 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage32 } from "react-intl";
import React52, { useContext as useContext14 } from "react";
var DeliveryAlerts = () => {
  var _a, _b, _c;
  const {
    areAllAddressesValidOnCart,
    errors
  } = useCartAddressesValidatorHook();
  const {
    useLocation: useLocation3
  } = useContext14(CheckoutViewContext_default);
  const location = useLocation3();
  return /* @__PURE__ */React52.createElement(React52.Fragment, null, ((_a = location.state) == null ? void 0 : _a.flash) && /* @__PURE__ */React52.createElement(Alert8, {
    variant: "success",
    isDismissible: true,
    autoDismiss: 5e3
  }, /* @__PURE__ */React52.createElement(FormattedMessage32, {
    id: "checkout.registration.successMessage",
    defaultMessage: "Your account has been created!"
  })), !areAllAddressesValidOnCart && /* @__PURE__ */React52.createElement(Alert8, {
    variant: (_c = (_b = location.state) == null ? void 0 : _b.warningType) != null ? _c : "warning"
  }, /* @__PURE__ */React52.createElement(FormattedMessage32, {
    id: "checkout.pleaseReviewValidationErrors",
    defaultMessage: "Please review the following validation errors:"
  }), /* @__PURE__ */React52.createElement("ul", null, errors.map(error => /* @__PURE__ */React52.createElement("li", {
    key: error
  }, /* @__PURE__ */React52.createElement("p", null, error))))));
};
var DeliveryAlerts_default = DeliveryAlerts;

// src/library/components/design-system/checkout/delivery-page/DeliveryLineItem.tsx
import { LinkAsButton as LinkAsButton14, Transition as Transition2 } from "@printdeal/ui-library";
import React78, { useState as useState25 } from "react";
import { FormattedMessage as FormattedMessage52 } from "react-intl";
import { addDataLayerEntry as addDataLayerEntry17 } from "@printdeal/data-layer-manager";
import { useFeatureToggle } from "@printdeal/feature-management/react";
import { usePrefetchAddresses as usePrefetchAddresses2 } from "@printdeal/address-frontend";
import { configurationProvider as configurationProvider11 } from "@printdeal/configuration";

// src/library/components/line-item/pickup-point/PickupPointSelector.tsx
import React60, { useEffect as useEffect25, useState as useState17 } from "react";
import { FormattedMessage as FormattedMessage36, useIntl as useIntl23 } from "react-intl";
import { Heading as Heading9, Tooltip as Tooltip3 } from "@printdeal/ui-library";

// src/library/components/line-item/pickup-point/PickupPointButton.tsx
import { LinkAsButton as LinkAsButton9 } from "@printdeal/ui-library";
import React53 from "react";
import { hasPickupPoint as isLineItemWithPickupPoint } from "@printdeal/business-logic";
import { FormattedMessage as FormattedMessage33 } from "react-intl";
var PickupPointButton = _ref66 => {
  let {
    lineItem,
    unavailableReason,
    className,
    onClick
  } = _ref66;
  var _a;
  const lineItemOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  return /* @__PURE__ */React53.createElement(LinkAsButton9, {
    iconBefore: "truck",
    variant: "secondary",
    className,
    onClick: () => {
      if (unavailableReason !== void 0 || lineItemOptionsQuery.isLoading) {
        return;
      }
      onClick();
    },
    "aria-disabled": Boolean(unavailableReason !== void 0 || lineItemOptionsQuery.isLoading),
    disabled: lineItemOptionsQuery.isLoading,
    isLoading: lineItemOptionsQuery.isLoading
  }, Boolean(isLineItemWithPickupPoint(lineItem)) || Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.printdealPickupPoint) ? /* @__PURE__ */React53.createElement(FormattedMessage33, {
    id: "checkout.changePickupPoint",
    defaultMessage: "Change pickup point"
  }) : /* @__PURE__ */React53.createElement(FormattedMessage33, {
    id: "checkout.choosePickupPoint",
    defaultMessage: "Choose pickup point"
  }));
};
var PickupPointButton_default = PickupPointButton;

// src/library/components/line-item/pickup-point/PickupPointModal.tsx
import { useIntl as useIntl22 } from "react-intl";
import React59 from "react";
import { Modal as Modal2 } from "@printdeal/ui-library";
import { addDataLayerEntry as addDataLayerEntry14 } from "@printdeal/data-layer-manager";
import { configurationProvider as configurationProvider9 } from "@printdeal/configuration";
import { useGetAddressesQuery } from "@printdeal/address-frontend";

// src/library/components/line-item/pickup-point/widget/PickupPointWidget.tsx
import { configurationProvider as configurationProvider8 } from "@printdeal/configuration";
import { APIProvider } from "@vis.gl/react-google-maps";
import React58 from "react";

// src/library/components/line-item/pickup-point/widget/PickupPointWidgetInternal.tsx
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import React57, { useCallback as useCallback3, useEffect as useEffect24, useState as useState16 } from "react";
import { useDebounce as useDebounce2 } from "@printdeal/ui-library";

// src/library/components/line-item/pickup-point/widget/PickupPointMaps.tsx
import { Map as Map2, Marker, useMap } from "@vis.gl/react-google-maps";
import React54, { useEffect as useEffect23 } from "react";
import { useIsMutating as useIsMutating2 } from "@tanstack/react-query";

// src/library/components/line-item/pickup-point/widget/MapStyling.ts
var mapStyling = [{
  featureType: "administrative",
  stylers: [{
    visibility: "on"
  }]
}, {
  featureType: "poi",
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.attraction",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.business",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.government",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.medical",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.medical",
  elementType: "geometry",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.park",
  elementType: "labels.text",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.place_of_worship",
  elementType: "geometry",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.school",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.sports_complex",
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "transit",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "water",
  elementType: "labels.text",
  stylers: [{
    visibility: "off"
  }]
}];
var MapStyling_default = mapStyling;

// src/library/components/line-item/pickup-point/widget/PickupPointMaps.tsx
var PickupPointMaps = _ref67 => {
  let {
    pickupPoints,
    focusedPickupPointId,
    onClickMarker
  } = _ref67;
  const map = useMap("pickup-points-map");
  const updateLineItemMutating = useIsMutating2({
    mutationKey: ["updateLineItem" /* updateLineItem */, "setPickupPoint" /* setPickupPoint */],
    exact: true,
    status: "pending"
  });
  useEffect23(() => {
    if (pickupPoints) {
      const bounds = new google.maps.LatLngBounds();
      pickupPoints.forEach(_ref68 => {
        let {
          pickupPoint
        } = _ref68;
        if (pickupPoint.pickupPointsProviderId === "pup:providers:keep-at-plant-nl") {
          return;
        }
        bounds.extend({
          lat: pickupPoint.geoCoordinates.latitude,
          lng: pickupPoint.geoCoordinates.longitude
        });
      });
      pickupPoints.filter(_ref69 => {
        let {
          pickupPoint
        } = _ref69;
        return pickupPoint.pickupPointsProviderId === "pup:providers:keep-at-plant-nl";
      }).forEach(_ref70 => {
        let {
          pickupPoint
        } = _ref70;
        if (bounds.contains({
          lat: pickupPoint.geoCoordinates.latitude,
          lng: pickupPoint.geoCoordinates.longitude
        })) {
          bounds.extend({
            lat: pickupPoint.geoCoordinates.latitude,
            lng: pickupPoint.geoCoordinates.longitude
          });
        }
      });
      if (map) {
        map.fitBounds(bounds);
      }
    }
  }, [pickupPoints, map]);
  return /* @__PURE__ */React54.createElement(Map2, {
    id: "pickup-points-map",
    gestureHandling: "greedy",
    disableDefaultUI: true,
    zoomControl: true,
    styles: MapStyling_default
  }, pickupPoints && pickupPoints.map(_ref71 => {
    let {
      pickupPoint
    } = _ref71;
    return /* @__PURE__ */React54.createElement(Marker, {
      key: pickupPoint.id,
      position: {
        lat: pickupPoint.geoCoordinates.latitude,
        lng: pickupPoint.geoCoordinates.longitude
      },
      icon: {
        path: "M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z",
        fillColor: focusedPickupPointId === pickupPoint.id ? "#262626" : "#ff7600",
        fillOpacity: 1,
        strokeWeight: 0,
        scale: focusedPickupPointId === pickupPoint.id ? 0.65 : 0.5
      },
      zIndex: focusedPickupPointId === pickupPoint.id ? 1 : 0,
      onClick: () => {
        if (updateLineItemMutating === 0) {
          onClickMarker(pickupPoint.id);
        }
      }
    });
  }));
};
var PickupPointMaps_default = PickupPointMaps;

// src/library/components/line-item/pickup-point/widget/PickupPointList.tsx
import { Spinner as Spinner6, TextInput } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage35, useIntl as useIntl21 } from "react-intl";
import React56 from "react";

// src/library/components/line-item/pickup-point/widget/PickupPointPanel.tsx
import { Brand as Brand7, Button as Button9, DescriptionList as DescriptionList2, Heading as Heading8, Icon as Icon2, Panel as Panel10 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage34, defineMessages as defineMessages6, useIntl as useIntl20 } from "react-intl";
import React55, { Fragment as Fragment2 } from "react";
import { useIsMutating as useIsMutating3 } from "@tanstack/react-query";
import clsx3 from "clsx";
var DaysOfTheWeek = /* @__PURE__ */(DaysOfTheWeek2 => {
  DaysOfTheWeek2["MONDAY"] = "monday";
  DaysOfTheWeek2["TUESDAY"] = "tuesday";
  DaysOfTheWeek2["WEDNESDAY"] = "wednesday";
  DaysOfTheWeek2["THURSDAY"] = "thursday";
  DaysOfTheWeek2["FRIDAY"] = "friday";
  DaysOfTheWeek2["SATURDAY"] = "saturday";
  DaysOfTheWeek2["SUNDAY"] = "sunday";
  return DaysOfTheWeek2;
})(DaysOfTheWeek || {});
var PickupPointPanel = _ref72 => {
  let {
    pickupPointResult,
    focusedPickupPointId,
    onClickPanel,
    onSubmit
  } = _ref72;
  const intl = useIntl20();
  const updateLineItemMutating = useIsMutating3({
    mutationKey: ["updateLineItem" /* updateLineItem */, "setPickupPoint" /* setPickupPoint */],
    exact: true,
    status: "pending"
  });
  const {
    pickupPoint,
    distance
  } = pickupPointResult;
  const translatedDaysOfTheWeek = defineMessages6({
    ["monday" /* MONDAY */]: {
      id: "checkout.pickupPoint.monday",
      defaultMessage: "Monday"
    },
    ["tuesday" /* TUESDAY */]: {
      id: "checkout.pickupPoint.tuesday",
      defaultMessage: "Tuesday"
    },
    ["wednesday" /* WEDNESDAY */]: {
      id: "checkout.pickupPoint.wednesday",
      defaultMessage: "Wednesday"
    },
    ["thursday" /* THURSDAY */]: {
      id: "checkout.pickupPoint.thursday",
      defaultMessage: "Thursday"
    },
    ["friday" /* FRIDAY */]: {
      id: "checkout.pickupPoint.friday",
      defaultMessage: "Friday"
    },
    ["saturday" /* SATURDAY */]: {
      id: "checkout.pickupPoint.saturday",
      defaultMessage: "Saturday"
    },
    ["sunday" /* SUNDAY */]: {
      id: "checkout.pickupPoint.sunday",
      defaultMessage: "Sunday"
    }
  });
  const getPickupPointProviderImage = () => {
    switch (pickupPointResult.pickupPoint.pickupPointsProviderId) {
      case "pup:providers:postnl":
        return /* @__PURE__ */React55.createElement(Brand7, {
          brand: "postnl",
          className: "pd-h-14"
        });
      case "pup:providers:dhl":
        return /* @__PURE__ */React55.createElement(Brand7, {
          brand: "dhl",
          className: "pd-h-14"
        });
      case "pup:providers:keep-at-plant-nl":
      case "pup:providers:printdeal-pickup-point":
        return /* @__PURE__ */React55.createElement(Brand7, {
          brand: "printdeal-logo-mark",
          className: "pd-h-14"
        });
      default:
        return /* @__PURE__ */React55.createElement(Icon2, {
          icon: "truck",
          size: "2xl"
        });
    }
  };
  const getOpeningHours = businessHours => {
    const opening = businessHours == null ? void 0 : businessHours.opening;
    const closing = businessHours == null ? void 0 : businessHours.closing;
    if (opening === "00:00" && (closing === "23:59" || closing === "00:00")) {
      return intl.formatMessage({
        id: "checkout.pickupPoint.open24Hours",
        defaultMessage: "Open 24 hours"
      });
    }
    if (opening && closing) {
      return "".concat(opening, " - ").concat(closing);
    }
    return intl.formatMessage({
      id: "checkout.pickupPoint.closed",
      defaultMessage: "Closed"
    });
  };
  return /* @__PURE__ */React55.createElement(Panel10, {
    className: clsx3("pd-w-full pd-p-4", {
      "pd-cursor-pointer": focusedPickupPointId !== pickupPoint.id
    }),
    onClick: () => {
      if (updateLineItemMutating === 0 && focusedPickupPointId !== pickupPoint.id) {
        onClickPanel(pickupPoint.id);
      }
    }
  }, /* @__PURE__ */React55.createElement("div", {
    className: clsx3("pd-grid pd-grid-cols-4 pd-gap-2", {
      "pd-cursor-pointer": focusedPickupPointId === pickupPoint.id
    })
  }, /* @__PURE__ */React55.createElement("div", {
    className: "pd-flex pd-items-center pd-justify-center"
  }, getPickupPointProviderImage()), /* @__PURE__ */React55.createElement("div", {
    className: "pd-col-span-3 pd-flex pd-w-full pd-flex-col pd-justify-center pd-gap-1"
  }, /* @__PURE__ */React55.createElement(Heading8, {
    variant: "display",
    size: "3"
  }, pickupPoint.name), /* @__PURE__ */React55.createElement("div", {
    className: "pd-flex pd-justify-between pd-pr-2"
  }, /* @__PURE__ */React55.createElement("p", {
    className: "pd-text-xs"
  }, pickupPoint.address.addressLine1), distance && /* @__PURE__ */React55.createElement("div", {
    className: "pd-whitespace-nowrap pd-text-xs pd-font-semibold pd-text-dim-500"
  }, distance < 1 ? "".concat(Math.round(distance * 1e3), " m") : "".concat(distance.toFixed(1), " km"))))), focusedPickupPointId === pickupPoint.id && /* @__PURE__ */React55.createElement(React55.Fragment, null, /* @__PURE__ */React55.createElement("div", {
    className: "pd-mt-4 pd-px-4"
  }, /* @__PURE__ */React55.createElement("span", {
    className: "pd-text-sm pd-font-semibold"
  }, /* @__PURE__ */React55.createElement(FormattedMessage34, {
    id: "checkout.pickupPoint.openingHours",
    defaultMessage: "Opening hours"
  })), /* @__PURE__ */React55.createElement(DescriptionList2, {
    className: "pd-gap-1"
  }, Object.values(DaysOfTheWeek).map(dayOfTheWeek => {
    var _a;
    return /* @__PURE__ */React55.createElement(Fragment2, {
      key: dayOfTheWeek
    }, /* @__PURE__ */React55.createElement(DescriptionList2.Title, {
      className: "pd-mr-3 pd-text-sm pd-font-normal pd-text-dim-800"
    }, /* @__PURE__ */React55.createElement(FormattedMessage34, __spreadValues({}, translatedDaysOfTheWeek[dayOfTheWeek]))), /* @__PURE__ */React55.createElement(DescriptionList2.Content, {
      className: "pd-text-sm"
    }, getOpeningHours((_a = pickupPoint.businessHours) == null ? void 0 : _a[dayOfTheWeek])));
  }))), /* @__PURE__ */React55.createElement("div", {
    className: "pd-p-2 pd-pt-4"
  }, /* @__PURE__ */React55.createElement(Button9, {
    className: "pd-w-full",
    onClick: event => {
      event.stopPropagation();
      onSubmit(pickupPointResult);
    },
    isLoading: updateLineItemMutating > 0,
    disabled: updateLineItemMutating > 0
  }, /* @__PURE__ */React55.createElement(FormattedMessage34, {
    id: "checkout.pickupPoint.select",
    defaultMessage: "Select pickup point"
  })))));
};
var PickupPointPanel_default = PickupPointPanel;

// src/library/components/line-item/pickup-point/widget/PickupPointList.tsx
var PickupPointList = _ref73 => {
  let {
    pickupPointsQuery,
    focusedPickupPointId,
    searchAddress,
    setSearchAddress,
    onClickPanel,
    onSubmit
  } = _ref73;
  var _a;
  const intl = useIntl21();
  return /* @__PURE__ */React56.createElement(React56.Fragment, null, /* @__PURE__ */React56.createElement(TextInput, {
    iconAfter: "search",
    className: "pd-mb-2 pd-w-full",
    defaultValue: searchAddress,
    placeholder: intl.formatMessage({
      id: "checkout.searchPickupPoint",
      defaultMessage: "Search by address or city"
    }),
    onChange: event => {
      setSearchAddress(event.target.value);
    }
  }), /* @__PURE__ */React56.createElement("div", {
    className: "pd-flex pd-h-[60vh] pd-flex-col pd-gap-2 pd-overflow-x-hidden pd-overflow-y-scroll"
  }, pickupPointsQuery.isLoading && /* @__PURE__ */React56.createElement("div", {
    className: "pd-flex pd-h-full pd-items-center pd-justify-center"
  }, /* @__PURE__ */React56.createElement(Spinner6, {
    size: "lg"
  })), pickupPointsQuery.isError && /* @__PURE__ */React56.createElement(ErrorAlert_default, {
    sentryException: {
      e: pickupPointsQuery.error,
      tags: {
        fileLocation: "PickupPointList.tsx",
        featureFunction: "pickupPointsQuery"
      },
      fingerPrint: ["checkout-frontend", "pickup-point-widget"]
    }
  }, /* @__PURE__ */React56.createElement(FormattedMessage35, {
    id: "checkout.pickupPoint.error",
    defaultMessage: "Something went wrong while loading the pickup points."
  })), (_a = pickupPointsQuery.data) == null ? void 0 : _a.sort((a, b) => {
    if (a.distance && b.distance) {
      return a.distance - b.distance;
    }
    return 0;
  }).map(pickupPointResult => /* @__PURE__ */React56.createElement(ScrollIntoView_default, {
    key: pickupPointResult.pickupPoint.id,
    scrollIntoView: focusedPickupPointId === pickupPointResult.pickupPoint.id,
    scrollIntoViewOptions: {
      behavior: "smooth",
      block: "start",
      inline: "nearest"
    }
  }, /* @__PURE__ */React56.createElement(PickupPointPanel_default, {
    pickupPointResult,
    focusedPickupPointId,
    onClickPanel,
    onSubmit
  })))));
};
var PickupPointList_default = PickupPointList;

// src/library/queries/line-item/useSearchPickupPointsQuery.ts
import { useQuery as useQuery8 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication12 } from "@printdeal/authentication";
function useSearchPickupPointsQuery(_ref74) {
  let {
    lineItemId,
    latitude,
    longitude
  } = _ref74;
  const {
    isUserLoggedIn
  } = useAuthentication12();
  const {
    cartId
  } = useCart();
  return useQuery8({
    queryKey: ["search-pickup-points", cartId, lineItemId, latitude, longitude],
    queryFn: () => __async(this, null, function* () {
      if (!cartId || !lineItemId) {
        throw new Error("CartId or lineItemId is not defined");
      }
      if (!latitude || !longitude) {
        throw new Error("Latitude or longitude is not defined");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.searchPickupPoints(cartId, lineItemId, {
        action: {
          name: "searchPickupPoints",
          value: {
            latitude,
            longitude
          }
        }
      });
      return data;
    }),
    retry: false,
    enabled: isUserLoggedIn && Boolean(cartId) && Boolean(lineItemId) && Boolean(latitude) && Boolean(longitude)
  });
}

// src/library/components/line-item/pickup-point/widget/PickupPointWidgetInternal.tsx
var PickupPointWidgetInternal = _ref75 => {
  let {
    lineItem,
    customerAddress,
    fallbackAddress,
    onPickupPointClick,
    onPickupPointSelection
  } = _ref75;
  const pickupPointId = getPickupPointIdFromLineItem(lineItem);
  const pickupPointQuery = useGetPickupPointQuery({
    pickupPointId
  });
  const [geocoordinates, setGeocoordinates] = useState16(null);
  const [focusedPickupPointId, setFocusedPickupPointId] = useState16(pickupPointId);
  const [searchAddress, setSearchAddress] = useState16();
  const debouncedSearchAddress = useDebounce2(searchAddress, 500);
  const geocodingLibrary = useMapsLibrary("geocoding");
  const pickupPointsQuery = useSearchPickupPointsQuery({
    lineItemId: lineItem.id,
    latitude: geocoordinates == null ? void 0 : geocoordinates.latitude,
    longitude: geocoordinates == null ? void 0 : geocoordinates.longitude
  });
  const geocodeAddress = useCallback3(address => __async(void 0, null, function* () {
    if (!geocodingLibrary) {
      throw new Error("Geocoding library not loaded");
    }
    const geoCoder = new geocodingLibrary.Geocoder();
    const geocode = function (addressLine) {
      let retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __async(void 0, null, function* () {
        yield geoCoder.geocode({
          address: addressLine
        }).then(_ref76 => {
          let {
            results
          } = _ref76;
          const [{
            geometry: {
              location
            }
          }] = results;
          setGeocoordinates({
            latitude: location.lat(),
            longitude: location.lng()
          });
          if (!debouncedSearchAddress) {
            setSearchAddress(results[0].formatted_address);
          }
        }).catch(() => __async(void 0, null, function* () {
          if (retry) {
            yield geocode("".concat(fallbackAddress.postalCode, " ").concat(fallbackAddress.country), false);
          } else {
            throw new Error("Geocoding failed");
          }
        }));
      });
    };
    yield geocode(address);
  }), [geocodingLibrary, fallbackAddress, debouncedSearchAddress]);
  useEffect24(() => {
    const execute = () => __async(void 0, null, function* () {
      if (!geocodingLibrary) return;
      if (!pickupPointId) {
        const address = debouncedSearchAddress || "".concat(customerAddress.postalCode, " ").concat(customerAddress.country);
        yield geocodeAddress(address);
        return;
      }
      if (pickupPointQuery.data) {
        yield geocodeAddress("".concat(pickupPointQuery.data.address.postalCode, " ").concat(pickupPointQuery.data.address.countryCode));
      }
    });
    execute().catch(() => {});
  }, [geocodingLibrary, customerAddress, debouncedSearchAddress, pickupPointQuery.data, pickupPointId, geocodeAddress]);
  return /* @__PURE__ */React57.createElement("div", {
    className: "pd-grid pd-grid-cols-5 md:pd-gap-4"
  }, /* @__PURE__ */React57.createElement("div", {
    className: "pd-col-span-5 md:pd-col-span-2"
  }, /* @__PURE__ */React57.createElement(PickupPointList_default, {
    pickupPointsQuery,
    focusedPickupPointId,
    searchAddress: debouncedSearchAddress,
    setSearchAddress,
    onClickPanel: id => {
      setFocusedPickupPointId(id);
      onPickupPointClick();
    },
    onSubmit: selectedPickupPoint => onPickupPointSelection(selectedPickupPoint)
  })), /* @__PURE__ */React57.createElement("div", {
    className: "pd-col-span-3 pd-overflow-hidden pd-rounded-md"
  }, /* @__PURE__ */React57.createElement(PickupPointMaps_default, {
    pickupPoints: pickupPointsQuery.data,
    focusedPickupPointId,
    onClickMarker: id => {
      setFocusedPickupPointId(id);
      onPickupPointClick();
    }
  })));
};
var PickupPointWidgetInternal_default = PickupPointWidgetInternal;

// src/library/components/line-item/pickup-point/widget/PickupPointWidget.tsx
var PickupPointWidget = props => /* @__PURE__ */React58.createElement(APIProvider, {
  apiKey: configurationProvider8.getValue("GOOGLE_MAPS_API_KEY")
}, /* @__PURE__ */React58.createElement(PickupPointWidgetInternal_default, __spreadValues({}, props)));
var PickupPointWidget_default = PickupPointWidget;

// src/library/components/line-item/pickup-point/PickupPointModal.tsx
var PickupPointModal = _ref77 => {
  let {
    lineItem,
    isOpen,
    onClose
  } = _ref77;
  var _a, _b;
  const intl = useIntl22();
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "setPickupPoint" /* setPickupPoint */
  });
  const customerAddresses = useGetAddressesQuery();
  const customerDefaultShippingAddress = (_a = customerAddresses.data) == null ? void 0 : _a.addresses.find(address => address.isDefaultShippingAddress);
  const customerDefaultBillingAddress = (_b = customerAddresses.data) == null ? void 0 : _b.addresses.find(address => address.isDefaultBillingAddress);
  const pickupPointDataLayerEvent = action => {
    addDataLayerEntry14(action);
  };
  return /* @__PURE__ */React59.createElement(Modal2, {
    onClose: () => onClose(),
    isOpen,
    title: intl.formatMessage({
      id: "checkout.choosePickupPoint",
      defaultMessage: "Choose pick-up point"
    }),
    dismissLabel: "Close",
    size: "xl"
  }, /* @__PURE__ */React59.createElement(Modal2.Content, {
    className: "pd-bg-dim-100"
  }, updateLineItemMutation.status === "error" && /* @__PURE__ */React59.createElement("div", {
    className: "pd-mb-2"
  }, /* @__PURE__ */React59.createElement(ErrorAlert_default, {
    sentryException: {
      e: updateLineItemMutation.error,
      tags: {
        fileLocation: "PickupPointModal.tsx",
        featureFunction: "updateLineItemMutation"
      },
      fingerPrint: ["checkout-frontend", "pickup-point-selector"]
    }
  })), /* @__PURE__ */React59.createElement(PickupPointWidget_default, {
    lineItem,
    customerAddress: {
      postalCode: customerDefaultShippingAddress == null ? void 0 : customerDefaultShippingAddress.address.postalCode,
      country: customerDefaultShippingAddress == null ? void 0 : customerDefaultShippingAddress.address.country
    },
    fallbackAddress: {
      postalCode: configurationProvider9.getValue("PUP_DEFAULT_POSTAL_CODE"),
      country: configurationProvider9.getValue("PUP_DEFAULT_COUNTRY")
    },
    onPickupPointClick: () => {
      pickupPointDataLayerEvent("pickup_point_click");
    },
    onPickupPointSelection: selectedPickupPoint => {
      var _a2, _b2;
      const pickupPointHref = (_b2 = (_a2 = selectedPickupPoint.pickupPoint._links) == null ? void 0 : _a2.self) == null ? void 0 : _b2.href;
      if (!pickupPointHref) {
        const [streetName, streetNumber] = selectedPickupPoint.pickupPoint.address.addressLine1.split(" ");
        if (!streetNumber) {
          throw new Error("No street number found in pickup point address");
        }
        updateLineItemMutation.mutateAsync({
          lineItemId: lineItem.id,
          payload: {
            shippingAddresses: [{
              address: {
                id: selectedPickupPoint.pickupPoint.id,
                firstName: (customerDefaultBillingAddress == null ? void 0 : customerDefaultBillingAddress.address.firstName) || "",
                lastName: (customerDefaultBillingAddress == null ? void 0 : customerDefaultBillingAddress.address.lastName) || "",
                company: selectedPickupPoint.pickupPoint.name,
                streetName,
                streetNumber,
                postalCode: selectedPickupPoint.pickupPoint.address.postalCode,
                city: selectedPickupPoint.pickupPoint.address.city,
                country: selectedPickupPoint.pickupPoint.address.countryCode
              },
              quantity: lineItem.quantity
            }],
            printdealPickupPointId: selectedPickupPoint.pickupPoint.id
          }
        }).then(() => onClose());
      } else {
        updateLineItemMutation.mutateAsync({
          lineItemId: lineItem.id,
          payload: {
            pickupPoints: [{
              href: pickupPointHref
            }]
          }
        }).then(() => onClose());
      }
      pickupPointDataLayerEvent("pickup_point_selection");
    }
  })));
};
var PickupPointModal_default = PickupPointModal;

// src/library/components/line-item/pickup-point/PickupPointSelector.tsx
var PickupPointSelector = _ref78 => {
  let {
    lineItem
  } = _ref78;
  const intl = useIntl23();
  const getLineItemOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  const [pickupPointsAvailable, setPickupPointsAvailable] = useState17(false);
  const [unavailableReason, setUnavailableReason] = useState17(void 0);
  const [isModalOpen, setIsModalOpen] = useState17(false);
  useEffect25(() => {
    if (!pickupPointsAvailable) {
      setUnavailableReason(0 /* NotPossibleForProduct */);
      return;
    }
    if (hasSplitShipmentOnLineItem(lineItem)) {
      setUnavailableReason(3 /* HasSplitShipmentOnLineItem */);
      return;
    }
    if (hasTimedDeliveryOnLineItem(lineItem)) {
      setUnavailableReason(2 /* HasTimedDeliveryOnLineItem */);
      return;
    }
    setUnavailableReason(void 0);
  }, [lineItem, pickupPointsAvailable]);
  useEffect25(() => {
    if (getLineItemOptionsQuery.data) {
      const {
        pickupPointAllowed
      } = getLineItemOptionsQuery.data;
      if (pickupPointAllowed) {
        setPickupPointsAvailable(true);
      } else {
        setPickupPointsAvailable(false);
      }
    }
    if (getLineItemOptionsQuery.error) {
      setUnavailableReason(1 /* CouldNotFetchPickupPoints */);
    }
  }, [getLineItemOptionsQuery.data, getLineItemOptionsQuery.error]);
  const getTooltipText = reason => {
    switch (reason) {
      case 0 /* NotPossibleForProduct */:
        return intl.formatMessage({
          id: "pickupPoints.notPossibleWithProduct",
          defaultMessage: "Pickup points are currently not possible for this product."
        });
      case 2 /* HasTimedDeliveryOnLineItem */:
        return intl.formatMessage({
          id: "pickupPoints.cannotBeCombinedWithTimedDeliveries",
          defaultMessage: "Pickup points cannot be combined with timed deliveries."
        });
      case 3 /* HasSplitShipmentOnLineItem */:
        return intl.formatMessage({
          id: "pickupPoints.cannotBeCombinedWithSplitShipments",
          defaultMessage: "Pick up points cannot be combined with split shipments."
        });
      case 1 /* CouldNotFetchPickupPoints */:
      default:
        return intl.formatMessage({
          id: "pickupPoints.temporarilyUnavailable",
          defaultMessage: "This feature is temporarily unavailable."
        });
    }
  };
  return /* @__PURE__ */React60.createElement("div", {
    className: "pd-flex pd-flex-col pd-gap-2"
  }, /* @__PURE__ */React60.createElement(Heading9, {
    as: "h4",
    className: "pd-mb-2"
  }, /* @__PURE__ */React60.createElement(FormattedMessage36, {
    id: "pickupPoint.pickupPoint",
    defaultMessage: "Pick-up point"
  })), unavailableReason ? /* @__PURE__ */React60.createElement(Tooltip3, {
    placement: "top",
    trigger: /* @__PURE__ */React60.createElement(Tooltip3.Trigger, {
      as: PickupPointButton_default,
      lineItem,
      unavailableReason,
      className: "pd-self-start pd-text-sm",
      onClick: () => setIsModalOpen(true)
    })
  }, getTooltipText(unavailableReason)) : /* @__PURE__ */React60.createElement(PickupPointButton_default, {
    lineItem,
    unavailableReason,
    className: "pd-self-start pd-text-sm",
    onClick: () => setIsModalOpen(true)
  }), /* @__PURE__ */React60.createElement(PickupPointModal_default, {
    lineItem,
    isOpen: isModalOpen,
    onClose: () => setIsModalOpen(false)
  }));
};
var PickupPointSelector_default = PickupPointSelector;

// src/library/components/line-item/delivery-option/DeliveryOptionSelector.tsx
import { Heading as Heading10, Tooltip as Tooltip4 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage42, useIntl as useIntl26 } from "react-intl";
import React67, { useEffect as useEffect27, useState as useState19 } from "react";
import { addDataLayerEntry as addDataLayerEntry16 } from "@printdeal/data-layer-manager";
import { hasPickupPoint, hasSplitShipment, isReviewGroupLead } from "@printdeal/business-logic";

// src/library/helpers/DeliveryOptionHelpers.ts
function getTimedDeliveryOfLineItem(lineItem) {
  var _a;
  if (typeof ((_a = lineItem.custom) == null ? void 0 : _a.fields.timedDelivery) === "string") {
    try {
      return JSON.parse(lineItem.custom.fields.timedDelivery);
    } catch (error) {
      return void 0;
    }
  }
  return void 0;
}
function getDeliveryOptionOfLineItem(lineItem, deliveryOptions) {
  var _a;
  const timedDelivery = getTimedDeliveryOfLineItem(lineItem);
  const carrierKeys = (_a = lineItem.custom) == null ? void 0 : _a.fields.qpShippingCarrierKey;
  if (!timedDelivery && !carrierKeys) {
    return void 0;
  }
  if (timedDelivery) {
    if (!carrierKeys) {
      return deliveryOptions.find(option => option.before === timedDelivery.before);
    }
    const matchingOption = deliveryOptions.find(option => {
      var _a2;
      return option.before === timedDelivery.before && ((_a2 = option.recsKey) == null ? void 0 : _a2.length) === carrierKeys.length && option.recsKey.every((recsKey, index) => carrierKeys[index] === recsKey);
    });
    return matchingOption;
  }
  if (carrierKeys) {
    const matchingOption = deliveryOptions.find(option => {
      var _a2;
      return ((_a2 = option.recsKey) == null ? void 0 : _a2.length) === carrierKeys.length && option.recsKey.every((recsKey, index) => carrierKeys[index] === recsKey);
    });
    return matchingOption;
  }
  return void 0;
}
function getNumberOfDeliveryOptionCarriers(deliveryOptions) {
  const carriers = /* @__PURE__ */new Set();
  deliveryOptions.forEach(option => carriers.add(option.carrier));
  return Array.from(carriers).length;
}
function getDeliveryOptionId2(deliveryOption) {
  return JSON.stringify({
    recsKey: (deliveryOption == null ? void 0 : deliveryOption.recsKey) || "all",
    before: (deliveryOption == null ? void 0 : deliveryOption.before) || "all-day"
  });
}

// src/library/components/line-item/delivery-option/DeliveryOptionButton.tsx
import { LinkAsButton as LinkAsButton10 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage37 } from "react-intl";
import React61 from "react";
var DeliveryOptionButton = _ref79 => {
  let {
    lineItem,
    availableDeliveryOptions,
    unavailableReason,
    className,
    onClick
  } = _ref79;
  const shippingOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  return /* @__PURE__ */React61.createElement(LinkAsButton10, {
    iconBefore: "clock",
    variant: "secondary",
    className,
    onClick: () => {
      if (unavailableReason !== void 0 || shippingOptionsQuery.isLoading) {
        return;
      }
      onClick();
    },
    "aria-disabled": Boolean(unavailableReason !== void 0 || shippingOptionsQuery.isLoading),
    disabled: shippingOptionsQuery.isLoading,
    isLoading: shippingOptionsQuery.isLoading
  }, getNumberOfDeliveryOptionCarriers(availableDeliveryOptions) <= 1 ? /* @__PURE__ */React61.createElement(FormattedMessage37, {
    id: "deliveryOption.changeDeliverySlot",
    defaultMessage: "Change delivery slot"
  }) : /* @__PURE__ */React61.createElement(FormattedMessage37, {
    id: "deliveryOption.changeDeliveryCarrierAndSlot",
    defaultMessage: "Change carrier and or delivery slot"
  }));
};
var DeliveryOptionButton_default = DeliveryOptionButton;

// src/library/components/line-item/delivery-option/DeliveryOptionModal.tsx
import { Button as Button10, Modal as Modal3, RadioGroup as RadioGroup2 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage40, useIntl as useIntl25 } from "react-intl";
import React65, { useEffect as useEffect26, useState as useState18 } from "react";
import { addDataLayerEntry as addDataLayerEntry15 } from "@printdeal/data-layer-manager";

// src/library/components/line-item/delivery-option/DeliveryOptionPriceBadge.tsx
import { Badge as Badge4 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage38, useIntl as useIntl24 } from "react-intl";
import React62 from "react";
var DeliveryOptionPriceBadge = _ref80 => {
  let {
    deliveryOption
  } = _ref80;
  var _a;
  const intl = useIntl24();
  if (((_a = deliveryOption.price) == null ? void 0 : _a.price) && deliveryOption.price.price > 0) {
    return /* @__PURE__ */React62.createElement(Badge4, {
      variant: "success-outline"
    }, intl.formatNumber(deliveryOption.price.price, {
      style: "currency",
      currency: "EUR"
    }));
  }
  return /* @__PURE__ */React62.createElement(Badge4, {
    variant: "success-outline"
  }, /* @__PURE__ */React62.createElement(FormattedMessage38, {
    id: "carrierOption.freeDelivery",
    defaultMessage: "Free delivery"
  }));
};
var DeliveryOptionPriceBadge_default = DeliveryOptionPriceBadge;

// src/library/components/line-item/delivery-option/DeliveryOptionLabel.tsx
import { FormattedMessage as FormattedMessage39, defineMessages as defineMessages7 } from "react-intl";
import React64 from "react";

// src/library/components/line-item/delivery-option/DeliveryOptionImage.tsx
import { Brand as Brand8 } from "@printdeal/ui-library";
import React63 from "react";
var DeliveryOptionImage = _ref81 => {
  let {
    deliveryOption
  } = _ref81;
  switch (deliveryOption.carrier) {
    case "postnl":
      return /* @__PURE__ */React63.createElement(Brand8, {
        brand: "postnl",
        className: "pd-h-6"
      });
    case "dhl":
      return /* @__PURE__ */React63.createElement(Brand8, {
        brand: "dhl",
        className: "pd-h-6"
      });
    default:
      return null;
  }
};
var DeliveryOptionImage_default = DeliveryOptionImage;

// src/library/components/line-item/delivery-option/DeliveryOptionLabel.tsx
var DeliveryOptionLabel = _ref82 => {
  let {
    deliveryOption
  } = _ref82;
  const translatedCarrierNames = defineMessages7({
    postnl: {
      id: "carrierOption.postnl",
      defaultMessage: "PostNL"
    },
    dhl: {
      id: "carrierOption.dhl",
      defaultMessage: "DHL"
    }
  });
  if (!deliveryOption.carrier) {
    if (deliveryOption.before) {
      return /* @__PURE__ */React64.createElement(FormattedMessage39, {
        id: "deliveryOption.before",
        defaultMessage: "Before {before}",
        values: {
          before: deliveryOption.before
        }
      });
    }
    return /* @__PURE__ */React64.createElement(FormattedMessage39, {
      id: "carrierOption.noPreference",
      defaultMessage: "No preference"
    });
  }
  return /* @__PURE__ */React64.createElement("div", {
    className: "pd-flex pd-gap-2"
  }, deliveryOption.carrier in translatedCarrierNames ? /* @__PURE__ */React64.createElement(FormattedMessage39, __spreadValues({}, translatedCarrierNames[deliveryOption.carrier])) : deliveryOption.carrier, /* @__PURE__ */React64.createElement("span", {
    className: "pd-text-dim-500"
  }, deliveryOption.before ? /* @__PURE__ */React64.createElement(FormattedMessage39, {
    id: "deliveryOption.before",
    defaultMessage: "Before {before}",
    values: {
      before: deliveryOption.before
    }
  }) : /* @__PURE__ */React64.createElement(FormattedMessage39, {
    id: "deliveryOption.defaultTimeSlot",
    defaultMessage: "Between 08:00 and 17:00"
  })), /* @__PURE__ */React64.createElement(DeliveryOptionImage_default, {
    deliveryOption
  }));
};
var DeliveryOptionLabel_default = DeliveryOptionLabel;

// src/library/components/line-item/delivery-option/DeliveryOptionModal.tsx
var DeliveryOptionModal = _ref83 => {
  let {
    lineItem,
    availableDeliveryOptions,
    isOpen,
    onClose
  } = _ref83;
  const intl = useIntl25();
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "changeDeliveryOption" /* changeDeliveryOption */
  });
  const deliveryOptionOnLineItem = getDeliveryOptionOfLineItem(lineItem, availableDeliveryOptions);
  const [selectedDeliveryOption, setSelectedDeliveryOption] = useState18(deliveryOptionOnLineItem);
  const onSubmit = event => __async(void 0, null, function* () {
    event.preventDefault();
    yield updateLineItemMutation.mutateAsync({
      lineItemId: lineItem.id,
      payload: {
        deliveryOption: {
          recsKey: selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.recsKey,
          before: selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.before
        }
      }
    }).then(() => {
      var _a, _b;
      const carrierLabel = (_a = selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.carrier) != null ? _a : "default";
      const carrierOption = (_b = selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.before) != null ? _b : "";
      addDataLayerEntry15("checkout_save_carrier_option", {
        carrierLabel,
        carrierOption
      });
      onClose();
    });
  });
  useEffect26(() => {
    setSelectedDeliveryOption(deliveryOptionOnLineItem);
  }, [deliveryOptionOnLineItem]);
  return /* @__PURE__ */React65.createElement(Modal3, {
    isOpen,
    title: getNumberOfDeliveryOptionCarriers(availableDeliveryOptions) <= 1 ? /* @__PURE__ */React65.createElement(FormattedMessage40, {
      id: "deliveryOption.changeDeliverySlot",
      defaultMessage: "Change delivery slot"
    }) : /* @__PURE__ */React65.createElement(FormattedMessage40, {
      id: "deliveryOption.changeDeliveryCarrierAndSlot",
      defaultMessage: "Change carrier and or delivery slot"
    }),
    dismissLabel: intl.formatMessage({
      id: "general.modal.close",
      defaultMessage: "Close"
    }),
    onClose
  }, /* @__PURE__ */React65.createElement(Modal3.Content, null, updateLineItemMutation.isError && /* @__PURE__ */React65.createElement("div", {
    className: "pd-mb-4"
  }, /* @__PURE__ */React65.createElement(ErrorAlert_default, {
    sentryException: {
      e: updateLineItemMutation.error,
      tags: {
        fileLocation: "DeliveryOptionModal.tsx",
        featureFunction: "updateLineItemMutation"
      },
      fingerPrint: ["checkout-frontend", "delivery-option-selector"]
    }
  }, /* @__PURE__ */React65.createElement(FormattedMessage40, {
    id: "deliveryOption.error",
    defaultMessage: "Something went wrong while setting or updating the delivery option. Please try again later."
  }))), /* @__PURE__ */React65.createElement("form", {
    id: "delivery-option-form",
    method: "POST",
    onSubmit
  }, /* @__PURE__ */React65.createElement(RadioGroup2, {
    name: "delivery-option",
    id: "delivery-option"
  }, availableDeliveryOptions.map(deliveryOption => {
    const generatedId = getDeliveryOptionId2(deliveryOption);
    return /* @__PURE__ */React65.createElement(RadioGroup2.Field, {
      key: generatedId,
      id: generatedId,
      label: /* @__PURE__ */React65.createElement(DeliveryOptionLabel_default, {
        deliveryOption
      }),
      badge: /* @__PURE__ */React65.createElement(DeliveryOptionPriceBadge_default, {
        deliveryOption
      }),
      checked: generatedId === getDeliveryOptionId2(selectedDeliveryOption),
      onChange: () => {
        setSelectedDeliveryOption(deliveryOption);
      }
    });
  })))), /* @__PURE__ */React65.createElement(Modal3.Footer, {
    className: "pd-flex pd-justify-end"
  }, /* @__PURE__ */React65.createElement(Button10, {
    type: "submit",
    form: "delivery-option-form",
    isLoading: updateLineItemMutation.isPending
  }, /* @__PURE__ */React65.createElement(FormattedMessage40, {
    id: "deliveryOption.confirmDeliveryOption",
    defaultMessage: "Confirm delivery option"
  }))));
};
var DeliveryOptionModal_default = DeliveryOptionModal;

// src/library/components/line-item/delivery-option/DeliveryOptionDescription.tsx
import { FormattedMessage as FormattedMessage41 } from "react-intl";
import React66 from "react";
var DeliveryOptionDescription = _ref84 => {
  let {
    deliveryOption
  } = _ref84;
  if (!(deliveryOption == null ? void 0 : deliveryOption.before) && !(deliveryOption == null ? void 0 : deliveryOption.recsKey)) {
    return null;
  }
  return /* @__PURE__ */React66.createElement("div", {
    className: "pd-flex pd-items-center"
  }, deliveryOption.before ? /* @__PURE__ */React66.createElement(FormattedMessage41, {
    id: "deliveryOption.before",
    defaultMessage: "Before {before}",
    values: {
      before: deliveryOption.before
    }
  }) : /* @__PURE__ */React66.createElement(FormattedMessage41, {
    id: "deliveryOption.defaultTimeSlot",
    defaultMessage: "Between 08:00 and 17:00"
  }), deliveryOption.recsKey && /* @__PURE__ */React66.createElement("div", {
    className: "pd-ml-2"
  }, /* @__PURE__ */React66.createElement(DeliveryOptionImage_default, {
    deliveryOption
  })));
};
var DeliveryOptionDescription_default = DeliveryOptionDescription;

// src/library/components/line-item/delivery-option/DeliveryOptionSelector.tsx
var DeliveryOptionSelector = _ref85 => {
  let {
    lineItem
  } = _ref85;
  var _a;
  const intl = useIntl26();
  const shippingOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  const [isModalOpen, setIsModalOpen] = useState19(false);
  const [availableDeliveryOptions, setAvailableDeliveryOptions] = useState19([]);
  const [deliveryOptionFromLineItem, setDeliveryFromLineItem] = useState19(void 0);
  const [unavailableReason, setUnavailableReason] = useState19(void 0);
  useEffect27(() => {
    if (shippingOptionsQuery.data) {
      if (shippingOptionsQuery.data.deliveryOptions.length) {
        const deliveryOptionOnLineItem = getDeliveryOptionOfLineItem(lineItem, shippingOptionsQuery.data.deliveryOptions);
        setDeliveryFromLineItem(deliveryOptionOnLineItem);
        setAvailableDeliveryOptions(shippingOptionsQuery.data.deliveryOptions);
      } else {
        setAvailableDeliveryOptions([]);
      }
    }
    if (shippingOptionsQuery.error) {
      setAvailableDeliveryOptions([]);
    }
  }, [shippingOptionsQuery.status, (_a = lineItem.custom) == null ? void 0 : _a.fields, shippingOptionsQuery.data, shippingOptionsQuery.error, lineItem]);
  useEffect27(() => {
    if (isReviewGroupLead(lineItem) || availableDeliveryOptions.length === 0 && shippingOptionsQuery.isSuccess) {
      setUnavailableReason(0 /* NotPossibleForProduct */);
      return;
    }
    if (hasSplitShipment(lineItem)) {
      setUnavailableReason(2 /* HasSplitShipmentOnLineItem */);
      return;
    }
    if (hasPickupPoint(lineItem)) {
      setUnavailableReason(3 /* HasPickupPointOnLineItem */);
      return;
    }
    if (availableDeliveryOptions.length > 0) {
      setUnavailableReason(void 0);
      return;
    }
    setUnavailableReason(1 /* CouldNotFetchDeliveryOptions */);
  }, [availableDeliveryOptions, lineItem, shippingOptionsQuery.isSuccess]);
  const getTooltipText = reason => {
    switch (reason) {
      case 0 /* NotPossibleForProduct */:
        return intl.formatMessage({
          id: "deliveryOptions.notPossibleWithProduct",
          defaultMessage: "Delivery options are currently not possible for this product"
        });
      case 2 /* HasSplitShipmentOnLineItem */:
        return intl.formatMessage({
          id: "deliveryOptions.cannotBeCombinedWithSplitShipments",
          defaultMessage: "Delivery options cannot be combined with split shipments"
        });
      case 3 /* HasPickupPointOnLineItem */:
        return intl.formatMessage({
          id: "deliveryOptions.cannotBeCombinedWithPickupPoint",
          defaultMessage: "Delivery options cannot be combined with a pickup point"
        });
      case 1 /* CouldNotFetchDeliveryOptions */:
      default:
        return intl.formatMessage({
          id: "deliveryOptions.couldNotFetchDeliveryOptions",
          defaultMessage: "Could not fetch delivery options"
        });
    }
  };
  return /* @__PURE__ */React67.createElement("div", {
    className: "pd-flex pd-flex-col pd-gap-2"
  }, /* @__PURE__ */React67.createElement(Heading10, {
    as: "h4"
  }, getNumberOfDeliveryOptionCarriers(availableDeliveryOptions) <= 1 ? /* @__PURE__ */React67.createElement(FormattedMessage42, {
    id: "deliveryOption.deliverySlot",
    defaultMessage: "Delivery slot"
  }) : /* @__PURE__ */React67.createElement(FormattedMessage42, {
    id: "deliveryOption.deliveryCarrierAndSlot",
    defaultMessage: "Carrier and delivery slot"
  })), /* @__PURE__ */React67.createElement(DeliveryOptionDescription_default, {
    deliveryOption: deliveryOptionFromLineItem
  }), unavailableReason ? /* @__PURE__ */React67.createElement(Tooltip4, {
    placement: "top",
    trigger: /* @__PURE__ */React67.createElement(Tooltip4.Trigger, {
      as: DeliveryOptionButton_default,
      lineItem,
      availableDeliveryOptions,
      unavailableReason,
      className: "pd-self-start pd-text-sm",
      onClick: () => {
        setIsModalOpen(true);
        addDataLayerEntry16("click_carrier_option");
      }
    })
  }, getTooltipText(unavailableReason)) : /* @__PURE__ */React67.createElement(DeliveryOptionButton_default, {
    lineItem,
    availableDeliveryOptions,
    unavailableReason,
    className: "pd-self-start pd-text-sm",
    onClick: () => {
      setIsModalOpen(true);
      addDataLayerEntry16("click_carrier_option");
    }
  }), /* @__PURE__ */React67.createElement(DeliveryOptionModal_default, {
    lineItem,
    availableDeliveryOptions,
    isOpen: isModalOpen,
    onClose: () => setIsModalOpen(false)
  }));
};
var DeliveryOptionSelector_default = DeliveryOptionSelector;

// src/library/components/design-system/line-item/LineItemShippingAddress.tsx
import { Alert as Alert10, Heading as Heading11 } from "@printdeal/ui-library";
import React73, { useState as useState22 } from "react";
import { FormattedMessage as FormattedMessage47 } from "react-intl";
import { AddressContent } from "@printdeal/address-frontend";
import { getLineItemQuantity as getLineItemQuantity2 } from "@printdeal/checkout-shared";
import { hasSplitShipment as hasSplitShipment3, hasPickupPoint as hasPickupPoint3 } from "@printdeal/business-logic";
import { useQueryClient as useQueryClient4 } from "@tanstack/react-query";

// src/library/components/line-item/shipping-address/ShippingAddressButton.tsx
import { Button as Button11 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage43 } from "react-intl";
import React68 from "react";
import { hasSplitShipment as hasSplitShipment2, hasPickupPoint as hasPickupPoint2 } from "@printdeal/business-logic";
var ShippingAddressButton = _ref86 => {
  let {
    lineItem,
    onClick
  } = _ref86;
  const hasSplitShipmentOnLineItem2 = hasSplitShipment2(lineItem);
  const hasPickupPointOnLineItem = hasPickupPoint2(lineItem);
  return /* @__PURE__ */React68.createElement(Button11, {
    className: "pd-self-start",
    variant: "secondary",
    iconBefore: "edit",
    onClick
  }, /* @__PURE__ */React68.createElement(FormattedMessage43, {
    id: "checkout.changeShippingAddress",
    defaultMessage: "Change shipping address"
  }), (hasSplitShipmentOnLineItem2 || hasPickupPointOnLineItem) && " *");
};
var ShippingAddressButton_default = ShippingAddressButton;

// src/library/components/line-item/shipping-address/ShippingAddressPickupPointContent.tsx
import React69 from "react";
import { getPickupPointHref } from "@printdeal/business-logic";
import { FormattedMessage as FormattedMessage44 } from "react-intl";
import { Spinner as Spinner7 } from "@printdeal/ui-library";
var ShippingAddressPickupPointContent = _ref87 => {
  let {
    lineItem
  } = _ref87;
  const pickupPointHref = getPickupPointHref(lineItem);
  const pickupPointQuery = useGetPickupPointQuery({
    pickupPointId: pickupPointHref && getPickupPointId(pickupPointHref),
    enabled: Boolean(pickupPointHref)
  });
  return /* @__PURE__ */React69.createElement(React69.Fragment, null, pickupPointQuery.isError && /* @__PURE__ */React69.createElement(ErrorAlert_default, {
    scrollIntoView: false,
    sentryException: {
      e: pickupPointQuery.error,
      fingerPrint: ["pickup-point-details"]
    }
  }, /* @__PURE__ */React69.createElement(FormattedMessage44, {
    id: "pickupPointDetails.error",
    defaultMessage: "Could not fetch pickup point details. If the problem persists, please try setting a new pickup point or delivery address."
  })), pickupPointQuery.isLoading && /* @__PURE__ */React69.createElement(Spinner7, null), pickupPointQuery.data && /* @__PURE__ */React69.createElement(React69.Fragment, null, /* @__PURE__ */React69.createElement(FormattedMessage44, {
    id: "pickupPointDetails.pickupPoint",
    defaultMessage: "Pickup point"
  }), ":", /* @__PURE__ */React69.createElement("div", null, pickupPointQuery.data.name), /* @__PURE__ */React69.createElement("div", null, pickupPointQuery.data.address.addressLine1), /* @__PURE__ */React69.createElement("div", null, pickupPointQuery.data.address.postalCode, " ", pickupPointQuery.data.address.city)));
};
var ShippingAddressPickupPointContent_default = ShippingAddressPickupPointContent;

// src/library/components/line-item/shipping-address/ShippingAddressModal.tsx
import { Button as Button13, LinkAsButton as LinkAsButton11, Modal as Modal4 } from "@printdeal/ui-library";
import React72, { useState as useState21 } from "react";
import clsx5 from "clsx";
import { AddressFormSubmitButton, AddressListView, CreateAddressView, UpdateAddressView } from "@printdeal/address-frontend";
import { FormattedMessage as FormattedMessage46, useIntl as useIntl28 } from "react-intl";

// src/library/components/line-item/shipping-address/ShippingAddressPanel.tsx
import { useIntl as useIntl27 } from "react-intl";
import React70 from "react";
import { AddressDeleteModal, AddressPanel } from "@printdeal/address-frontend";
import clsx4 from "clsx";
var ShippingAddressPanel = _ref88 => {
  let {
    address,
    isDefaultBillingAddress,
    isDefaultShippingAddress,
    focusedAddressId,
    setView,
    setMutatingAddressId,
    setShowSuccessAlertForCreatedAddressId,
    setShowSuccessAlertForUpdatedAddressId,
    deleteAddressModalIsOpen,
    setDeleteAddressModalIsOpen,
    footer
  } = _ref88;
  const intl = useIntl27();
  return /* @__PURE__ */React70.createElement(React70.Fragment, null, /* @__PURE__ */React70.createElement(AddressPanel, {
    key: address.id,
    address,
    isDefaultBillingAddress,
    isDefaultShippingAddress,
    className: clsx4({
      "pd-border-info-500": focusedAddressId === address.id
    }),
    dropdownItems: [{
      title: intl.formatMessage({
        id: "checkout.editAddress",
        defaultMessage: "Edit address"
      }),
      iconBefore: "edit",
      onClick: () => {
        setMutatingAddressId(address.id);
        setShowSuccessAlertForCreatedAddressId(void 0);
        setShowSuccessAlertForUpdatedAddressId(void 0);
        setView("edit");
      }
    }, ...(!isDefaultBillingAddress && !isDefaultShippingAddress ? [{
      title: intl.formatMessage({
        id: "checkout.deleteAddress",
        defaultMessage: "Delete address"
      }),
      iconBefore: "trashcan",
      onClick: () => {
        setDeleteAddressModalIsOpen(address.id);
      }
    }] : [])],
    footer
  }), /* @__PURE__ */React70.createElement(AddressDeleteModal, {
    addressId: address.id,
    isModalOpen: deleteAddressModalIsOpen === address.id,
    setIsModalOpen: setDeleteAddressModalIsOpen,
    onSuccess: () => {
      setShowSuccessAlertForCreatedAddressId(void 0);
      setShowSuccessAlertForUpdatedAddressId(void 0);
      setMutatingAddressId(void 0);
    }
  }));
};
var ShippingAddressPanel_default = ShippingAddressPanel;

// src/library/components/line-item/shipping-address/ShippingAddressPanelFooter.tsx
import React71 from "react";
import { Alert as Alert9, Button as Button12 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage45 } from "react-intl";
import { getMainLineItems as getMainLineItems4 } from "@printdeal/checkout-shared";

// src/library/hooks/address/useValidateAddress.ts
import { addressSchema } from "@printdeal/address-frontend";
import { useEffect as useEffect28, useState as useState20 } from "react";
import { ValidationError } from "yup";
function useValidateAddress(_ref89) {
  let {
    address,
    requireEmail
  } = _ref89;
  const [validationErrors, setValidationErrors] = useState20([]);
  useEffect28(() => {
    setValidationErrors([]);
    try {
      addressSchema({
        required: requireEmail
      }).validateSync(address, {
        abortEarly: false
      });
      setValidationErrors([]);
    } catch (error) {
      if (error instanceof ValidationError) {
        setValidationErrors(error.inner);
      }
    }
  }, [address, requireEmail]);
  return validationErrors;
}

// src/library/components/design-system/address/AddressError.tsx
import { useTranslatedAddressYupErrorMessage } from "@printdeal/address-frontend";
var AddressError = _ref90 => {
  let {
    error
  } = _ref90;
  const translatedError = useTranslatedAddressYupErrorMessage({
    fieldName: error.path,
    errorMessage: error.message
  });
  return translatedError;
};
var AddressError_default = AddressError;

// src/library/components/line-item/shipping-address/ShippingAddressPanelFooter.tsx
var ShippingAddressPanelFooter = _ref91 => {
  let {
    lineItem,
    address,
    patchCartMutation,
    updateLineItemMutation,
    mutatingAddressId,
    setView,
    setMutatingAddressId,
    setDeleteAddressModalIsOpen,
    onClose
  } = _ref91;
  const {
    cart
  } = useCart();
  const validationErrors = useValidateAddress({
    address,
    requireEmail: false
  });
  const totalLineItemsQuantity = cart ? getMainLineItems4(cart).length : 0;
  return validationErrors.length === 0 ? /* @__PURE__ */React71.createElement(React71.Fragment, null, totalLineItemsQuantity > 1 && /* @__PURE__ */React71.createElement(Button12, {
    variant: "secondary",
    className: "pd-w-full md:pd-w-auto",
    isLoading: patchCartMutation.isPending && mutatingAddressId === address.id,
    onClick: () => {
      setMutatingAddressId(address.id);
      patchCartMutation.mutateAsync({
        action: {
          name: "setShippingAddress",
          value: __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
            id: address.id.trim(),
            firstName: address.firstName.trim(),
            lastName: address.lastName.trim()
          }, address.email && {
            email: address.email.trim()
          }), address.phone && {
            phone: address.phone.trim()
          }), address.company && {
            company: address.company.trim()
          }), {
            country: address.country.trim(),
            postalCode: address.postalCode.trim(),
            streetNumber: address.streetNumber.trim(),
            streetName: address.streetName.trim(),
            city: address.city.trim()
          }), address.additionalStreetInfo && {
            additionalStreetInfo: address.additionalStreetInfo.trim()
          })
        }
      }).then(() => {
        patchCartMutation.reset();
        onClose();
      });
    }
  }, /* @__PURE__ */React71.createElement(FormattedMessage45, {
    id: "checkout.button.selectAddressForAllProducts",
    defaultMessage: "Select address for all products"
  })), /* @__PURE__ */React71.createElement(Button12, {
    className: "pd-w-full md:pd-w-auto",
    isLoading: updateLineItemMutation.isPending && mutatingAddressId === address.id,
    onClick: () => {
      setMutatingAddressId(address.id);
      updateLineItemMutation.mutateAsync({
        lineItemId: lineItem.id,
        payload: {
          shippingAddresses: [{
            address: __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
              id: address.id.trim(),
              firstName: address.firstName.trim(),
              lastName: address.lastName.trim()
            }, address.email && {
              email: address.email.trim()
            }), address.phone && {
              phone: address.phone.trim()
            }), address.company && {
              company: address.company.trim()
            }), {
              country: address.country.trim(),
              postalCode: address.postalCode.trim(),
              streetNumber: address.streetNumber.trim(),
              streetName: address.streetName.trim(),
              city: address.city.trim()
            }), address.additionalStreetInfo && {
              additionalStreetInfo: address.additionalStreetInfo.trim()
            }),
            quantity: lineItem.quantity
          }]
        }
      }).then(() => {
        updateLineItemMutation.reset();
        onClose();
      });
    }
  }, totalLineItemsQuantity > 1 ? /* @__PURE__ */React71.createElement(FormattedMessage45, {
    id: "checkout.button.selectAddressForOneProduct",
    defaultMessage: "Select address for only this product"
  }) : /* @__PURE__ */React71.createElement(FormattedMessage45, {
    id: "checkout.button.selectAddress",
    defaultMessage: "Select address"
  }))) : /* @__PURE__ */React71.createElement(Alert9, {
    variant: "error"
  }, /* @__PURE__ */React71.createElement("div", {
    className: "pd-flex pd-flex-col pd-gap-2"
  }, /* @__PURE__ */React71.createElement(FormattedMessage45, {
    id: "checkout.invalidAddress",
    defaultMessage: "This address can currently not be selected, because it is missing certain data or contains invalid data. To make the address usable again, you can edit the address and fix the validation errors. Alternatively, if you no longer need this address, you can delete it."
  }), /* @__PURE__ */React71.createElement("ul", null, validationErrors.map(error => /* @__PURE__ */React71.createElement("li", {
    key: error.path
  }, /* @__PURE__ */React71.createElement(AddressError_default, {
    error
  })))), /* @__PURE__ */React71.createElement("div", {
    className: "pd-flex pd-gap-2"
  }, /* @__PURE__ */React71.createElement(Button12, {
    variant: "secondary",
    iconBefore: "edit",
    onClick: () => {
      setMutatingAddressId(address.id);
      setView("edit");
    }
  }, /* @__PURE__ */React71.createElement(FormattedMessage45, {
    id: "checkout.editAddress",
    defaultMessage: "Edit address"
  })), /* @__PURE__ */React71.createElement(Button12, {
    variant: "secondary",
    iconBefore: "trashcan",
    onClick: () => setDeleteAddressModalIsOpen(address.id)
  }, /* @__PURE__ */React71.createElement(FormattedMessage45, {
    id: "checkout.deleteAddress",
    defaultMessage: "Delete address"
  })))));
};
var ShippingAddressPanelFooter_default = ShippingAddressPanelFooter;

// src/library/components/line-item/shipping-address/ShippingAddressModal.tsx
var ShippingAddressModal = _ref92 => {
  let {
    lineItem,
    isOpen,
    onClose
  } = _ref92;
  const intl = useIntl28();
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "setShippingAddress" /* setShippingAddress */
  });
  const updateCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "setShippingAddress" /* setShippingAddress */
    }
  });
  const [view, setView] = useState21("list");
  const [mutatingAddressId, setMutatingAddressId] = useState21();
  const [showSuccessAlertForCreatedAddressId, setShowSuccessAlertForCreatedAddressId] = useState21();
  const [showSuccessAlertForUpdatedAddressId, setShowSuccessAlertForUpdatedAddressId] = useState21();
  const [deleteAddressModalIsOpen, setDeleteAddressModalIsOpen] = useState21();
  return /* @__PURE__ */React72.createElement(Modal4, {
    isOpen,
    onClose: () => {
      updateLineItemMutation.reset();
      updateCartMutation.reset();
      setView("list");
      setMutatingAddressId(void 0);
      setShowSuccessAlertForCreatedAddressId(void 0);
      setShowSuccessAlertForUpdatedAddressId(void 0);
      onClose();
    },
    size: "lg",
    dismissLabel: intl.formatMessage({
      id: "general.modal.close",
      defaultMessage: "Close"
    }),
    title: intl.formatMessage({
      id: "checkout.selectShippingAddress",
      defaultMessage: "Select shipping address"
    })
  }, /* @__PURE__ */React72.createElement(Modal4.Content, {
    className: clsx5("pd-h-[90vh]", {
      "pd-p-0": view === "list"
    })
  }, view === "list" && /* @__PURE__ */React72.createElement(AddressListView, {
    className: "pd-p-4",
    showSuccessAlertForCreatedAddressId,
    showSuccessAlertForUpdatedAddressId,
    renderAddressPanel: (_a, focusedAddressId) => {
      var _b = _a,
        {
          address
        } = _b,
        data = __objRest(_b, ["address"]);
      return /* @__PURE__ */React72.createElement(ShippingAddressPanel_default, {
        address,
        isDefaultBillingAddress: data.isDefaultBillingAddress,
        isDefaultShippingAddress: data.isDefaultShippingAddress,
        focusedAddressId,
        setView,
        setMutatingAddressId,
        setShowSuccessAlertForCreatedAddressId,
        setShowSuccessAlertForUpdatedAddressId,
        deleteAddressModalIsOpen,
        setDeleteAddressModalIsOpen,
        footer: /* @__PURE__ */React72.createElement(ShippingAddressPanelFooter_default, {
          lineItem,
          address,
          patchCartMutation: updateCartMutation,
          updateLineItemMutation,
          mutatingAddressId,
          setView,
          setMutatingAddressId,
          setDeleteAddressModalIsOpen,
          onClose
        })
      });
    },
    alert: (updateLineItemMutation.isError || updateCartMutation.isError) && /* @__PURE__ */React72.createElement(ErrorAlert_default, {
      className: "pd-m-0",
      scrollIntoView: true,
      sentryException: {
        e: updateLineItemMutation.error || updateCartMutation.error,
        tags: {
          fileLocation: "ShippingAddressModal.tsx",
          featureFunction: "ShippingAddressModal"
        },
        fingerPrint: ["checkout", "update-shipping-address"]
      }
    }, /* @__PURE__ */React72.createElement(FormattedMessage46, {
      id: "checkout.shippingAddress.error",
      defaultMessage: "An error occurred while updating the shipping address. Please try again."
    }))
  }), view === "create" && /* @__PURE__ */React72.createElement(CreateAddressView, {
    onSubmitSuccess: address => {
      setShowSuccessAlertForCreatedAddressId(address.id);
      setView("list");
    }
  }), view === "edit" && /* @__PURE__ */React72.createElement(UpdateAddressView, {
    mutatingAddressId,
    onSubmitSuccess: () => {
      setShowSuccessAlertForUpdatedAddressId(mutatingAddressId);
      setView("list");
    }
  })), /* @__PURE__ */React72.createElement(Modal4.Footer, null, view === "list" && /* @__PURE__ */React72.createElement("div", {
    className: "pd-flex pd-justify-end"
  }, /* @__PURE__ */React72.createElement(Button13, {
    variant: "secondary",
    iconBefore: "plus",
    onClick: () => setView("create")
  }, /* @__PURE__ */React72.createElement(FormattedMessage46, {
    id: "checkout.addAddress",
    defaultMessage: "Add address"
  }))), (view === "create" || view === "edit") && /* @__PURE__ */React72.createElement("div", {
    className: "pd-flex pd-items-center pd-justify-between"
  }, /* @__PURE__ */React72.createElement(LinkAsButton11, {
    className: "pd-text-sm",
    iconBefore: "chevron-left",
    variant: "secondary",
    onClick: () => {
      setShowSuccessAlertForCreatedAddressId(void 0);
      setShowSuccessAlertForUpdatedAddressId(void 0);
      setView("list");
    }
  }, /* @__PURE__ */React72.createElement(FormattedMessage46, {
    id: "checkout.backToAddressList",
    defaultMessage: "Back to address list"
  })), /* @__PURE__ */React72.createElement(AddressFormSubmitButton, null))));
};
var ShippingAddressModal_default = ShippingAddressModal;

// src/library/components/design-system/line-item/LineItemShippingAddress.tsx
var LineItemShippingAddress = _ref93 => {
  let {
    lineItem
  } = _ref93;
  const queryClient = useQueryClient4();
  const {
    cartId,
    invalidateCart
  } = useCart();
  const shippingAddresses = getShippingAddressesFromLineItem(lineItem);
  const shippingAddress = shippingAddresses && shippingAddresses[0];
  const hasSplitShipmentOnLineItem2 = hasSplitShipment3(lineItem);
  const hasPickupPointOnLineItem = hasPickupPoint3(lineItem);
  const totalQuantity = hasSplitShipmentOnLineItem2 ? shippingAddress == null ? void 0 : shippingAddress.quantity : getLineItemQuantity2(lineItem);
  const [isModalOpen, setIsModalOpen] = useState22(false);
  return /* @__PURE__ */React73.createElement("div", {
    className: "pd-flex pd-flex-col pd-gap-3"
  }, /* @__PURE__ */React73.createElement(Heading11, {
    as: "h4"
  }, /* @__PURE__ */React73.createElement(FormattedMessage47, {
    id: "checkout.shippingAddress",
    defaultMessage: "Shipping address"
  })), /* @__PURE__ */React73.createElement("div", null, hasPickupPointOnLineItem ? /* @__PURE__ */React73.createElement(ShippingAddressPickupPointContent_default, {
    lineItem
  }) : /* @__PURE__ */React73.createElement("div", null, shippingAddress ? /* @__PURE__ */React73.createElement(AddressContent, {
    address: shippingAddress,
    showFirstAndLastName: true
  }) : /* @__PURE__ */React73.createElement(Alert10, {
    variant: "error"
  }, /* @__PURE__ */React73.createElement(FormattedMessage47, {
    id: "checkout.shippingAddressNotSet",
    defaultMessage: "Please select a shipping address"
  }))), /* @__PURE__ */React73.createElement("div", {
    className: "pd-text-sm pd-text-dim-600"
  }, "(", /* @__PURE__ */React73.createElement(FormattedMessage47, {
    id: "checkout.lineItem.quantityCount",
    defaultMessage: "{quantity} {quantity, plural, one {piece} other {pieces}}",
    values: {
      quantity: totalQuantity
    }
  }), ")")), /* @__PURE__ */React73.createElement(ShippingAddressButton_default, {
    lineItem,
    onClick: () => setIsModalOpen(true)
  }), /* @__PURE__ */React73.createElement(ShippingAddressModal_default, {
    lineItem,
    isOpen: isModalOpen,
    onClose: () => {
      queryClient.resetQueries({
        queryKey: ["getShippingOptions" /* getShippingOptions */, lineItem.id, cartId]
      });
      invalidateCart();
      setIsModalOpen(false);
    }
  }), (hasSplitShipmentOnLineItem2 || hasPickupPointOnLineItem) && /* @__PURE__ */React73.createElement("div", {
    className: "pd-text-xs pd-text-dim-500"
  }, "*", " ", hasSplitShipmentOnLineItem2 ? /* @__PURE__ */React73.createElement(FormattedMessage47, {
    id: "cart.address.replaceSplitShipmentWithShippingAddressExplanation",
    defaultMessage: "If you change to a different shipping address, it will automatically replace the extra addresses you have currently selected."
  }) : /* @__PURE__ */React73.createElement(FormattedMessage47, {
    id: "cart.address.replacePickupPointWithShippingAddressExplanation",
    defaultMessage: "If you change to a different shipping address, it will automatically replace the pickup point you have currently selected."
  })));
};
var LineItemShippingAddress_default = LineItemShippingAddress;

// src/library/components/line-item/split-shipment/SplitShipmentSelector.tsx
import { Heading as Heading12, Tooltip as Tooltip5 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage51, useIntl as useIntl31 } from "react-intl";
import React77, { useEffect as useEffect30, useState as useState24 } from "react";
import { AddressContent as AddressContent2, countries as countries2 } from "@printdeal/address-frontend";
import { configurationProvider as configurationProvider10 } from "@printdeal/configuration";
import { hasPickupPoint as hasPickupPoint4 } from "@printdeal/business-logic";

// src/library/components/line-item/split-shipment/SplitShipmentButton.tsx
import { LinkAsButton as LinkAsButton12 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage48 } from "react-intl";
import React74 from "react";
var SplitShipmentButton = _ref94 => {
  let {
    lineItem,
    unavailableReason,
    className,
    onClick
  } = _ref94;
  const shippingOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  const shippingAddresses = getShippingAddressesFromLineItem(lineItem);
  return /* @__PURE__ */React74.createElement(LinkAsButton12, {
    iconBefore: shippingAddresses && shippingAddresses.length > 1 ? "edit" : "plus",
    variant: "secondary",
    className,
    onClick: () => {
      if (unavailableReason !== void 0 || shippingOptionsQuery.isLoading) {
        return;
      }
      onClick();
    },
    "aria-disabled": Boolean(unavailableReason !== void 0 || shippingOptionsQuery.isLoading),
    disabled: shippingOptionsQuery.isLoading,
    isLoading: shippingOptionsQuery.isLoading
  }, shippingAddresses && shippingAddresses.length > 1 ? /* @__PURE__ */React74.createElement(FormattedMessage48, {
    id: "checkout.splitshipment.changeExtraShippingAddresses",
    defaultMessage: "Change extra shipping addresses"
  }) : /* @__PURE__ */React74.createElement(FormattedMessage48, {
    id: "checkout.splitshipment.addExtraShippingAddresses",
    defaultMessage: "Add extra shipping addresses"
  }), shippingOptionsQuery.data && shippingOptionsQuery.data.splitShipment.price && /* @__PURE__ */React74.createElement(React74.Fragment, null, " (", /* @__PURE__ */React74.createElement(Money_default, {
    value: shippingOptionsQuery.data.splitShipment.price.centAmount,
    currency: shippingOptionsQuery.data.splitShipment.price.currencyCode
  }), ")"));
};
var SplitShipmentButton_default = SplitShipmentButton;

// src/library/components/line-item/split-shipment/SplitShipmentModal.tsx
import { Alert as Alert12, Button as Button14, Checkbox, Label, LinkAsButton as LinkAsButton13, Modal as Modal6, TextInput as TextInput2, Transition } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage50, useIntl as useIntl30 } from "react-intl";
import React76, { useCallback as useCallback4, useEffect as useEffect29, useMemo as useMemo9, useState as useState23 } from "react";
import clsx6 from "clsx";
import { AddressDeleteModal as AddressDeleteModal2, AddressFormSubmitButton as AddressFormSubmitButton2, AddressListView as AddressListView2, AddressPanel as AddressPanel2, countries, CreateAddressView as CreateAddressView2, UpdateAddressView as UpdateAddressView2 } from "@printdeal/address-frontend";

// src/library/components/line-item/split-shipment/SplitShipmentAlertModal.tsx
import { Alert as Alert11, Modal as Modal5 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage49, useIntl as useIntl29 } from "react-intl";
import React75 from "react";
var SplitShipmentAlertModal = _ref95 => {
  let {
    isModalOpen,
    setIsModalOpen,
    submitButton
  } = _ref95;
  const intl = useIntl29();
  return /* @__PURE__ */React75.createElement(Modal5, {
    isOpen: isModalOpen,
    onClose: () => setIsModalOpen(!isModalOpen),
    dismissLabel: "Close",
    size: "sm",
    title: intl.formatMessage({
      id: "checkout.splitShipment.alertModal.title",
      defaultMessage: "Pay attention"
    })
  }, /* @__PURE__ */React75.createElement(Modal5.Content, null, /* @__PURE__ */React75.createElement(Alert11, {
    variant: "warning"
  }, /* @__PURE__ */React75.createElement(FormattedMessage49, {
    id: "checkout.splitShipment.alertModal.content",
    defaultMessage: "You have changed one or more addresses. These changes have not yet been applied to your shopping cart. Apply these address changes to your shopping cart."
  }))), /* @__PURE__ */React75.createElement(Modal5.Footer, {
    className: "pd-flex pd-flex-col pd-gap-2"
  }, submitButton));
};
var SplitShipmentAlertModal_default = SplitShipmentAlertModal;

// src/library/components/line-item/split-shipment/SplitShipmentModal.tsx
var SplitShipmentModal = _ref96 => {
  let {
    lineItem,
    isOpen,
    onClose
  } = _ref96;
  const intl = useIntl30();
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "setSplitShipment" /* setSplitShipment */
  });
  const removeSplitShipmentMutation = useUpdateLineItemMutation({
    context: "setShippingAddress" /* setShippingAddress */
  });
  const shippingAddresses = getShippingAddressesFromLineItem(lineItem);
  const defaultShippingAddress = shippingAddresses && shippingAddresses[0];
  const transformedShippingAddresses = useMemo9(() => {
    if (!shippingAddresses) return [];
    return shippingAddresses.map(shippingAddress => {
      const _a = shippingAddress,
        {
          quantity
        } = _a,
        address = __objRest(_a, ["quantity"]);
      return {
        address,
        quantity: Number(quantity)
      };
    });
  }, [shippingAddresses]);
  const [view, setView] = useState23("list");
  const [mutatingAddressId, setMutatingAddressId] = useState23();
  const [showSuccessAlertForCreatedAddressId, setShowSuccessAlertForCreatedAddressId] = useState23();
  const [showSuccessAlertForUpdatedAddressId, setShowSuccessAlertForUpdatedAddressId] = useState23();
  const [deleteAddressModalIsOpen, setDeleteAddressModalIsOpen] = useState23();
  const [selectedItems, setSelectedItems] = useState23([]);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState23(false);
  const [submitCount, setSubmitCount] = useState23(0);
  useEffect29(() => {
    const lineItemShippingAddresses = getShippingAddressesFromLineItem(lineItem);
    if (lineItemShippingAddresses) {
      setSelectedItems(lineItemShippingAddresses.map(shippingAddress => {
        const _a = shippingAddress,
          {
            quantity
          } = _a,
          address = __objRest(_a, ["quantity"]);
        return {
          address,
          quantity: Number(quantity)
        };
      }));
    }
  }, [lineItem]);
  const itemsWithoutQuantity = selectedItems.filter(item => !item.quantity);
  const invalidQuantityFields = useMemo9(() => selectedItems.filter(item => {
    if (defaultShippingAddress && item.address.id === defaultShippingAddress.id) {
      return false;
    }
    if (item.quantity && item.quantity >= lineItem.quantity) {
      return true;
    }
    const totalSelectedQuantity = selectedItems.reduce((total, selectedItem) => total + (selectedItem.quantity || 0), 0);
    return totalSelectedQuantity > lineItem.quantity;
  }), [selectedItems, lineItem, defaultShippingAddress]);
  const calculateTotalQuantityForOthers = useCallback4((items, excludeAddressId) => items.reduce((total, item) => {
    if (defaultShippingAddress && item.address.id !== defaultShippingAddress.id && item.address.id !== excludeAddressId) {
      return total + (item.quantity || 0);
    }
    return total;
  }, 0), [defaultShippingAddress]);
  const deleteSelectedItem = useCallback4(addressId => {
    const updatedItems = selectedItems.filter(item => item.address.id !== addressId).map(item => {
      if (defaultShippingAddress && item.address.id === defaultShippingAddress.id) {
        return __spreadProps(__spreadValues({}, item), {
          quantity: Math.max(lineItem.quantity - calculateTotalQuantityForOthers(selectedItems, addressId), 1)
        });
      }
      return item;
    });
    setSelectedItems(updatedItems);
  }, [selectedItems, defaultShippingAddress, lineItem, calculateTotalQuantityForOthers]);
  const closeModal = () => {
    onClose();
    updateLineItemMutation.reset();
    removeSplitShipmentMutation.reset();
    setView("list");
    setMutatingAddressId(void 0);
    setShowSuccessAlertForCreatedAddressId(void 0);
    setShowSuccessAlertForUpdatedAddressId(void 0);
    setSelectedItems(transformedShippingAddresses);
  };
  const handleSetSplitShipmentAddresses = () => {
    updateLineItemMutation.mutateAsync({
      lineItemId: lineItem.id,
      payload: {
        shippingAddresses: selectedItems.map(item => {
          var _a;
          return {
            address: __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
              id: item.address.id.trim(),
              firstName: item.address.firstName.trim(),
              lastName: item.address.lastName.trim()
            }, item.address.email && {
              email: item.address.email.trim()
            }), item.address.phone && {
              phone: item.address.phone.trim()
            }), item.address.company && {
              company: item.address.company.trim()
            }), {
              country: item.address.country.trim(),
              postalCode: item.address.postalCode.trim(),
              streetNumber: item.address.streetNumber.trim(),
              streetName: item.address.streetName.trim(),
              city: item.address.city.trim()
            }), item.address.additionalStreetInfo && {
              additionalStreetInfo: item.address.additionalStreetInfo.trim()
            }),
            quantity: (_a = item.quantity) != null ? _a : 0
          };
        })
      }
    }).then(() => {
      onClose();
      setMutatingAddressId(void 0);
      setShowSuccessAlertForCreatedAddressId(void 0);
      setShowSuccessAlertForUpdatedAddressId(void 0);
      setSubmitCount(0);
      setIsAlertModalOpen(false);
      updateLineItemMutation.reset();
    }).catch(() => {
      setIsAlertModalOpen(false);
    });
  };
  return /* @__PURE__ */React76.createElement(Modal6, {
    isOpen,
    onClose: () => {
      const hasUpdatedAddress = selectedItems.some(item => {
        const originalItem = transformedShippingAddresses.find(original => original.address.id === item.address.id);
        if (!originalItem) {
          return false;
        }
        return item.address.firstName !== originalItem.address.firstName || item.address.lastName !== originalItem.address.lastName || item.address.country !== originalItem.address.country || item.address.postalCode !== originalItem.address.postalCode || item.address.streetName !== originalItem.address.streetName || item.address.streetNumber !== originalItem.address.streetNumber || item.address.city !== originalItem.address.city || item.address.company !== originalItem.address.company || item.address.email !== originalItem.address.email || item.address.phone !== originalItem.address.phone || item.address.additionalStreetInfo !== originalItem.address.additionalStreetInfo;
      });
      if (hasUpdatedAddress) {
        setIsAlertModalOpen(true);
      } else {
        closeModal();
      }
    },
    size: "lg",
    dismissLabel: intl.formatMessage({
      id: "general.modal.close",
      defaultMessage: "Close"
    }),
    title: shippingAddresses && shippingAddresses.length > 1 ? /* @__PURE__ */React76.createElement(FormattedMessage50, {
      id: "checkout.splitShipment.changeExtraShippingAddresses",
      defaultMessage: "Change extra shipping addresses"
    }) : /* @__PURE__ */React76.createElement(FormattedMessage50, {
      id: "checkout.splitShipment.addExtraShippingAddresses",
      defaultMessage: "Add extra shipping addresses"
    })
  }, /* @__PURE__ */React76.createElement(Modal6.Content, {
    className: clsx6("pd-h-[90vh]", {
      "pd-p-0": view === "list"
    })
  }, view === "list" && /* @__PURE__ */React76.createElement(AddressListView2, {
    className: "pd-p-4",
    showSuccessAlertForCreatedAddressId,
    showSuccessAlertForUpdatedAddressId,
    renderAddressPanel: (_a, focusedAddressId) => {
      var _b = _a,
        {
          address
        } = _b,
        data = __objRest(_b, ["address"]);
      const disabled = defaultShippingAddress && address.id === defaultShippingAddress.id;
      const currentSelectedItem = selectedItems.find(item => item.address.id === address.id);
      const checked = currentSelectedItem !== void 0;
      const minQuantityPerField = 1;
      const maxQuantityPerField = lineItem.quantity - (selectedItems.length - 1);
      const dropdownItems = [{
        title: intl.formatMessage({
          id: "checkout.editAddress",
          defaultMessage: "Edit address"
        }),
        iconBefore: "edit",
        onClick: () => {
          setMutatingAddressId(address.id);
          setShowSuccessAlertForCreatedAddressId(void 0);
          setShowSuccessAlertForUpdatedAddressId(void 0);
          setView("edit");
        }
      }];
      if (!data.isDefaultBillingAddress && !data.isDefaultShippingAddress) {
        dropdownItems.push({
          title: intl.formatMessage({
            id: "checkout.deleteAddress",
            defaultMessage: "Delete address"
          }),
          iconBefore: "trashcan",
          onClick: () => {
            setDeleteAddressModalIsOpen(address.id);
          }
        });
      }
      return /* @__PURE__ */React76.createElement(React76.Fragment, null, /* @__PURE__ */React76.createElement(AddressPanel2, {
        key: address.id,
        address,
        isDefaultBillingAddress: data.isDefaultBillingAddress,
        isDefaultShippingAddress: data.isDefaultShippingAddress,
        className: focusedAddressId === address.id ? "pd-border-info-500" : void 0,
        dropdownItems,
        footer: /* @__PURE__ */React76.createElement("div", {
          className: "pd-flex pd-w-full pd-flex-col pd-gap-4 pd-py-2"
        }, /* @__PURE__ */React76.createElement(Label, {
          className: "pd-flex pd-items-center pd-gap-2 pd-self-start"
        }, /* @__PURE__ */React76.createElement(Checkbox, {
          disabled,
          checked: selectedItems.find(item => item.address.id === address.id) !== void 0,
          onChange: () => {
            if (selectedItems.find(item => item.address.id === address.id) !== void 0) {
              deleteSelectedItem(address.id);
            } else {
              const newSelectedItems = [...selectedItems, {
                address,
                quantity: minQuantityPerField
              }];
              const updatedSelectedItems = newSelectedItems.map(item => {
                if (defaultShippingAddress && item.address.id === defaultShippingAddress.id) {
                  return __spreadProps(__spreadValues({}, item), {
                    quantity: lineItem.quantity - calculateTotalQuantityForOthers(newSelectedItems)
                  });
                }
                return item;
              });
              setSelectedItems(updatedSelectedItems);
            }
          }
        }), /* @__PURE__ */React76.createElement(FormattedMessage50, {
          id: "checkout.button.selectAddress",
          defaultMessage: "Select address"
        })), /* @__PURE__ */React76.createElement(Transition, {
          show: checked,
          variant: "appear"
        }, /* @__PURE__ */React76.createElement(FormattedMessage50, {
          id: "checkout.splitShipment.quantityPerShippingAddress",
          defaultMessage: "Ship {quantityField} {quantity, plural, one {piece} other {pieces}} to this address (of {total} total)",
          values: {
            total: lineItem.quantity,
            quantity: (currentSelectedItem == null ? void 0 : currentSelectedItem.quantity) || 0,
            quantityField: /* @__PURE__ */React76.createElement(TextInput2, {
              type: "number",
              disabled,
              value: currentSelectedItem && currentSelectedItem.quantity && (currentSelectedItem.quantity < minQuantityPerField ? minQuantityPerField : currentSelectedItem.quantity),
              onChange: event => {
                const trimmedValue = event.target.value.trim();
                const parsedValue = trimmedValue === "" ? void 0 : parseInt(trimmedValue, 10);
                const updatedItems = selectedItems.map(item => {
                  if (defaultShippingAddress && item.address.id === defaultShippingAddress.id) {
                    const totalQuantityForOthers = calculateTotalQuantityForOthers(selectedItems, address.id);
                    const remainingQuantity = lineItem.quantity - totalQuantityForOthers - (parsedValue || 0);
                    return __spreadProps(__spreadValues({}, item), {
                      quantity: remainingQuantity < 1 ? 1 : remainingQuantity
                    });
                  }
                  if (item.address.id === address.id) {
                    return __spreadProps(__spreadValues({}, item), {
                      quantity: parsedValue
                    });
                  }
                  return item;
                });
                setSelectedItems(updatedItems);
              },
              min: minQuantityPerField,
              max: maxQuantityPerField,
              step: 1,
              className: "pd-inline-flex pd-w-40",
              validation: currentSelectedItem && (invalidQuantityFields.includes(currentSelectedItem) || submitCount > 0 && itemsWithoutQuantity.includes(currentSelectedItem)) ? "error" : void 0
            })
          }
        })), currentSelectedItem && invalidQuantityFields.includes(currentSelectedItem) && /* @__PURE__ */React76.createElement(Alert12, {
          variant: "error",
          key: "invalidQuantityFields"
        }, /* @__PURE__ */React76.createElement(FormattedMessage50, {
          id: "checkout.splitShipment.invalidQuantity",
          defaultMessage: "The quantity entered is {quantityTooHigh} {quantityTooHigh, plural, one {piece} other {pieces}} too high.{br} Reduce the quantity to stay within the total ({total} {total, plural, one {piece} other {pieces}})",
          values: {
            total: lineItem.quantity,
            quantityTooHigh: Math.max(selectedItems.reduce((total, selectedItem) => total + (selectedItem.quantity || 0), 0) - lineItem.quantity, 0),
            br: /* @__PURE__ */React76.createElement("br", null)
          }
        })))
      }), /* @__PURE__ */React76.createElement(AddressDeleteModal2, {
        addressId: address.id,
        isModalOpen: deleteAddressModalIsOpen === address.id,
        setIsModalOpen: setDeleteAddressModalIsOpen,
        onSuccess: () => {
          deleteSelectedItem(address.id);
          setShowSuccessAlertForCreatedAddressId(void 0);
          setShowSuccessAlertForUpdatedAddressId(void 0);
          setMutatingAddressId(void 0);
        }
      }));
    },
    filterByCountry: defaultShippingAddress == null ? void 0 : defaultShippingAddress.country,
    alert: /* @__PURE__ */React76.createElement("div", {
      className: "pd-flex pd-flex-col pd-gap-4"
    }, /* @__PURE__ */React76.createElement("div", {
      className: "pd-self-end"
    }, /* @__PURE__ */React76.createElement(Button14, {
      variant: "secondary",
      iconBefore: "plus",
      onClick: () => setView("create")
    }, /* @__PURE__ */React76.createElement(FormattedMessage50, {
      id: "checkout.addAddress",
      defaultMessage: "Add address"
    }))), defaultShippingAddress && /* @__PURE__ */React76.createElement(Alert12, {
      variant: "info"
    }, defaultShippingAddress.country in countries ? /* @__PURE__ */React76.createElement(FormattedMessage50, {
      id: "checkout.splitShipment.filteredByCountryExplanation",
      defaultMessage: "Note: at this moment you can only select addresses within the following country: {country}.",
      values: {
        country: intl.formatMessage(countries[defaultShippingAddress.country])
      }
    }) : /* @__PURE__ */React76.createElement(FormattedMessage50, {
      id: "checkout.splitShipment.filteredByCountryExplanation",
      defaultMessage: "Note: at this moment you can only select addresses within the following country: {country}.",
      values: {
        country: defaultShippingAddress.country
      }
    })), (updateLineItemMutation.isError || removeSplitShipmentMutation.isError) && /* @__PURE__ */React76.createElement(ErrorAlert_default, {
      className: "pd-m-0",
      scrollIntoView: true,
      sentryException: {
        e: updateLineItemMutation.error || removeSplitShipmentMutation.error,
        tags: {
          fileLocation: "SplitShipmentModal.tsx",
          featureFunction: "SplitShipmentModal"
        },
        fingerPrint: ["checkout", "splitShipment"]
      }
    }, /* @__PURE__ */React76.createElement(FormattedMessage50, {
      id: "checkout.splitShipment.error",
      defaultMessage: "An error occurred while updating the shipping addresses. Please try again."
    })), itemsWithoutQuantity.length > 0 && submitCount > 0 && /* @__PURE__ */React76.createElement(ErrorAlert_default, {
      className: "pd-m-0",
      scrollIntoView: true
    }, /* @__PURE__ */React76.createElement(FormattedMessage50, {
      id: "checkout.splitShipment.quantityRequired",
      defaultMessage: "You have not yet entered a quantity for all your selected addresses. Make sure all addresses have a quantity entered."
    })))
  }), view === "create" && /* @__PURE__ */React76.createElement(CreateAddressView2, {
    onSubmitSuccess: address => {
      setShowSuccessAlertForCreatedAddressId(address.id);
      setView("list");
    }
  }), view === "edit" && /* @__PURE__ */React76.createElement(UpdateAddressView2, {
    mutatingAddressId,
    onSubmitSuccess: address => {
      const items = selectedItems.map(item => {
        if (item.address.id === mutatingAddressId) {
          return {
            address,
            quantity: item.quantity
          };
        }
        return item;
      });
      setSelectedItems(items);
      setShowSuccessAlertForUpdatedAddressId(mutatingAddressId);
      setView("list");
    }
  }), /* @__PURE__ */React76.createElement(SplitShipmentAlertModal_default, {
    isModalOpen: isAlertModalOpen,
    setIsModalOpen: setIsAlertModalOpen,
    submitButton: /* @__PURE__ */React76.createElement(Button14, {
      className: "pd-w-full",
      isLoading: updateLineItemMutation.isPending,
      disabled: invalidQuantityFields.length > 0,
      onClick: () => {
        setSubmitCount(submitCount + 1);
        if (itemsWithoutQuantity.length === 0) {
          handleSetSplitShipmentAddresses();
        } else {
          setIsAlertModalOpen(false);
        }
      }
    }, /* @__PURE__ */React76.createElement(FormattedMessage50, {
      id: "checkout.splitShipment.confirmSelectedAddresses",
      defaultMessage: "Confirm selected addresses ({count})",
      values: {
        count: selectedItems.length
      }
    }))
  })), /* @__PURE__ */React76.createElement(Modal6.Footer, null, view === "list" && /* @__PURE__ */React76.createElement("div", {
    className: "pd-flex pd-justify-end pd-gap-2"
  }, shippingAddresses && shippingAddresses.length > 1 && defaultShippingAddress && /* @__PURE__ */React76.createElement(Button14, {
    variant: "secondary",
    isLoading: removeSplitShipmentMutation.isPending,
    onClick: () => {
      const items = [{
        address: (_a => {
          var _b = _a,
            {
              quantity
            } = _b,
            rest = __objRest(_b, ["quantity"]);
          return rest;
        })(defaultShippingAddress),
        quantity: lineItem.quantity
      }];
      removeSplitShipmentMutation.mutateAsync({
        lineItemId: lineItem.id,
        payload: {
          shippingAddresses: items
        }
      }).then(() => {
        onClose();
        setMutatingAddressId(void 0);
        setShowSuccessAlertForCreatedAddressId(void 0);
        setShowSuccessAlertForUpdatedAddressId(void 0);
        setSelectedItems(items);
        removeSplitShipmentMutation.reset();
      });
    }
  }, /* @__PURE__ */React76.createElement(FormattedMessage50, {
    id: "checkout.splitShipment.deleteExtraShippingAddresses",
    defaultMessage: "Delete extra shipping addresses"
  })), /* @__PURE__ */React76.createElement(Button14, {
    isLoading: updateLineItemMutation.isPending,
    disabled: invalidQuantityFields.length > 0,
    onClick: () => {
      setSubmitCount(submitCount + 1);
      if (itemsWithoutQuantity.length === 0) {
        handleSetSplitShipmentAddresses();
      }
    }
  }, /* @__PURE__ */React76.createElement(FormattedMessage50, {
    id: "checkout.splitShipment.confirmSelectedAddresses",
    defaultMessage: "Confirm selected addresses ({count})",
    values: {
      count: selectedItems.length
    }
  }))), (view === "create" || view === "edit") && /* @__PURE__ */React76.createElement("div", {
    className: "pd-flex pd-items-center pd-justify-between"
  }, /* @__PURE__ */React76.createElement(LinkAsButton13, {
    className: "pd-text-sm",
    iconBefore: "chevron-left",
    variant: "secondary",
    onClick: () => {
      setShowSuccessAlertForCreatedAddressId(void 0);
      setShowSuccessAlertForUpdatedAddressId(void 0);
      setView("list");
    }
  }, /* @__PURE__ */React76.createElement(FormattedMessage50, {
    id: "checkout.backToAddressList",
    defaultMessage: "Back to address list"
  })), /* @__PURE__ */React76.createElement(AddressFormSubmitButton2, null))));
};
var SplitShipmentModal_default = SplitShipmentModal;

// src/library/components/line-item/split-shipment/SplitShipmentSelector.tsx
var SplitShipmentSelector = _ref97 => {
  let {
    lineItem
  } = _ref97;
  const intl = useIntl31();
  const shippingOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  const shippingAddresses = getShippingAddressesFromLineItem(lineItem);
  const [defaultShippingAddress, ...extraShippingAddresses] = shippingAddresses || [];
  const [unavailableReason, setUnavailableReason] = useState24();
  const [isModalOpen, setIsModalOpen] = useState24(false);
  useEffect30(() => {
    if (shippingOptionsQuery.data) {
      if (shippingOptionsQuery.data.splitShipment.isAllowed === false) {
        setUnavailableReason(1 /* NotPossibleForProduct */);
      } else if (shippingAddresses && shippingAddresses.length && !configurationProvider10.getValueAsArray("SPLIT_SHIPPING_COUNTRIES").includes(defaultShippingAddress.country)) {
        setUnavailableReason(0 /* NotPossibleForCountry */);
      } else if (hasTimedDeliveryOnLineItem(lineItem)) {
        setUnavailableReason(2 /* HasDeliveryOptionsOnLineItem */);
      } else if (hasPickupPoint4(lineItem)) {
        setUnavailableReason(3 /* HasPickupPointOnLineItem */);
      } else if (shippingAddresses && !shippingAddresses.length) {
        setUnavailableReason(4 /* HasNoDefaultAddressOnLineItem */);
      } else {
        setUnavailableReason(void 0);
      }
    }
    if (shippingOptionsQuery.error) {
      setUnavailableReason(5 /* CouldNotFetchSplitShipmentOptions */);
    }
  }, [defaultShippingAddress, lineItem, shippingAddresses, shippingOptionsQuery.data, shippingOptionsQuery.error]);
  const getTooltipText = reason => {
    switch (reason) {
      case 0 /* NotPossibleForCountry */:
        if (defaultShippingAddress.country in countries2) {
          return intl.formatMessage({
            id: "splitShipment.notPossibleForCountry",
            defaultMessage: "Extra addresses are currently not possible for this country: {country}"
          }, {
            country: intl.formatMessage(countries2[defaultShippingAddress.country])
          });
        }
        return intl.formatMessage({
          id: "splitShipment.notPossibleForCountry",
          defaultMessage: "Extra addresses are currently not possible for this country: {country}"
        }, {
          country: defaultShippingAddress.country
        });
      case 1 /* NotPossibleForProduct */:
        return intl.formatMessage({
          id: "splitShipment.notPossibleWithProduct",
          defaultMessage: "Extra addresses are currently not possible for this product"
        });
      case 2 /* HasDeliveryOptionsOnLineItem */:
        return intl.formatMessage({
          id: "splitShipment.cannotBeCombinedWithDeliveryOptions",
          defaultMessage: "Extra addresses cannot be combined with a delivery options"
        });
      case 3 /* HasPickupPointOnLineItem */:
        return intl.formatMessage({
          id: "splitShipment.cannotBeCombinedWithPickupPoint",
          defaultMessage: "Extra addresses cannot be combined with a pickup point"
        });
      case 4 /* HasNoDefaultAddressOnLineItem */:
        return intl.formatMessage({
          id: "splitShipment.hasNoDefaultAddressOnLineItem",
          defaultMessage: "Set a default shipping address first"
        });
      case 5 /* CouldNotFetchSplitShipmentOptions */:
      default:
        return intl.formatMessage({
          id: "splitShipment.couldNotFetchSplitShipmentOptions",
          defaultMessage: "Could not fetch split shipment options"
        });
    }
  };
  return /* @__PURE__ */React77.createElement("div", {
    className: "pd-flex pd-flex-col pd-gap-2"
  }, /* @__PURE__ */React77.createElement(Heading12, {
    as: "h4",
    className: "pd-mb-2"
  }, /* @__PURE__ */React77.createElement(FormattedMessage51, {
    id: "checkout.extraDeliveryAddresses",
    defaultMessage: "Extra delivery addresses"
  })), extraShippingAddresses.map((shippingAddress, index) => /* @__PURE__ */React77.createElement("div", {
    key: shippingAddress.id
  }, /* @__PURE__ */React77.createElement("span", {
    className: "pd-font-bold"
  }, /* @__PURE__ */React77.createElement(FormattedMessage51, {
    id: "checkout.extraDeliveryAddress",
    defaultMessage: "Address {number}",
    values: {
      number: index + 2
    }
  }), ":"), /* @__PURE__ */React77.createElement(AddressContent2, {
    address: shippingAddress,
    showFirstAndLastName: true
  }), /* @__PURE__ */React77.createElement("div", {
    className: "pd-text-sm pd-text-dim-600"
  }, "(", /* @__PURE__ */React77.createElement(FormattedMessage51, {
    id: "checkout.lineItem.quantityCount",
    defaultMessage: "{quantity} {quantity, plural, one {piece} other {pieces}}",
    values: {
      quantity: shippingAddress.quantity
    }
  }), ")"))), unavailableReason === void 0 ? /* @__PURE__ */React77.createElement(SplitShipmentButton_default, {
    lineItem,
    unavailableReason,
    className: "pd-self-start pd-text-sm",
    onClick: () => setIsModalOpen(true)
  }) : /* @__PURE__ */React77.createElement(Tooltip5, {
    placement: "top",
    trigger: /* @__PURE__ */React77.createElement(Tooltip5.Trigger, {
      as: SplitShipmentButton_default,
      lineItem,
      unavailableReason,
      className: "pd-self-start pd-text-sm",
      onClick: () => setIsModalOpen(true)
    })
  }, getTooltipText(unavailableReason)), /* @__PURE__ */React77.createElement(SplitShipmentModal_default, {
    lineItem,
    isOpen: isModalOpen,
    onClose: () => setIsModalOpen(false)
  }));
};
var SplitShipmentSelector_default = SplitShipmentSelector;

// src/library/components/design-system/checkout/delivery-page/DeliveryLineItem.tsx
var DeliveryLineItem = _ref98 => {
  let {
    lineItem
  } = _ref98;
  usePrefetchAddresses2();
  const {
    featureToggle: {
      isEnabled: isSplitshipmentEnabled
    }
  } = useFeatureToggle("checkout_split_shipment_toggle");
  const {
    featureToggle: {
      isEnabled: isPickuppointEnabled
    }
  } = useFeatureToggle("checkout_pickuppoint_toggle");
  const [isProductDetailsOpen, setIsProductDetailsOpen] = useState25(false);
  return /* @__PURE__ */React78.createElement(LineItemPanel_default, {
    key: lineItem.id,
    lineItem,
    showLineItemActions: false
  }, /* @__PURE__ */React78.createElement("div", {
    className: "pd-mb-3 pd-flex pd-justify-between pd-gap-4"
  }, /* @__PURE__ */React78.createElement(LineItemTitle_default, {
    lineItem
  }), /* @__PURE__ */React78.createElement(Transition2, {
    show: isProductDetailsOpen,
    variant: "appear"
  }, /* @__PURE__ */React78.createElement(LineItemPrice_default, {
    lineItem
  }))), /* @__PURE__ */React78.createElement(Transition2, {
    show: isProductDetailsOpen,
    variant: "appear"
  }, /* @__PURE__ */React78.createElement("div", {
    className: "pd-mb-2 pd-flex pd-justify-between pd-gap-4"
  }, /* @__PURE__ */React78.createElement("div", null, /* @__PURE__ */React78.createElement(LineItemDescription_default, {
    lineItem
  })), /* @__PURE__ */React78.createElement(LineItemArtwork_default, {
    lineItem
  }))), /* @__PURE__ */React78.createElement(LinkAsButton14, {
    variant: "secondary",
    onClick: () => {
      setIsProductDetailsOpen(!isProductDetailsOpen);
      addDataLayerEntry17("show_product_details");
    },
    iconAfter: isProductDetailsOpen ? "double-chevron-up" : "double-chevron-down",
    className: "pd-text-xs"
  }, isProductDetailsOpen ? /* @__PURE__ */React78.createElement(FormattedMessage52, {
    id: "checkout.hideProductDetails",
    defaultMessage: "Hide product details"
  }) : /* @__PURE__ */React78.createElement(FormattedMessage52, {
    id: "checkout.showProductDetails",
    defaultMessage: "Show product details"
  })), isProductDetailsOpen && /* @__PURE__ */React78.createElement("hr", {
    className: "pd-mt-4"
  }), /* @__PURE__ */React78.createElement("div", {
    className: "pd-mt-4 pd-grid pd-grid-cols-2 pd-gap-4"
  }, /* @__PURE__ */React78.createElement("div", {
    className: "pd-col-span-2 md:pd-col-span-1"
  }, /* @__PURE__ */React78.createElement(LineItemShippingAddress_default, {
    lineItem
  }), /* @__PURE__ */React78.createElement("hr", {
    className: "pd-my-5 sm:pd-hidden"
  })), /* @__PURE__ */React78.createElement("div", {
    className: "pd-col-span-2 md:pd-col-span-1"
  }, configurationProvider11.getValueAsBoolean("DELIVERY_OPTIONS_ENABLED") && /* @__PURE__ */React78.createElement(React78.Fragment, null, /* @__PURE__ */React78.createElement(DeliveryOptionSelector_default, {
    lineItem
  }), (isSplitshipmentEnabled || isPickuppointEnabled) && /* @__PURE__ */React78.createElement("hr", {
    className: "pd-my-5"
  })), configurationProvider11.getValueAsBoolean("SPLIT_SHIPPING_ENABLED") && /* @__PURE__ */React78.createElement(React78.Fragment, null, /* @__PURE__ */React78.createElement(SplitShipmentSelector_default, {
    lineItem
  }), isPickuppointEnabled && /* @__PURE__ */React78.createElement("hr", {
    className: "pd-my-5"
  })), configurationProvider11.getValueAsBoolean("PICKUP_POINTS_ENABLED") && /* @__PURE__ */React78.createElement(PickupPointSelector_default, {
    lineItem
  }))));
};
var DeliveryLineItem_default = DeliveryLineItem;

// src/library/components/cart/billing-address/BillingAddressSelector.tsx
import React83, { useState as useState27 } from "react";

// src/library/components/cart/billing-address/BillingAddressButton.tsx
import { Button as Button15 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage53 } from "react-intl";
import React79 from "react";
var BillingAddressButton = _ref99 => {
  let {
    onClick
  } = _ref99;
  return /* @__PURE__ */React79.createElement(Button15, {
    className: "pd-self-start",
    variant: "secondary",
    iconBefore: "edit",
    onClick
  }, /* @__PURE__ */React79.createElement(FormattedMessage53, {
    id: "checkout.changeBillingAddress",
    defaultMessage: "Change billing address"
  }));
};
var BillingAddressButton_default = BillingAddressButton;

// src/library/components/cart/billing-address/BillingAddressModal.tsx
import { Button as Button17, LinkAsButton as LinkAsButton15, Modal as Modal7 } from "@printdeal/ui-library";
import React82, { useState as useState26 } from "react";
import clsx8 from "clsx";
import { AddressFormSubmitButton as AddressFormSubmitButton3, AddressListView as AddressListView3, CreateAddressView as CreateAddressView3, UpdateAddressView as UpdateAddressView3 } from "@printdeal/address-frontend";
import { FormattedMessage as FormattedMessage55, useIntl as useIntl33 } from "react-intl";

// src/library/components/cart/billing-address/BillingAddressPanel.tsx
import { useIntl as useIntl32 } from "react-intl";
import React80 from "react";
import { AddressDeleteModal as AddressDeleteModal3, AddressPanel as AddressPanel3 } from "@printdeal/address-frontend";
import clsx7 from "clsx";
var BillingAddressPanel = _ref100 => {
  let {
    address,
    isDefaultBillingAddress,
    isDefaultShippingAddress,
    focusedAddressId,
    setView,
    setMutatingAddressId,
    setShowSuccessAlertForCreatedAddressId,
    setShowSuccessAlertForUpdatedAddressId,
    deleteAddressModalIsOpen,
    setDeleteAddressModalIsOpen,
    footer
  } = _ref100;
  const intl = useIntl32();
  const validationErrors = useValidateAddress({
    address,
    requireEmail: true
  });
  return /* @__PURE__ */React80.createElement(React80.Fragment, null, /* @__PURE__ */React80.createElement(AddressPanel3, {
    key: address.id,
    address,
    isDefaultBillingAddress,
    isDefaultShippingAddress,
    className: clsx7({
      "pd-border-info-500": focusedAddressId === address.id,
      "pd-border-error-500": validationErrors.length > 0
    }),
    dropdownItems: [{
      title: intl.formatMessage({
        id: "checkout.editAddress",
        defaultMessage: "Edit address"
      }),
      iconBefore: "edit",
      onClick: () => {
        setMutatingAddressId(address.id);
        setShowSuccessAlertForCreatedAddressId(void 0);
        setShowSuccessAlertForUpdatedAddressId(void 0);
        setView("edit");
      }
    }, ...(!isDefaultBillingAddress && !isDefaultShippingAddress ? [{
      title: intl.formatMessage({
        id: "checkout.deleteAddress",
        defaultMessage: "Delete address"
      }),
      iconBefore: "trashcan",
      onClick: () => {
        setDeleteAddressModalIsOpen(address.id);
      }
    }] : [])],
    footer
  }), /* @__PURE__ */React80.createElement(AddressDeleteModal3, {
    addressId: address.id,
    isModalOpen: deleteAddressModalIsOpen === address.id,
    setIsModalOpen: setDeleteAddressModalIsOpen,
    onSuccess: () => {
      setShowSuccessAlertForCreatedAddressId(void 0);
      setShowSuccessAlertForUpdatedAddressId(void 0);
      setMutatingAddressId(void 0);
    }
  }));
};
var BillingAddressPanel_default = BillingAddressPanel;

// src/library/components/cart/billing-address/BillingAddressPanelFooter.tsx
import React81 from "react";
import { Button as Button16, Alert as Alert13 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage54 } from "react-intl";
var BillingAddressPanelFooter = _ref101 => {
  let {
    address,
    patchCartMutation,
    mutatingAddressId,
    setView,
    setMutatingAddressId,
    setDeleteAddressModalIsOpen,
    onSuccess
  } = _ref101;
  const validationErrors = useValidateAddress({
    address,
    requireEmail: true
  });
  return validationErrors.length === 0 ? /* @__PURE__ */React81.createElement(Button16, {
    className: "pd-w-full md:pd-w-auto",
    isLoading: patchCartMutation.isPending && mutatingAddressId === address.id,
    onClick: () => {
      setMutatingAddressId(address.id);
      patchCartMutation.mutateAsync({
        action: {
          name: "setBillingAddress",
          value: __spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
            id: address.id.trim(),
            firstName: address.firstName.trim(),
            lastName: address.lastName.trim()
          }, address.email && {
            email: address.email.trim()
          }), address.phone && {
            phone: address.phone.trim()
          }), address.company && {
            company: address.company.trim()
          }), {
            country: address.country.trim(),
            postalCode: address.postalCode.trim(),
            streetNumber: address.streetNumber.trim(),
            streetName: address.streetName.trim(),
            city: address.city.trim()
          }), address.additionalStreetInfo && {
            additionalStreetInfo: address.additionalStreetInfo.trim()
          }), address.vatId && {
            vatId: address.vatId.trim()
          })
        }
      }).then(() => {
        patchCartMutation.reset();
        onSuccess();
      });
    }
  }, /* @__PURE__ */React81.createElement(FormattedMessage54, {
    id: "checkout.button.selectAddress",
    defaultMessage: "Select address"
  })) : /* @__PURE__ */React81.createElement(Alert13, {
    variant: "error"
  }, /* @__PURE__ */React81.createElement("div", {
    className: "pd-flex pd-flex-col pd-gap-2"
  }, /* @__PURE__ */React81.createElement(FormattedMessage54, {
    id: "checkout.invalidAddress",
    defaultMessage: "This address can currently not be selected, because it is missing certain data or contains invalid data. To make the address usable again, you can edit the address and fix the validation errors. Alternatively, if you no longer need this address, you can delete it."
  }), /* @__PURE__ */React81.createElement("ul", null, validationErrors.map(error => /* @__PURE__ */React81.createElement("li", {
    key: error.path
  }, /* @__PURE__ */React81.createElement(AddressError_default, {
    error
  })))), /* @__PURE__ */React81.createElement("div", {
    className: "pd-flex pd-gap-2"
  }, /* @__PURE__ */React81.createElement(Button16, {
    variant: "secondary",
    iconBefore: "edit",
    onClick: () => {
      setMutatingAddressId(address.id);
      setView("edit");
    }
  }, /* @__PURE__ */React81.createElement(FormattedMessage54, {
    id: "checkout.editAddress",
    defaultMessage: "Edit address"
  })), /* @__PURE__ */React81.createElement(Button16, {
    variant: "secondary",
    iconBefore: "trashcan",
    onClick: () => setDeleteAddressModalIsOpen(address.id)
  }, /* @__PURE__ */React81.createElement(FormattedMessage54, {
    id: "checkout.deleteAddress",
    defaultMessage: "Delete address"
  })))));
};
var BillingAddressPanelFooter_default = BillingAddressPanelFooter;

// src/library/components/cart/billing-address/BillingAddressModal.tsx
var BillingAddressModal = _ref102 => {
  let {
    isOpen,
    onClose
  } = _ref102;
  const intl = useIntl33();
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "setBillingAddress" /* setBillingAddress */
    }
  });
  const [view, setView] = useState26("list");
  const [mutatingAddressId, setMutatingAddressId] = useState26();
  const [showSuccessAlertForCreatedAddressId, setShowSuccessAlertForCreatedAddressId] = useState26();
  const [showSuccessAlertForUpdatedAddressId, setShowSuccessAlertForUpdatedAddressId] = useState26();
  const [deleteAddressModalIsOpen, setDeleteAddressModalIsOpen] = useState26();
  return /* @__PURE__ */React82.createElement(Modal7, {
    isOpen,
    onClose: () => {
      patchCartMutation.reset();
      setView("list");
      setMutatingAddressId(void 0);
      setShowSuccessAlertForCreatedAddressId(void 0);
      setShowSuccessAlertForUpdatedAddressId(void 0);
      onClose();
    },
    size: "lg",
    dismissLabel: intl.formatMessage({
      id: "general.modal.close",
      defaultMessage: "Close"
    }),
    title: intl.formatMessage({
      id: "checkout.selectBillingAddress",
      defaultMessage: "Select billing address"
    })
  }, /* @__PURE__ */React82.createElement(Modal7.Content, {
    className: clsx8("pd-h-[90vh]", {
      "pd-p-0": view === "list"
    })
  }, view === "list" && /* @__PURE__ */React82.createElement(AddressListView3, {
    className: "pd-p-4",
    showSuccessAlertForCreatedAddressId,
    showSuccessAlertForUpdatedAddressId,
    renderAddressPanel: (_a, focusedAddressId) => {
      var _b = _a,
        {
          address
        } = _b,
        data = __objRest(_b, ["address"]);
      return /* @__PURE__ */React82.createElement(BillingAddressPanel_default, {
        address,
        isDefaultBillingAddress: data.isDefaultBillingAddress,
        isDefaultShippingAddress: data.isDefaultShippingAddress,
        focusedAddressId,
        setView,
        setMutatingAddressId,
        setShowSuccessAlertForCreatedAddressId,
        setShowSuccessAlertForUpdatedAddressId,
        deleteAddressModalIsOpen,
        setDeleteAddressModalIsOpen,
        footer: /* @__PURE__ */React82.createElement(BillingAddressPanelFooter_default, {
          address,
          patchCartMutation,
          mutatingAddressId,
          setView,
          setMutatingAddressId,
          setDeleteAddressModalIsOpen,
          onSuccess: () => onClose()
        })
      });
    },
    alert: patchCartMutation.isError && /* @__PURE__ */React82.createElement(ErrorAlert_default, {
      className: "pd-m-0",
      scrollIntoView: true,
      sentryException: {
        e: patchCartMutation.error,
        tags: {
          fileLocation: "BillingAddressModal.tsx",
          featureFunction: "BillingAddressModal"
        },
        fingerPrint: ["checkout", "update-billing-address"]
      }
    }, /* @__PURE__ */React82.createElement(FormattedMessage55, {
      id: "checkout.billingAddress.error",
      defaultMessage: "An error occurred while updating the billing address. Please try again."
    }))
  }), view === "create" && /* @__PURE__ */React82.createElement(CreateAddressView3, {
    onSubmitSuccess: address => {
      setShowSuccessAlertForCreatedAddressId(address.id);
      setView("list");
    }
  }), view === "edit" && /* @__PURE__ */React82.createElement(UpdateAddressView3, {
    mutatingAddressId,
    onSubmitSuccess: () => {
      setShowSuccessAlertForUpdatedAddressId(mutatingAddressId);
      setView("list");
    }
  })), /* @__PURE__ */React82.createElement(Modal7.Footer, null, view === "list" && /* @__PURE__ */React82.createElement("div", {
    className: "pd-flex pd-justify-end"
  }, /* @__PURE__ */React82.createElement(Button17, {
    variant: "secondary",
    iconBefore: "plus",
    onClick: () => setView("create")
  }, /* @__PURE__ */React82.createElement(FormattedMessage55, {
    id: "checkout.addAddress",
    defaultMessage: "Add address"
  }))), (view === "create" || view === "edit") && /* @__PURE__ */React82.createElement("div", {
    className: "pd-flex pd-items-center pd-justify-between"
  }, /* @__PURE__ */React82.createElement(LinkAsButton15, {
    className: "pd-text-sm",
    iconBefore: "chevron-left",
    variant: "secondary",
    onClick: () => {
      setShowSuccessAlertForCreatedAddressId(void 0);
      setShowSuccessAlertForUpdatedAddressId(void 0);
      setView("list");
    }
  }, /* @__PURE__ */React82.createElement(FormattedMessage55, {
    id: "checkout.backToAddressList",
    defaultMessage: "Back to address list"
  })), /* @__PURE__ */React82.createElement(AddressFormSubmitButton3, null))));
};
var BillingAddressModal_default = BillingAddressModal;

// src/library/components/cart/billing-address/BillingAddressSelector.tsx
var BillingAddressSelector = () => {
  const [isModalOpen, setIsModalOpen] = useState27(false);
  return /* @__PURE__ */React83.createElement(React83.Fragment, null, /* @__PURE__ */React83.createElement(BillingAddressButton_default, {
    onClick: () => setIsModalOpen(true)
  }), /* @__PURE__ */React83.createElement(BillingAddressModal_default, {
    isOpen: isModalOpen,
    onClose: () => setIsModalOpen(false)
  }));
};
var BillingAddressSelector_default = BillingAddressSelector;

// src/library/views/DeliveryView.tsx
var DeliveryView = () => {
  const {
    cartId,
    cart: cartObject
  } = useCart();
  const {
    navigate,
    paths
  } = useContext15(CheckoutViewContext_default);
  usePrefetchedPaymentMethodsForCart();
  useValidateCartRedirectHook();
  usePrefetchAddresses3();
  useEffect31(() => {
    EcommerceObjectHelper.clearEcommerceObject();
    addDataLayerEntry18("begin_checkout", __spreadProps(__spreadValues({}, EcommerceObjectHelper.createEcommerceObject(cartObject)), {
      cartId,
      lineItemIds: cartObject == null ? void 0 : cartObject.lineItems.map(lineItem => lineItem.id)
    }));
    addDataLayerEntry18("view_delivery");
  }, [cartId, cartObject]);
  return /* @__PURE__ */React84.createElement(Container3, {
    className: "pd-py-6"
  }, /* @__PURE__ */React84.createElement(CheckoutStepper_default, null), /* @__PURE__ */React84.createElement(Heading13, {
    as: "h1",
    className: "pd-mb-5"
  }, /* @__PURE__ */React84.createElement(FormattedMessage56, {
    id: "checkout.deliveryView.title",
    defaultMessage: "Delivery"
  })), /* @__PURE__ */React84.createElement(CartQuery_default, null, cart => {
    const lineItems = getMainLineItems5(cart);
    return /* @__PURE__ */React84.createElement("div", {
      className: "pd-grid pd-grid-cols-3 pd-items-start pd-gap-4"
    }, /* @__PURE__ */React84.createElement("div", {
      className: "pd-col-span-3 md:pd-col-span-2"
    }, /* @__PURE__ */React84.createElement("div", {
      className: "pd-grid pd-gap-4"
    }, /* @__PURE__ */React84.createElement(CheckoutDevOnly_default, {
      jsonObject: {
        cartId: cart.id,
        cartVersion: cart.version
      }
    }), /* @__PURE__ */React84.createElement(DeliveryAlerts_default, null), lineItems.map(lineItem => /* @__PURE__ */React84.createElement(DeliveryLineItem_default, {
      key: lineItem.id,
      lineItem
    })))), /* @__PURE__ */React84.createElement("div", {
      className: "pd-sticky pd-top-3 pd-col-span-3 pd-flex pd-flex-col pd-gap-4 md:pd-col-span-1"
    }, /* @__PURE__ */React84.createElement("div", {
      className: "pd-order-1 md:pd-order-none"
    }, /* @__PURE__ */React84.createElement(CheckoutSummary_default, {
      nextStepButton: /* @__PURE__ */React84.createElement(Button18, {
        className: "pd-w-full",
        iconAfter: "chevron-right",
        onClick: () => {
          navigate(paths.paymentMethodPage.path).catch(() => {});
          addDataLayerEntry18("delivery_next");
        }
      }, /* @__PURE__ */React84.createElement(FormattedMessage56, {
        id: "checkout.nextStepToPaymentMethod",
        defaultMessage: "To payment method"
      }))
    })), /* @__PURE__ */React84.createElement("div", {
      className: "pd-order-none md:pd-order-1"
    }, /* @__PURE__ */React84.createElement(Panel11, {
      className: "pd-flex pd-flex-col pd-gap-3"
    }, /* @__PURE__ */React84.createElement(Heading13, {
      as: "h4"
    }, /* @__PURE__ */React84.createElement(FormattedMessage56, {
      id: "checkout.billingAddress",
      defaultMessage: "Billing address"
    })), cart.billingAddress && isAddressOnCartComplete(cart.billingAddress) ? /* @__PURE__ */React84.createElement(AddressContent3, {
      address: cart.billingAddress,
      showFirstAndLastName: true,
      showEmail: true
    }) : /* @__PURE__ */React84.createElement(Alert14, {
      variant: "error"
    }, /* @__PURE__ */React84.createElement(FormattedMessage56, {
      id: "checkout.billingAddressNotSet",
      defaultMessage: "Please select a billing address"
    })), /* @__PURE__ */React84.createElement(BillingAddressSelector_default, null)))));
  }));
};
var DeliveryView_default = DeliveryView;

// src/library/queries/order/usePatchOrderMutation.ts
import { useMutation as useMutation13, useQueryClient as useQueryClient5 } from "@tanstack/react-query";
import { addDataLayerEntry as addDataLayerEntry19 } from "@printdeal/data-layer-manager";

// src/library/http-clients/OrderHttpClient.ts
import axios7 from "axios";
import { configurationProvider as configurationProvider12 } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor as authenticateHttpRequestInterceptor5 } from "@printdeal/authentication";
import { getFeatureManagementUserId as getFeatureManagementUserId2 } from "@printdeal/feature-management/react";
var OrderHttpClient = class {
  get client() {
    var _a;
    if (!this.httpClient) {
      const baseURL = configurationProvider12.getValue("ECOMMERCE_ORDER_API_BASE_URL");
      this.httpClient = axios7.create({
        baseURL,
        headers: {
          "Feature-Management-User-Id": (_a = getFeatureManagementUserId2()) != null ? _a : ""
        }
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor5);
    }
    return this.httpClient;
  }
  patchLineItem(_0, _1) {
    return __async(this, arguments, function (orderId, _ref103) {
      var _this2 = this;
      let {
        payload,
        lineItemId
      } = _ref103;
      return function* () {
        return _this2.client.patch("order/".concat(orderId, "/lineitems/").concat(lineItemId), payload);
      }();
    });
  }
  getOrder(orderId) {
    return __async(this, null, function* () {
      return this.client.get("order/".concat(orderId));
    });
  }
  patchOrder(orderId, payload) {
    return __async(this, null, function* () {
      return this.client.patch("order/".concat(orderId), payload);
    });
  }
};
var orderHttpClient = new OrderHttpClient();
var OrderHttpClient_default = orderHttpClient;

// src/library/queries/order/usePatchOrderMutation.ts
function usePatchOrderMutation(_ref104) {
  let {
    context
  } = _ref104;
  const queryClient = useQueryClient5();
  return useMutation13({
    mutationKey: ["patchOrder" /* patchOrder */, context],
    mutationFn: requestData => __async(this, null, function* () {
      const _a = requestData,
        {
          orderId
        } = _a,
        payload = __objRest(_a, ["orderId"]);
      if (!orderId) {
        throw new Error("Cannot update an order without an order id");
      }
      switch (context) {
        case "orderSetPoNumber" /* orderSetPoNumber */:
          return OrderHttpClient_default.patchOrder(orderId, payload).then(_ref105 => {
            let {
              data
            } = _ref105;
            return {
              message: data
            };
          });
        case "orderSetReference" /* orderSetReference */:
          return OrderHttpClient_default.patchOrder(orderId, payload).then(_ref106 => {
            let {
              data
            } = _ref106;
            return {
              message: data
            };
          });
        default:
          throw new Error("Unsupported context");
      }
    }),
    onSuccess: order => {
      queryClient.setQueryData(["getOrder" /* getOrder */, order.message.id], order);
      switch (context) {
        case "orderSetPoNumber" /* orderSetPoNumber */:
          addDataLayerEntry19("order_detail_interaction", {
            action: "edit_po_number"
          });
          break;
        case "orderSetReference" /* orderSetReference */:
          addDataLayerEntry19("order_detail_interaction", {
            action: "edit_reference"
          });
          break;
        default:
          break;
      }
    },
    onError: () => {
      switch (context) {
        case "orderSetPoNumber" /* orderSetPoNumber */:
          addDataLayerEntry19("order_detail_api_failure", {
            action: "error_edit_po_number"
          });
          break;
        case "orderSetReference" /* orderSetReference */:
          addDataLayerEntry19("order_detail_api_failure", {
            action: "error_edit_reference"
          });
          break;
        default:
          break;
      }
    }
  });
}

// src/library/queries/order/usePatchOrderLineItemMutation.ts
import { useMutation as useMutation14, useQueryClient as useQueryClient6 } from "@tanstack/react-query";
import { useFeatureToggle as useFeatureToggle2 } from "@printdeal/feature-management/react";

// src/library/http-clients/LegacyOrderHttpClient.ts
import axios8 from "axios";
import { configurationProvider as configurationProvider13 } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor as authenticateHttpRequestInterceptor6 } from "@printdeal/authentication";
var LegacyOrderHttpClient = class {
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider13.getValue("ORDER_API_BASE_URL");
      this.httpClient = axios8.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor6);
    }
    return this.httpClient;
  }
  getOrder(orderId) {
    return __async(this, null, function* () {
      return this.client.get("/order/getMyOrder?id=".concat(orderId));
    });
  }
  getOrderByNumber(orderNumber) {
    return __async(this, null, function* () {
      return this.client.get("/order/getMyOrder?orderNumber=".concat(orderNumber));
    });
  }
  editOrder(_a) {
    return __async(this, null, function* () {
      var _b = _a,
        {
          orderId,
          lineItemId
        } = _b,
        payload = __objRest(_b, ["orderId", "lineItemId"]);
      return this.client.post("/order/edit/".concat(orderId, "/").concat(lineItemId), __spreadValues({}, payload));
    });
  }
  approveEdit(_0) {
    return __async(this, arguments, function (_ref107) {
      var _this3 = this;
      let {
        orderId,
        lineItemId,
        orderEditId,
        orderEditVersion
      } = _ref107;
      return function* () {
        return _this3.client.post("/order/edit/apply", {
          lineItemId,
          orderId,
          orderEditId,
          orderEditVersion
        });
      }();
    });
  }
};
var legacyOrderHttpClient = new LegacyOrderHttpClient();
var LegacyOrderHttpClient_default = legacyOrderHttpClient;

// src/library/queries/order/usePatchOrderLineItemMutation.ts
function usePatchOrderLineItemMutation(_ref108) {
  let {
    context,
    onSuccess,
    onError,
    replaceOrderOnSuccess = true
  } = _ref108;
  const queryClient = useQueryClient6();
  const {
    featureToggle: {
      isEnabled: useEcommerceApi
    }
  } = useFeatureToggle2("ecommerce_update_order_line_item_edit");
  return useMutation14({
    mutationKey: ["patchLineItem" /* patchLineItem */, context],
    mutationFn: _a => __async(this, null, function* () {
      var _b = _a,
        {
          orderId
        } = _b,
        requestData = __objRest(_b, ["orderId"]);
      if (!orderId) {
        throw new Error("Cannot update a line item without an order id");
      }
      if (!requestData.lineItemId) {
        throw new Error("Cannot update a line item without a line item id");
      }
      if (useEcommerceApi) {
        if (requestData.removeFile) {
          delete requestData.removeFile;
        }
        const {
          data: order
        } = yield OrderHttpClient_default.patchLineItem(orderId, requestData);
        return order;
      }
      if ("editLineItem" in requestData.payload) {
        const {
          data: {
            message: {
              orderEditId,
              version: orderEditVersion
            }
          }
        } = yield LegacyOrderHttpClient_default.editOrder({
          orderId,
          removeFile: requestData.removeFile,
          lineItemId: requestData.lineItemId,
          changedAttributes: requestData.payload.editLineItem[0].userSelection,
          quantity: requestData.payload.editLineItem[0].quantity
        });
        return LegacyOrderHttpClient_default.approveEdit({
          lineItemId: requestData.lineItemId,
          orderId,
          orderEditId,
          orderEditVersion
        }).then(() => void 0);
      }
      throw new Error("Legacy order API only supports editLineItem ATM");
    }),
    onSuccess: order => {
      if (order && replaceOrderOnSuccess) {
        queryClient.setQueryData(["getOrder" /* getOrder */, order.id], order);
      }
      if (typeof onSuccess === "function") {
        onSuccess(order);
      }
    },
    onError: error => {
      if (typeof onError === "function") {
        onError(error);
      }
    }
  });
}

// src/library/queries/order/useGetOrderQuery.ts
import { useQuery as useQuery9 } from "@tanstack/react-query";
import { useFeatureToggle as useFeatureToggle3 } from "@printdeal/feature-management/react";
function useGetOrderQuery(_ref109) {
  let {
    orderId,
    orderNumber
  } = _ref109;
  const {
    featureToggle: {
      isEnabled: useEcommerceApi
    }
  } = useFeatureToggle3("ecommerce_get_single_order");
  return useQuery9({
    // eslint-disable-next-line
    queryKey: ["getOrder" /* getOrder */, orderId],
    queryFn: () => __async(this, null, function* () {
      if (!orderId && !orderNumber) {
        throw new Error("Cannot get order without an id or an orderNumber");
      }
      if (useEcommerceApi) {
        const id = orderId || orderNumber;
        const {
          data
        } = yield OrderHttpClient_default.getOrder(id);
        return {
          message: data
        };
      }
      if (orderId) {
        const {
          data
        } = yield LegacyOrderHttpClient_default.getOrder(orderId);
        return data;
      }
      if (orderNumber) {
        const {
          data
        } = yield LegacyOrderHttpClient_default.getOrderByNumber(orderNumber);
        return data;
      }
      throw new Error("Cannot get order without an id or an orderNumber");
    }),
    retry: false,
    enabled: Boolean(orderId)
  });
}

// src/library/components/order/OrderReferenceField.tsx
import React85 from "react";
import { useIntl as useIntl34 } from "react-intl";
var OrderReferenceField = _ref110 => {
  let {
    order,
    disabled = false
  } = _ref110;
  var _a;
  const intl = useIntl34();
  const patchOrderMutation = usePatchOrderMutation({
    context: "orderSetReference" /* orderSetReference */
  });
  return /* @__PURE__ */React85.createElement(DebounceField_default, {
    initialValue: ((_a = order.custom) == null ? void 0 : _a.fields.referenceLabel) || "",
    mutationStatus: patchOrderMutation.status,
    onUpdate: value => patchOrderMutation.mutate({
      orderId: order.id,
      action: {
        name: "setReferenceLabel",
        value
      }
    }),
    name: "reference",
    id: "reference",
    label: intl.formatMessage({
      id: "checkout.label.reference",
      defaultMessage: "Reference/Description"
    }),
    disabled
  });
};
var OrderReferenceField_default = OrderReferenceField;

// src/library/components/order/OrderPoNumberField.tsx
import React86 from "react";
import { useIntl as useIntl35 } from "react-intl";
var OrderPoNumberField = _ref111 => {
  let {
    order,
    disabled = false
  } = _ref111;
  var _a;
  const intl = useIntl35();
  const patchOrderMutation = usePatchOrderMutation({
    context: "orderSetPoNumber" /* orderSetPoNumber */
  });
  return /* @__PURE__ */React86.createElement(DebounceField_default, {
    initialValue: ((_a = order.custom) == null ? void 0 : _a.fields.PONumber) || "",
    mutationStatus: patchOrderMutation.status,
    onUpdate: value => patchOrderMutation.mutate({
      orderId: order.id,
      action: {
        name: "setPurchaseOrderNumber",
        value
      }
    }),
    name: "poNumber",
    id: "poNumber",
    label: intl.formatMessage({
      id: "checkout.label.poNumber",
      defaultMessage: "PO number"
    }),
    disabled
  });
};
var OrderPoNumberField_default = OrderPoNumberField;
export { AddressError_default as AddressError, BillingAddressPanel_default as BillingAddressPanel, CartPoNumberField_default as CartPoNumberField, CartProvider_default as CartProvider, CartQueryMutationKey, CartReferenceField_default as CartReferenceField, CartView_default as CartView, CheckoutStepper_default as CheckoutStepper, CheckoutViewProvider_default as CheckoutViewProvider, DeliveryOptionDescription_default as DeliveryOptionDescription, DeliveryOptionPriceBadge_default as DeliveryOptionPriceBadge, DeliveryView_default as DeliveryView, DiscountSummary_default as DiscountSummary, EditLineItemModal_default as EditLineItemModal, ErrorAlert_default as ErrorAlert, OrderPoNumberField_default as OrderPoNumberField, OrderQueryMutationKey, OrderReferenceField_default as OrderReferenceField, PaymentMethodIconGrid_default as PaymentMethodIconGrid, PaymentMethodView_default as PaymentMethodView, ShippingAddressPanel_default as ShippingAddressPanel, getPickupPointId, getShippingAddressesFromLineItem, useAddLineItemMutation, useAddQuoteToCartMutation, useCart, useEntityTotals, useGetOrderQuery, useGetPickupPointQuery, usePatchCartMutation, usePatchOrderLineItemMutation, usePatchOrderMutation, useReOrderLineItemsMutation, useRemoveLineItemMutation, useUpdateLineItemMutation, useValidateAddress };